//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ControlTowerServiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5001";
    }

    admin_TriggerNightlyPackageBuildStage1(): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Admin/nightlyPackageBuild/stage1";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdmin_TriggerNightlyPackageBuildStage1(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdmin_TriggerNightlyPackageBuildStage1(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processAdmin_TriggerNightlyPackageBuildStage1(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    admin_TriggerNightlyPackageBuildStage2(): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Admin/nightlyPackageBuild/stage2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdmin_TriggerNightlyPackageBuildStage2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdmin_TriggerNightlyPackageBuildStage2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processAdmin_TriggerNightlyPackageBuildStage2(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    admin_TriggerPreviewAutoPublishReconciler(): Observable<string> {
        let url_ = this.baseUrl + "/api/Admin/previewAutoPublish/trigger";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdmin_TriggerPreviewAutoPublishReconciler(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdmin_TriggerPreviewAutoPublishReconciler(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAdmin_TriggerPreviewAutoPublishReconciler(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    admin_TriggerPreviewRepoPublish(): Observable<string> {
        let url_ = this.baseUrl + "/api/Admin/previewRepoPublish/trigger";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdmin_TriggerPreviewRepoPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdmin_TriggerPreviewRepoPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAdmin_TriggerPreviewRepoPublish(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    admin_RecoverPmcSboms(request: PmcSbomRecoveryRequest): Observable<PmcSbomRecoveryResponse> {
        let url_ = this.baseUrl + "/api/Admin/pmc/sboms/recover";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdmin_RecoverPmcSboms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdmin_RecoverPmcSboms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PmcSbomRecoveryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PmcSbomRecoveryResponse>;
        }));
    }

    protected processAdmin_RecoverPmcSboms(response: HttpResponseBase): Observable<PmcSbomRecoveryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PmcSbomRecoveryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    admin_ScheduleRecurringJob(jobId: string, request: RecurringJobScheduleRequest): Observable<RecurringJobStatus> {
        let url_ = this.baseUrl + "/api/Admin/recurringJobs/{jobId}/schedule";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdmin_ScheduleRecurringJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdmin_ScheduleRecurringJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecurringJobStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecurringJobStatus>;
        }));
    }

    protected processAdmin_ScheduleRecurringJob(response: HttpResponseBase): Observable<RecurringJobStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecurringJobStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    admin_UnscheduleRecurringJob(jobId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Admin/recurringJobs/{jobId}/unschedule";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdmin_UnscheduleRecurringJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdmin_UnscheduleRecurringJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdmin_UnscheduleRecurringJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    admin_GetRecurringJobs(): Observable<RecurringJobStatus[]> {
        let url_ = this.baseUrl + "/api/Admin/recurringJobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdmin_GetRecurringJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdmin_GetRecurringJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecurringJobStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecurringJobStatus[]>;
        }));
    }

    protected processAdmin_GetRecurringJobs(response: HttpResponseBase): Observable<RecurringJobStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecurringJobStatus.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    admin_GetRecurringJob(jobId: string): Observable<RecurringJobStatus> {
        let url_ = this.baseUrl + "/api/Admin/recurringJobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdmin_GetRecurringJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdmin_GetRecurringJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecurringJobStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecurringJobStatus>;
        }));
    }

    protected processAdmin_GetRecurringJob(response: HttpResponseBase): Observable<RecurringJobStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecurringJobStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    admin_BackfillPmcPackageIds(request: BackfillPmcPackageIdsRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Admin/pmcPackageIds/backfill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdmin_BackfillPmcPackageIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdmin_BackfillPmcPackageIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processAdmin_BackfillPmcPackageIds(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    admin_TriggerPmcPreviewPublishNoSrpm(request: PmcPreviewPublishNoSrpmRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Admin/pmcPreviewPublish/nosrpm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdmin_TriggerPmcPreviewPublishNoSrpm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdmin_TriggerPmcPreviewPublishNoSrpm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processAdmin_TriggerPmcPreviewPublishNoSrpm(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetSymbolPreparation(componentId: string): Observable<SymbolPreparationRecord> {
        let url_ = this.baseUrl + "/api/Artifacts/components/{componentId}/symbols";
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetSymbolPreparation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetSymbolPreparation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SymbolPreparationRecord>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SymbolPreparationRecord>;
        }));
    }

    protected processArtifacts_GetSymbolPreparation(response: HttpResponseBase): Observable<SymbolPreparationRecord> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SymbolPreparationRecord.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_DownloadSymbolArtifact(componentId: string, kind: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Artifacts/components/{componentId}/symbols/artifacts/{kind}";
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        if (kind === undefined || kind === null)
            throw new globalThis.Error("The parameter 'kind' must be defined.");
        url_ = url_.replace("{kind}", encodeURIComponent("" + kind));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_DownloadSymbolArtifact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_DownloadSymbolArtifact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processArtifacts_DownloadSymbolArtifact(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetMyComponents(scope?: ArtifactScope | undefined, result?: ComponentResult | null | undefined, version?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Observable<PagedResultOfComponentBuildDto> {
        let url_ = this.baseUrl + "/api/Artifacts/components/mine?";
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (result !== undefined && result !== null)
            url_ += "result=" + encodeURIComponent("" + result) + "&";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetMyComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetMyComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfComponentBuildDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfComponentBuildDto>;
        }));
    }

    protected processArtifacts_GetMyComponents(response: HttpResponseBase): Observable<PagedResultOfComponentBuildDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfComponentBuildDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetComponents(scope?: ArtifactScope | undefined, search?: string | null | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Observable<PagedResultOfComponentSummaryDto> {
        let url_ = this.baseUrl + "/api/Artifacts/components?";
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfComponentSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfComponentSummaryDto>;
        }));
    }

    protected processArtifacts_GetComponents(response: HttpResponseBase): Observable<PagedResultOfComponentSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfComponentSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetImageArtifacts(scope?: ArtifactScope | undefined, search?: string | null | undefined, exactImageName?: string | null | undefined, imageFormat?: string | null | undefined, architecture?: Architecture | null | undefined, signedOnly?: boolean | undefined, page?: number | undefined, pageSize?: number | undefined): Observable<PagedResultOfImageArtifactDto> {
        let url_ = this.baseUrl + "/api/Artifacts/image-artifacts?";
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (exactImageName !== undefined && exactImageName !== null)
            url_ += "exactImageName=" + encodeURIComponent("" + exactImageName) + "&";
        if (imageFormat !== undefined && imageFormat !== null)
            url_ += "imageFormat=" + encodeURIComponent("" + imageFormat) + "&";
        if (architecture !== undefined && architecture !== null)
            url_ += "architecture=" + encodeURIComponent("" + architecture) + "&";
        if (signedOnly === null)
            throw new globalThis.Error("The parameter 'signedOnly' cannot be null.");
        else if (signedOnly !== undefined)
            url_ += "signedOnly=" + encodeURIComponent("" + signedOnly) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetImageArtifacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetImageArtifacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfImageArtifactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfImageArtifactDto>;
        }));
    }

    protected processArtifacts_GetImageArtifacts(response: HttpResponseBase): Observable<PagedResultOfImageArtifactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfImageArtifactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetValidationRuns(releaseId?: string | null | undefined, imageId?: string | null | undefined, workflowJobId?: string | null | undefined): Observable<ValidationRunSummaryDto[]> {
        let url_ = this.baseUrl + "/api/Artifacts/validation-runs?";
        if (releaseId !== undefined && releaseId !== null)
            url_ += "releaseId=" + encodeURIComponent("" + releaseId) + "&";
        if (imageId !== undefined && imageId !== null)
            url_ += "imageId=" + encodeURIComponent("" + imageId) + "&";
        if (workflowJobId !== undefined && workflowJobId !== null)
            url_ += "workflowJobId=" + encodeURIComponent("" + workflowJobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetValidationRuns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetValidationRuns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidationRunSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidationRunSummaryDto[]>;
        }));
    }

    protected processArtifacts_GetValidationRuns(response: HttpResponseBase): Observable<ValidationRunSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ValidationRunSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetComponentBuilds(name: string, scope?: ArtifactScope | undefined, result?: ComponentResult | null | undefined, version?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Observable<PagedResultOfComponentBuildDto> {
        let url_ = this.baseUrl + "/api/Artifacts/components/{name}/builds?";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (result !== undefined && result !== null)
            url_ += "result=" + encodeURIComponent("" + result) + "&";
        if (version !== undefined && version !== null)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetComponentBuilds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetComponentBuilds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfComponentBuildDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfComponentBuildDto>;
        }));
    }

    protected processArtifacts_GetComponentBuilds(response: HttpResponseBase): Observable<PagedResultOfComponentBuildDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfComponentBuildDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetProdPromotableComponents(): Observable<ComponentNvrDto[]> {
        let url_ = this.baseUrl + "/api/Artifacts/components/promotable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetProdPromotableComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetProdPromotableComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentNvrDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentNvrDto[]>;
        }));
    }

    protected processArtifacts_GetProdPromotableComponents(response: HttpResponseBase): Observable<ComponentNvrDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentNvrDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetPreviewPublishableComponents(): Observable<ComponentNvrDto[]> {
        let url_ = this.baseUrl + "/api/Artifacts/components/preview-publishable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetPreviewPublishableComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetPreviewPublishableComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentNvrDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentNvrDto[]>;
        }));
    }

    protected processArtifacts_GetPreviewPublishableComponents(response: HttpResponseBase): Observable<ComponentNvrDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentNvrDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetComponentNvrs(name: string, officialOnly?: boolean | undefined): Observable<ComponentNvrDto[]> {
        let url_ = this.baseUrl + "/api/Artifacts/components/{name}/nvrs?";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (officialOnly === null)
            throw new globalThis.Error("The parameter 'officialOnly' cannot be null.");
        else if (officialOnly !== undefined)
            url_ += "officialOnly=" + encodeURIComponent("" + officialOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetComponentNvrs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetComponentNvrs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentNvrDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentNvrDto[]>;
        }));
    }

    protected processArtifacts_GetComponentNvrs(response: HttpResponseBase): Observable<ComponentNvrDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentNvrDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetComponentsByWorkflowJob(id: string, excludeSkipped?: boolean | undefined): Observable<ComponentNvrDto[]> {
        let url_ = this.baseUrl + "/api/Artifacts/workflow-jobs/{id}/components?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (excludeSkipped === null)
            throw new globalThis.Error("The parameter 'excludeSkipped' cannot be null.");
        else if (excludeSkipped !== undefined)
            url_ += "excludeSkipped=" + encodeURIComponent("" + excludeSkipped) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetComponentsByWorkflowJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetComponentsByWorkflowJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentNvrDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentNvrDto[]>;
        }));
    }

    protected processArtifacts_GetComponentsByWorkflowJob(response: HttpResponseBase): Observable<ComponentNvrDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComponentNvrDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetComponentBuildStats(name: string, scope?: ArtifactScope | undefined): Observable<ComponentBuildStatsDto> {
        let url_ = this.baseUrl + "/api/Artifacts/components/{name}/stats?";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetComponentBuildStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetComponentBuildStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentBuildStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentBuildStatsDto>;
        }));
    }

    protected processArtifacts_GetComponentBuildStats(response: HttpResponseBase): Observable<ComponentBuildStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentBuildStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetComponentPmcVersions(name: string): Observable<ComponentPmcVersionsDto> {
        let url_ = this.baseUrl + "/api/Artifacts/components/{name}/pmc-versions";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetComponentPmcVersions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetComponentPmcVersions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentPmcVersionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentPmcVersionsDto>;
        }));
    }

    protected processArtifacts_GetComponentPmcVersions(response: HttpResponseBase): Observable<ComponentPmcVersionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentPmcVersionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetComponentDetail(id: string): Observable<ComponentBuildDetailDto> {
        let url_ = this.baseUrl + "/api/Artifacts/components/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetComponentDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetComponentDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComponentBuildDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComponentBuildDetailDto>;
        }));
    }

    protected processArtifacts_GetComponentDetail(response: HttpResponseBase): Observable<ComponentBuildDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComponentBuildDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_SignComponent(id: string, deleteExistingSignatures?: boolean | undefined): Observable<TriggerSigningResponse> {
        let url_ = this.baseUrl + "/api/Artifacts/components/{id}/sign?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (deleteExistingSignatures === null)
            throw new globalThis.Error("The parameter 'deleteExistingSignatures' cannot be null.");
        else if (deleteExistingSignatures !== undefined)
            url_ += "deleteExistingSignatures=" + encodeURIComponent("" + deleteExistingSignatures) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_SignComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_SignComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TriggerSigningResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TriggerSigningResponse>;
        }));
    }

    protected processArtifacts_SignComponent(response: HttpResponseBase): Observable<TriggerSigningResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = TriggerSigningResponse.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_RefreshTagSigningStatus(tag: string): Observable<RefreshSigningStatusResponse> {
        let url_ = this.baseUrl + "/api/Artifacts/tags/{tag}/refresh-signing-status";
        if (tag === undefined || tag === null)
            throw new globalThis.Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_RefreshTagSigningStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_RefreshTagSigningStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshSigningStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshSigningStatusResponse>;
        }));
    }

    protected processArtifacts_RefreshTagSigningStatus(response: HttpResponseBase): Observable<RefreshSigningStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = RefreshSigningStatusResponse.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_ReportUnsignedInTag(tag: string): Observable<ListUnsignedInTagResponse> {
        let url_ = this.baseUrl + "/api/Artifacts/tags/{tag}/unsigned-report";
        if (tag === undefined || tag === null)
            throw new globalThis.Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_ReportUnsignedInTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_ReportUnsignedInTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListUnsignedInTagResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListUnsignedInTagResponse>;
        }));
    }

    protected processArtifacts_ReportUnsignedInTag(response: HttpResponseBase): Observable<ListUnsignedInTagResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = ListUnsignedInTagResponse.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_BackfillComponentRecords(maxComponents?: number | null | undefined, preview?: boolean | undefined, live?: boolean | undefined): Observable<BackfillComponentRecordsResponse> {
        let url_ = this.baseUrl + "/api/Artifacts/components/backfill-records?";
        if (maxComponents !== undefined && maxComponents !== null)
            url_ += "maxComponents=" + encodeURIComponent("" + maxComponents) + "&";
        if (preview === null)
            throw new globalThis.Error("The parameter 'preview' cannot be null.");
        else if (preview !== undefined)
            url_ += "preview=" + encodeURIComponent("" + preview) + "&";
        if (live === null)
            throw new globalThis.Error("The parameter 'live' cannot be null.");
        else if (live !== undefined)
            url_ += "live=" + encodeURIComponent("" + live) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_BackfillComponentRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_BackfillComponentRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackfillComponentRecordsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackfillComponentRecordsResponse>;
        }));
    }

    protected processArtifacts_BackfillComponentRecords(response: HttpResponseBase): Observable<BackfillComponentRecordsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BackfillComponentRecordsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = BackfillComponentRecordsResponse.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_BackfillComponentRecordsById(componentId: string): Observable<BackfillComponentRecordsResponse> {
        let url_ = this.baseUrl + "/api/Artifacts/components/{componentId}/backfill-records";
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_BackfillComponentRecordsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_BackfillComponentRecordsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackfillComponentRecordsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackfillComponentRecordsResponse>;
        }));
    }

    protected processArtifacts_BackfillComponentRecordsById(response: HttpResponseBase): Observable<BackfillComponentRecordsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = BackfillComponentRecordsResponse.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetPromotableContainerImages(): Observable<PromotableContainerImageDto[]> {
        let url_ = this.baseUrl + "/api/Artifacts/images/containers/promotable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetPromotableContainerImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetPromotableContainerImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotableContainerImageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotableContainerImageDto[]>;
        }));
    }

    protected processArtifacts_GetPromotableContainerImages(response: HttpResponseBase): Observable<PromotableContainerImageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromotableContainerImageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetImages(scope?: ArtifactScope | undefined, search?: string | null | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Observable<PagedResultOfImageSummaryDto> {
        let url_ = this.baseUrl + "/api/Artifacts/images?";
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfImageSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfImageSummaryDto>;
        }));
    }

    protected processArtifacts_GetImages(response: HttpResponseBase): Observable<PagedResultOfImageSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfImageSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetOfficialImages(search?: string | null | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Observable<PagedResultOfImageSummaryDto> {
        let url_ = this.baseUrl + "/api/Artifacts/images/official?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetOfficialImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetOfficialImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfImageSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfImageSummaryDto>;
        }));
    }

    protected processArtifacts_GetOfficialImages(response: HttpResponseBase): Observable<PagedResultOfImageSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfImageSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetImageBuilds(name: string, scope?: ArtifactScope | undefined, result?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Observable<PagedResultOfImageBuildDto> {
        let url_ = this.baseUrl + "/api/Artifacts/images/{name}/builds?";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (result !== undefined && result !== null)
            url_ += "result=" + encodeURIComponent("" + result) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetImageBuilds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetImageBuilds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfImageBuildDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfImageBuildDto>;
        }));
    }

    protected processArtifacts_GetImageBuilds(response: HttpResponseBase): Observable<PagedResultOfImageBuildDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfImageBuildDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetImageLatestPublished(name: string): Observable<ImageLatestPublishedDto> {
        let url_ = this.baseUrl + "/api/Artifacts/images/{name}/latest-published";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetImageLatestPublished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetImageLatestPublished(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageLatestPublishedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageLatestPublishedDto>;
        }));
    }

    protected processArtifacts_GetImageLatestPublished(response: HttpResponseBase): Observable<ImageLatestPublishedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageLatestPublishedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetMyImages(scope?: ArtifactScope | undefined, result?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Observable<PagedResultOfImageBuildDto> {
        let url_ = this.baseUrl + "/api/Artifacts/images/mine?";
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (result !== undefined && result !== null)
            url_ += "result=" + encodeURIComponent("" + result) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetMyImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetMyImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfImageBuildDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfImageBuildDto>;
        }));
    }

    protected processArtifacts_GetMyImages(response: HttpResponseBase): Observable<PagedResultOfImageBuildDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfImageBuildDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetImageBuildStats(name: string, scope?: ArtifactScope | undefined): Observable<ImageBuildStatsDto> {
        let url_ = this.baseUrl + "/api/Artifacts/images/{name}/stats?";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetImageBuildStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetImageBuildStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageBuildStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageBuildStatsDto>;
        }));
    }

    protected processArtifacts_GetImageBuildStats(response: HttpResponseBase): Observable<ImageBuildStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageBuildStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetImageDetail(id: string): Observable<ImageBuildDetailDto> {
        let url_ = this.baseUrl + "/api/Artifacts/images/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetImageDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetImageDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageBuildDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageBuildDetailDto>;
        }));
    }

    protected processArtifacts_GetImageDetail(response: HttpResponseBase): Observable<ImageBuildDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageBuildDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetImagePublishPreview(id: string): Observable<StagingImagePublishPreviewDto> {
        let url_ = this.baseUrl + "/api/Artifacts/images/{id}/publish-preview";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetImagePublishPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetImagePublishPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StagingImagePublishPreviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StagingImagePublishPreviewDto>;
        }));
    }

    protected processArtifacts_GetImagePublishPreview(response: HttpResponseBase): Observable<StagingImagePublishPreviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StagingImagePublishPreviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetOnePGalleryPublishOptions(): Observable<OnePGalleryPublishOptionsDto> {
        let url_ = this.baseUrl + "/api/Artifacts/one-p-gallery-publish-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetOnePGalleryPublishOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetOnePGalleryPublishOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePGalleryPublishOptionsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePGalleryPublishOptionsDto>;
        }));
    }

    protected processArtifacts_GetOnePGalleryPublishOptions(response: HttpResponseBase): Observable<OnePGalleryPublishOptionsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnePGalleryPublishOptionsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_CheckOnePGalleryPublish(imageIds?: string[] | undefined): Observable<OnePGalleryImageCheckDto[]> {
        let url_ = this.baseUrl + "/api/Artifacts/one-p-gallery-publish-check?";
        if (imageIds === null)
            throw new globalThis.Error("The parameter 'imageIds' cannot be null.");
        else if (imageIds !== undefined)
            imageIds && imageIds.forEach(item => { url_ += "imageIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_CheckOnePGalleryPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_CheckOnePGalleryPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnePGalleryImageCheckDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnePGalleryImageCheckDto[]>;
        }));
    }

    protected processArtifacts_CheckOnePGalleryPublish(response: HttpResponseBase): Observable<OnePGalleryImageCheckDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnePGalleryImageCheckDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    artifacts_GetWorkflowJobArtifactSummary(id: string): Observable<WorkflowJobArtifactSummaryDto> {
        let url_ = this.baseUrl + "/api/Artifacts/workflow-jobs/{id}/artifact-summary";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArtifacts_GetWorkflowJobArtifactSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArtifacts_GetWorkflowJobArtifactSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobArtifactSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobArtifactSummaryDto>;
        }));
    }

    protected processArtifacts_GetWorkflowJobArtifactSummary(response: HttpResponseBase): Observable<WorkflowJobArtifactSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobArtifactSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    metrics_GetBuildDashboard(startDate?: Date | undefined, endDate?: Date | undefined, packageName?: string | null | undefined): Observable<BuildDashboardMetricsDto> {
        let url_ = this.baseUrl + "/api/Metrics/build-dashboard?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (packageName !== undefined && packageName !== null)
            url_ += "packageName=" + encodeURIComponent("" + packageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetrics_GetBuildDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetrics_GetBuildDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildDashboardMetricsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildDashboardMetricsDto>;
        }));
    }

    protected processMetrics_GetBuildDashboard(response: HttpResponseBase): Observable<BuildDashboardMetricsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BuildDashboardMetricsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    metrics_Get(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Metrics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetrics_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetrics_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processMetrics_Get(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    metrics_GetDiagnostics(): Observable<BuildInfoDto> {
        let url_ = this.baseUrl + "/api/Metrics/diagnostics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMetrics_GetDiagnostics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMetrics_GetDiagnostics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildInfoDto>;
        }));
    }

    protected processMetrics_GetDiagnostics(response: HttpResponseBase): Observable<BuildInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BuildInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    officialScenario_PublishSymbols(request: PublishSymbolsRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/official/symbols/publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfficialScenario_PublishSymbols(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfficialScenario_PublishSymbols(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processOfficialScenario_PublishSymbols(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = WorkflowJobStatusDto.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    officialScenario_ExecuteOfficialPackageBuild(request: OfficialPackageBuildRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/official/packages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfficialScenario_ExecuteOfficialPackageBuild(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfficialScenario_ExecuteOfficialPackageBuild(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processOfficialScenario_ExecuteOfficialPackageBuild(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    officialScenario_ExecuteOfficialBuildImage(request: OfficialBuildImageRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/official/buildimage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfficialScenario_ExecuteOfficialBuildImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfficialScenario_ExecuteOfficialBuildImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processOfficialScenario_ExecuteOfficialBuildImage(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    officialScenario_ExecuteOfficialPackagePmcPublish(request: OfficialPackagePmcPublishRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/official/packages/pmc/publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfficialScenario_ExecuteOfficialPackagePmcPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfficialScenario_ExecuteOfficialPackagePmcPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processOfficialScenario_ExecuteOfficialPackagePmcPublish(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    officialScenario_ExecutePreviewUploadAndPublish(request: PreviewUploadAndPublishRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/official/packages/pmc/preview/upload-and-publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfficialScenario_ExecutePreviewUploadAndPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfficialScenario_ExecutePreviewUploadAndPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processOfficialScenario_ExecutePreviewUploadAndPublish(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    officialScenario_ExecutePreviewToProdPmcTransfer(request: PreviewToProdPmcTransferRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/official/packages/pmc/preview-to-prod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfficialScenario_ExecutePreviewToProdPmcTransfer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfficialScenario_ExecutePreviewToProdPmcTransfer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processOfficialScenario_ExecutePreviewToProdPmcTransfer(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    officialScenario_ExecutePreviewToProdPmcTransferByAge(request: PreviewToProdPmcTransferByAgeRequest): Observable<PreviewToProdPmcTransferByAgeResponse> {
        let url_ = this.baseUrl + "/api/Scenario/official/packages/pmc/preview-to-prod/by-age";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfficialScenario_ExecutePreviewToProdPmcTransferByAge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfficialScenario_ExecutePreviewToProdPmcTransferByAge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreviewToProdPmcTransferByAgeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreviewToProdPmcTransferByAgeResponse>;
        }));
    }

    protected processOfficialScenario_ExecutePreviewToProdPmcTransferByAge(response: HttpResponseBase): Observable<PreviewToProdPmcTransferByAgeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreviewToProdPmcTransferByAgeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    officialScenario_ExecuteBuildImages(request: BuildImagesRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/official/buildimages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfficialScenario_ExecuteBuildImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfficialScenario_ExecuteBuildImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processOfficialScenario_ExecuteBuildImages(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    officialScenario_ExecutePreviewPublish(request: PreviewPublishRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/official/previewpublish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfficialScenario_ExecutePreviewPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfficialScenario_ExecutePreviewPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processOfficialScenario_ExecutePreviewPublish(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    officialScenario_ExecutePublishImagesToProd(request: PublishImagesToProdRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/official/publishprodimages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOfficialScenario_ExecutePublishImagesToProd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOfficialScenario_ExecutePublishImagesToProd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processOfficialScenario_ExecutePublishImagesToProd(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    promotions_SignOff(request: PromotionActionRequest): Observable<PromotionActionResult[]> {
        let url_ = this.baseUrl + "/api/Promotions/signoff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPromotions_SignOff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromotions_SignOff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionActionResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionActionResult[]>;
        }));
    }

    protected processPromotions_SignOff(response: HttpResponseBase): Observable<PromotionActionResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromotionActionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    promotions_Block(request: PromotionActionRequest): Observable<PromotionActionResult[]> {
        let url_ = this.baseUrl + "/api/Promotions/block";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPromotions_Block(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromotions_Block(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionActionResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionActionResult[]>;
        }));
    }

    protected processPromotions_Block(response: HttpResponseBase): Observable<PromotionActionResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromotionActionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    promotions_Unblock(request: PromotionActionRequest): Observable<PromotionActionResult[]> {
        let url_ = this.baseUrl + "/api/Promotions/unblock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPromotions_Unblock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromotions_Unblock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionActionResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionActionResult[]>;
        }));
    }

    protected processPromotions_Unblock(response: HttpResponseBase): Observable<PromotionActionResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromotionActionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    promotions_GetHistory(componentId: string): Observable<PromotionEventDto[]> {
        let url_ = this.baseUrl + "/api/Promotions/{componentId}/history";
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPromotions_GetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromotions_GetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionEventDto[]>;
        }));
    }

    protected processPromotions_GetHistory(response: HttpResponseBase): Observable<PromotionEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromotionEventDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    publishSchedules_GetPublishSchedules(): Observable<PublishScheduleDto[]> {
        let url_ = this.baseUrl + "/api/publish-schedules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishSchedules_GetPublishSchedules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishSchedules_GetPublishSchedules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublishScheduleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublishScheduleDto[]>;
        }));
    }

    protected processPublishSchedules_GetPublishSchedules(response: HttpResponseBase): Observable<PublishScheduleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublishScheduleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releases_GetReleases(search?: string | null | undefined, owner?: string | null | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined, page?: number | undefined, pageSize?: number | undefined): Observable<PagedResultOfReleaseDto> {
        let url_ = this.baseUrl + "/api/Releases?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (owner !== undefined && owner !== null)
            url_ += "owner=" + encodeURIComponent("" + owner) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleases_GetReleases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleases_GetReleases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfReleaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfReleaseDto>;
        }));
    }

    protected processReleases_GetReleases(response: HttpResponseBase): Observable<PagedResultOfReleaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfReleaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releases_GetRelease(id: string): Observable<ReleaseDto> {
        let url_ = this.baseUrl + "/api/Releases/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleases_GetRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleases_GetRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseDto>;
        }));
    }

    protected processReleases_GetRelease(response: HttpResponseBase): Observable<ReleaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releases_PublishPreview(id: string): Observable<ReleaseDto> {
        let url_ = this.baseUrl + "/api/Releases/{id}/publish-preview";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleases_PublishPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleases_PublishPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseDto>;
        }));
    }

    protected processReleases_PublishPreview(response: HttpResponseBase): Observable<ReleaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releases_Validate(id: string): Observable<ReleaseDto> {
        let url_ = this.baseUrl + "/api/Releases/{id}/validate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleases_Validate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleases_Validate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseDto>;
        }));
    }

    protected processReleases_Validate(response: HttpResponseBase): Observable<ReleaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releases_PublishProd(id: string): Observable<ReleaseDto> {
        let url_ = this.baseUrl + "/api/Releases/{id}/publish-prod";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleases_PublishProd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleases_PublishProd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReleaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReleaseDto>;
        }));
    }

    protected processReleases_PublishProd(response: HttpResponseBase): Observable<ReleaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReleaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    results_GetKojiResultsForJob(jobId: string): Observable<WorkflowJobKojiResultsDto> {
        let url_ = this.baseUrl + "/api/Results/jobs/{jobId}/koji";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResults_GetKojiResultsForJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResults_GetKojiResultsForJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobKojiResultsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobKojiResultsDto>;
        }));
    }

    protected processResults_GetKojiResultsForJob(response: HttpResponseBase): Observable<WorkflowJobKojiResultsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobKojiResultsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    results_GetKojiPackageResultsForJob(jobId: string): Observable<WorkflowJobKojiPackageResultsDto> {
        let url_ = this.baseUrl + "/api/Results/jobs/{jobId}/koji/packages";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResults_GetKojiPackageResultsForJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResults_GetKojiPackageResultsForJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobKojiPackageResultsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobKojiPackageResultsDto>;
        }));
    }

    protected processResults_GetKojiPackageResultsForJob(response: HttpResponseBase): Observable<WorkflowJobKojiPackageResultsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobKojiPackageResultsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    results_GetKojiImageResultsForJob(jobId: string): Observable<WorkflowJobKojiImageResultsDto> {
        let url_ = this.baseUrl + "/api/Results/jobs/{jobId}/koji/images";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResults_GetKojiImageResultsForJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResults_GetKojiImageResultsForJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobKojiImageResultsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobKojiImageResultsDto>;
        }));
    }

    protected processResults_GetKojiImageResultsForJob(response: HttpResponseBase): Observable<WorkflowJobKojiImageResultsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobKojiImageResultsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    results_GetKojiDistRepoResultsForJob(jobId: string): Observable<WorkflowJobKojiDistRepoResultsDto> {
        let url_ = this.baseUrl + "/api/Results/jobs/{jobId}/koji/dist-repos";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResults_GetKojiDistRepoResultsForJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResults_GetKojiDistRepoResultsForJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobKojiDistRepoResultsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobKojiDistRepoResultsDto>;
        }));
    }

    protected processResults_GetKojiDistRepoResultsForJob(response: HttpResponseBase): Observable<WorkflowJobKojiDistRepoResultsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobKojiDistRepoResultsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    results_GetKojiStatisticsForJob(jobId: string): Observable<KojiJobStatisticsDto> {
        let url_ = this.baseUrl + "/api/Results/jobs/{jobId}/koji/statistics";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResults_GetKojiStatisticsForJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResults_GetKojiStatisticsForJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KojiJobStatisticsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KojiJobStatisticsDto>;
        }));
    }

    protected processResults_GetKojiStatisticsForJob(response: HttpResponseBase): Observable<KojiJobStatisticsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KojiJobStatisticsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    results_CancelWorkflow(workflowId: string): Observable<KojiWorkflowCancellationResultDto> {
        let url_ = this.baseUrl + "/api/Results/workflows/{workflowId}/cancel";
        if (workflowId === undefined || workflowId === null)
            throw new globalThis.Error("The parameter 'workflowId' must be defined.");
        url_ = url_.replace("{workflowId}", encodeURIComponent("" + workflowId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResults_CancelWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResults_CancelWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KojiWorkflowCancellationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KojiWorkflowCancellationResultDto>;
        }));
    }

    protected processResults_CancelWorkflow(response: HttpResponseBase): Observable<KojiWorkflowCancellationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KojiWorkflowCancellationResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_ExecutePrCheck(request: PrCheckRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/prcheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_ExecutePrCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_ExecutePrCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_ExecutePrCheck(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_ExecuteBuildBranch(request: BuildBranchRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/buildbranch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_ExecuteBuildBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_ExecuteBuildBranch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_ExecuteBuildBranch(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_ExecuteBuildImage(request: BuildImageRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/buildimage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_ExecuteBuildImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_ExecuteBuildImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_ExecuteBuildImage(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_ExecuteCustomImageBuild(request: CustomImageBuildRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/customimage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_ExecuteCustomImageBuild(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_ExecuteCustomImageBuild(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_ExecuteCustomImageBuild(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_ExecutePackageBuild(request: PackageBuildRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/packages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_ExecutePackageBuild(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_ExecutePackageBuild(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_ExecutePackageBuild(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_PublishComponents(request: PublishComponentsRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/publish/packages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_PublishComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_PublishComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_PublishComponents(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_ExecuteAllowlistPackages(request: AllowlistPackagesRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/allowlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_ExecuteAllowlistPackages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_ExecuteAllowlistPackages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_ExecuteAllowlistPackages(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_ExecuteRepoRegeneration(request: RegenerateRepoRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/regenrepo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_ExecuteRepoRegeneration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_ExecuteRepoRegeneration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_ExecuteRepoRegeneration(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_RebuildComponent(componentId: string): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/rebuild/{componentId}";
        if (componentId === undefined || componentId === null)
            throw new globalThis.Error("The parameter 'componentId' must be defined.");
        url_ = url_.replace("{componentId}", encodeURIComponent("" + componentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_RebuildComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_RebuildComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_RebuildComponent(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_RebuildImage(imageId: string): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/rebuild/image/{imageId}";
        if (imageId === undefined || imageId === null)
            throw new globalThis.Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_RebuildImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_RebuildImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_RebuildImage(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_ExecutePublishMarketplaceImages(request: PublishMarketplaceImageJobRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/publishmarketplaceimages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_ExecutePublishMarketplaceImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_ExecutePublishMarketplaceImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_ExecutePublishMarketplaceImages(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_RunImageFundamentals(request: RunImageFundamentalsRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/imageFundamentals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_RunImageFundamentals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_RunImageFundamentals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_RunImageFundamentals(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_UploadStagingImage(request: UploadStagingImageRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/uploadStagingImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_UploadStagingImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_UploadStagingImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_UploadStagingImage(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_ResumeEsrpRelease(request: EsrpReleaseResumeRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/esrp/resume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_ResumeEsrpRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_ResumeEsrpRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_ResumeEsrpRelease(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_ExecuteContainerPublish(request: ContainerPublishRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/containerpublish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_ExecuteContainerPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_ExecuteContainerPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_ExecuteContainerPublish(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    scenario_ExecuteCustomImageValidation(request: CustomImageValidationPlanRequest): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Scenario/custom-image-validation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScenario_ExecuteCustomImageValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScenario_ExecuteCustomImageValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processScenario_ExecuteCustomImageValidation(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 503) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    test_StressQueue(queueName: string, count?: number | undefined, processingTimeSeconds?: number | undefined): Observable<StressTestResult> {
        let url_ = this.baseUrl + "/api/Test/stress/{queueName}?";
        if (queueName === undefined || queueName === null)
            throw new globalThis.Error("The parameter 'queueName' must be defined.");
        url_ = url_.replace("{queueName}", encodeURIComponent("" + queueName));
        if (count === null)
            throw new globalThis.Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (processingTimeSeconds === null)
            throw new globalThis.Error("The parameter 'processingTimeSeconds' cannot be null.");
        else if (processingTimeSeconds !== undefined)
            url_ += "processingTimeSeconds=" + encodeURIComponent("" + processingTimeSeconds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest_StressQueue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest_StressQueue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StressTestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StressTestResult>;
        }));
    }

    protected processTest_StressQueue(response: HttpResponseBase): Observable<StressTestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StressTestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    test_StressAllQueues(countPerQueue?: number | undefined, processingTimeSeconds?: number | undefined): Observable<{ [key: string]: StressTestResult; }> {
        let url_ = this.baseUrl + "/api/Test/stress/all?";
        if (countPerQueue === null)
            throw new globalThis.Error("The parameter 'countPerQueue' cannot be null.");
        else if (countPerQueue !== undefined)
            url_ += "countPerQueue=" + encodeURIComponent("" + countPerQueue) + "&";
        if (processingTimeSeconds === null)
            throw new globalThis.Error("The parameter 'processingTimeSeconds' cannot be null.");
        else if (processingTimeSeconds !== undefined)
            url_ += "processingTimeSeconds=" + encodeURIComponent("" + processingTimeSeconds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest_StressAllQueues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest_StressAllQueues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: StressTestResult; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: StressTestResult; }>;
        }));
    }

    protected processTest_StressAllQueues(response: HttpResponseBase): Observable<{ [key: string]: StressTestResult; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] ? StressTestResult.fromJS(resultData200[key]) : new StressTestResult();
                }
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    test_GetQueueStats(): Observable<{ [key: string]: QueueStats; }> {
        let url_ = this.baseUrl + "/api/Test/queue-stats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest_GetQueueStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest_GetQueueStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: QueueStats; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: QueueStats; }>;
        }));
    }

    protected processTest_GetQueueStats(response: HttpResponseBase): Observable<{ [key: string]: QueueStats; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] ? QueueStats.fromJS(resultData200[key]) : new QueueStats();
                }
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    test_GetHealth(): Observable<any> {
        let url_ = this.baseUrl + "/api/Test/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest_GetHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest_GetHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processTest_GetHealth(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GetAllWorkflowPlans(): Observable<WorkflowPlanDto[]> {
        let url_ = this.baseUrl + "/api/Workflow/plans";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GetAllWorkflowPlans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GetAllWorkflowPlans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowPlanDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowPlanDto[]>;
        }));
    }

    protected processWorkflow_GetAllWorkflowPlans(response: HttpResponseBase): Observable<WorkflowPlanDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkflowPlanDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GetWorkflowPlan(planId: string): Observable<WorkflowPlanDto> {
        let url_ = this.baseUrl + "/api/Workflow/plans/{planId}";
        if (planId === undefined || planId === null)
            throw new globalThis.Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GetWorkflowPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GetWorkflowPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowPlanDto>;
        }));
    }

    protected processWorkflow_GetWorkflowPlan(response: HttpResponseBase): Observable<WorkflowPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GenerateFullBuild(request: FullBuildPlanRequest): Observable<WorkflowPlanDto> {
        let url_ = this.baseUrl + "/api/Workflow/generate/full";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GenerateFullBuild(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GenerateFullBuild(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowPlanDto>;
        }));
    }

    protected processWorkflow_GenerateFullBuild(response: HttpResponseBase): Observable<WorkflowPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GenerateImageFundamentals(request: ImageFundamentalsPlanRequest): Observable<WorkflowPlanDto> {
        let url_ = this.baseUrl + "/api/Workflow/generate/imagefundamentals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GenerateImageFundamentals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GenerateImageFundamentals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowPlanDto>;
        }));
    }

    protected processWorkflow_GenerateImageFundamentals(response: HttpResponseBase): Observable<WorkflowPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GenerateTargetPlan(request: TargetPlanRequest): Observable<WorkflowPlanDto> {
        let url_ = this.baseUrl + "/api/Workflow/generate/target";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GenerateTargetPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GenerateTargetPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowPlanDto>;
        }));
    }

    protected processWorkflow_GenerateTargetPlan(response: HttpResponseBase): Observable<WorkflowPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GenerateAllTargetsPlan(request: AllTargetsPlanRequest): Observable<WorkflowPlanDto> {
        let url_ = this.baseUrl + "/api/Workflow/generate/all-targets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GenerateAllTargetsPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GenerateAllTargetsPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowPlanDto>;
        }));
    }

    protected processWorkflow_GenerateAllTargetsPlan(response: HttpResponseBase): Observable<WorkflowPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GenerateDistRepoPlan(request: DistRepoPlanRequest): Observable<WorkflowPlanDto> {
        let url_ = this.baseUrl + "/api/Workflow/generate/dist-repo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GenerateDistRepoPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GenerateDistRepoPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowPlanDto>;
        }));
    }

    protected processWorkflow_GenerateDistRepoPlan(response: HttpResponseBase): Observable<WorkflowPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GenerateContainerUploadPlan(request: ContainerUploadPlanRequest): Observable<WorkflowPlanDto> {
        let url_ = this.baseUrl + "/api/Workflow/generate/container-upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GenerateContainerUploadPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GenerateContainerUploadPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowPlanDto>;
        }));
    }

    protected processWorkflow_GenerateContainerUploadPlan(response: HttpResponseBase): Observable<WorkflowPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GeneratePublishImagesToProdPlan(request: PublishImagesToProdPlanRequest): Observable<WorkflowPlanDto> {
        let url_ = this.baseUrl + "/api/Workflow/generate/publishprodimages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GeneratePublishImagesToProdPlan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GeneratePublishImagesToProdPlan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowPlanDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowPlanDto>;
        }));
    }

    protected processWorkflow_GeneratePublishImagesToProdPlan(response: HttpResponseBase): Observable<WorkflowPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_Execute(planId: string): Observable<ExecuteWorkflowResponse> {
        let url_ = this.baseUrl + "/api/Workflow/execute/{planId}";
        if (planId === undefined || planId === null)
            throw new globalThis.Error("The parameter 'planId' must be defined.");
        url_ = url_.replace("{planId}", encodeURIComponent("" + planId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_Execute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_Execute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExecuteWorkflowResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExecuteWorkflowResponse>;
        }));
    }

    protected processWorkflow_Execute(response: HttpResponseBase): Observable<ExecuteWorkflowResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExecuteWorkflowResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GetJobs(includeTasks?: boolean | undefined, includeWorkflowPlan?: boolean | undefined): Observable<WorkflowJobDto[]> {
        let url_ = this.baseUrl + "/api/Workflow/jobs?";
        if (includeTasks === null)
            throw new globalThis.Error("The parameter 'includeTasks' cannot be null.");
        else if (includeTasks !== undefined)
            url_ += "includeTasks=" + encodeURIComponent("" + includeTasks) + "&";
        if (includeWorkflowPlan === null)
            throw new globalThis.Error("The parameter 'includeWorkflowPlan' cannot be null.");
        else if (includeWorkflowPlan !== undefined)
            url_ += "includeWorkflowPlan=" + encodeURIComponent("" + includeWorkflowPlan) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GetJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GetJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobDto[]>;
        }));
    }

    protected processWorkflow_GetJobs(response: HttpResponseBase): Observable<WorkflowJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkflowJobDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GetJobsByUser(userEmail: string, includeTasks?: boolean | undefined): Observable<WorkflowJobDto[]> {
        let url_ = this.baseUrl + "/api/Workflow/jobs/byuser/{userEmail}?";
        if (userEmail === undefined || userEmail === null)
            throw new globalThis.Error("The parameter 'userEmail' must be defined.");
        url_ = url_.replace("{userEmail}", encodeURIComponent("" + userEmail));
        if (includeTasks === null)
            throw new globalThis.Error("The parameter 'includeTasks' cannot be null.");
        else if (includeTasks !== undefined)
            url_ += "includeTasks=" + encodeURIComponent("" + includeTasks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GetJobsByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GetJobsByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobDto[]>;
        }));
    }

    protected processWorkflow_GetJobsByUser(response: HttpResponseBase): Observable<WorkflowJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkflowJobDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GetJobStatus(jobId: string): Observable<WorkflowJobStatusDto> {
        let url_ = this.baseUrl + "/api/Workflow/jobs/status/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GetJobStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GetJobStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobStatusDto>;
        }));
    }

    protected processWorkflow_GetJobStatus(response: HttpResponseBase): Observable<WorkflowJobStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GetJobDetails(jobId: string, includeWorkflowPlan?: boolean | undefined): Observable<WorkflowJobDto> {
        let url_ = this.baseUrl + "/api/Workflow/jobs/details/{jobId}?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (includeWorkflowPlan === null)
            throw new globalThis.Error("The parameter 'includeWorkflowPlan' cannot be null.");
        else if (includeWorkflowPlan !== undefined)
            url_ += "includeWorkflowPlan=" + encodeURIComponent("" + includeWorkflowPlan) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GetJobDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GetJobDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowJobDto>;
        }));
    }

    protected processWorkflow_GetJobDetails(response: HttpResponseBase): Observable<WorkflowJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GetJobValidationRuns(jobId: string): Observable<WorkflowValidationRunsDto> {
        let url_ = this.baseUrl + "/api/Workflow/jobs/{jobId}/validation-runs";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GetJobValidationRuns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GetJobValidationRuns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkflowValidationRunsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkflowValidationRunsDto>;
        }));
    }

    protected processWorkflow_GetJobValidationRuns(response: HttpResponseBase): Observable<WorkflowValidationRunsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkflowValidationRunsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_GetJobLogs(jobId: string, subJobId?: string | null | undefined, level?: JobLogLevel | null | undefined, skip?: number | undefined, take?: number | undefined, descending?: boolean | undefined): Observable<PaginatedLogsResponse> {
        let url_ = this.baseUrl + "/api/Workflow/jobs/{jobId}/logs?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (subJobId !== undefined && subJobId !== null)
            url_ += "subJobId=" + encodeURIComponent("" + subJobId) + "&";
        if (level !== undefined && level !== null)
            url_ += "level=" + encodeURIComponent("" + level) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (descending === null)
            throw new globalThis.Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_GetJobLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_GetJobLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedLogsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedLogsResponse>;
        }));
    }

    protected processWorkflow_GetJobLogs(response: HttpResponseBase): Observable<PaginatedLogsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedLogsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workflow_DownloadJobLogs(jobId: string, subJobId?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/jobs/{jobId}/logs/download?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (subJobId !== undefined && subJobId !== null)
            url_ += "subJobId=" + encodeURIComponent("" + subJobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow_DownloadJobLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow_DownloadJobLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorkflow_DownloadJobLogs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class WorkflowJobStatusDto implements IWorkflowJobStatusDto {
    jobId?: string;
    workflowPlanId?: string;
    status?: string;
    createdAt?: Date;
    updatedAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    errorMessage?: string | undefined;
    tasks?: WorkflowJobTaskStatusDto[];

    constructor(data?: IWorkflowJobStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.workflowPlanId = _data["workflowPlanId"];
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(WorkflowJobTaskStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkflowJobStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowJobStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["workflowPlanId"] = this.workflowPlanId;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkflowJobStatusDto {
    jobId?: string;
    workflowPlanId?: string;
    status?: string;
    createdAt?: Date;
    updatedAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    errorMessage?: string | undefined;
    tasks?: WorkflowJobTaskStatusDto[];
}

export class WorkflowJobTaskStatusDto implements IWorkflowJobTaskStatusDto {
    taskId?: string;
    taskName?: string;
    status?: string;
    createTime?: Date;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    attemptNumber?: number;
    taskType?: TaskType | undefined;
    validationFailureSummary?: string | undefined;

    constructor(data?: IWorkflowJobTaskStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.status = _data["status"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : undefined as any;
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : undefined as any;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : undefined as any;
            this.attemptNumber = _data["attemptNumber"];
            this.taskType = _data["taskType"];
            this.validationFailureSummary = _data["validationFailureSummary"];
        }
    }

    static fromJS(data: any): WorkflowJobTaskStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowJobTaskStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["status"] = this.status;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : undefined as any;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["attemptNumber"] = this.attemptNumber;
        data["taskType"] = this.taskType;
        data["validationFailureSummary"] = this.validationFailureSummary;
        return data;
    }
}

export interface IWorkflowJobTaskStatusDto {
    taskId?: string;
    taskName?: string;
    status?: string;
    createTime?: Date;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    attemptNumber?: number;
    taskType?: TaskType | undefined;
    validationFailureSummary?: string | undefined;
}

export enum TaskType {
    BuildPackage = "BuildPackage",
    BuildImage = "BuildImage",
    ValidatePackage = "ValidatePackage",
    ValidateImage = "ValidateImage",
    ValidateArtifact = "ValidateArtifact",
    SignPackage = "SignPackage",
    SignImage = "SignImage",
    DownloadArtifact = "DownloadArtifact",
    PublishArtifact = "PublishArtifact",
    UploadArtifacts = "UploadArtifacts",
    CreateRepo = "CreateRepo",
    UploadRepo = "UploadRepo",
    PublishRepo = "PublishRepo",
    KojiStatusUpdate = "KojiStatusUpdate",
    TriggerFundamentalsPipeline = "TriggerFundamentalsPipeline",
    MirrorRepo = "MirrorRepo",
    CreateTarget = "CreateTarget",
    CreateDistRepo = "CreateDistRepo",
    PublishChannelRepo = "PublishChannelRepo",
    ChannelMirrorRepo = "ChannelMirrorRepo",
    PublishImage = "PublishImage",
    UploadContainer = "UploadContainer",
    UploadIso = "UploadIso",
    UploadSources = "UploadSources",
    PmcPublish = "PmcPublish",
    PmcChannelPublish = "PmcChannelPublish",
    RemoveFromRepo = "RemoveFromRepo",
    UploadKojiBlobstore = "UploadKojiBlobstore",
    EsrpIsoPublish = "EsrpIsoPublish",
    BlobstoreUploadByImageId = "BlobstoreUploadByImageId",
    TransferContainer = "TransferContainer",
    PublishMarketplaceImage = "PublishMarketplaceImage",
    ScanSources = "ScanSources",
    PublishPackageBlobstore = "PublishPackageBlobstore",
    ContainerUploadByImageId = "ContainerUploadByImageId",
    OfficialPackagePmcPublish = "OfficialPackagePmcPublish",
    BackfillPmcPackageIds = "BackfillPmcPackageIds",
    TriggerSigning = "TriggerSigning",
    ListUnsignedInTag = "ListUnsignedInTag",
    RefreshSigningStatus = "RefreshSigningStatus",
    OciArtifactUploadByImageId = "OciArtifactUploadByImageId",
    PmcPackageTransfer = "PmcPackageTransfer",
    BackfillComponentRecords = "BackfillComponentRecords",
    RecordImageArtifacts = "RecordImageArtifacts",
    AllowlistPackage = "AllowlistPackage",
    RegenerateRepo = "RegenerateRepo",
    RecordRelease = "RecordRelease",
    NotifyImagesBuilt = "NotifyImagesBuilt",
    PublishOnePGalleryImage = "PublishOnePGalleryImage",
    NotifyImagesPreviewPublished = "NotifyImagesPreviewPublished",
    ComponentSignedPmcPublish = "ComponentSignedPmcPublish",
    PmcRepoPublish = "PmcRepoPublish",
    PmcVerifyPublish = "PmcVerifyPublish",
    PublishSymbols = "PublishSymbols",
    PmcSbomPublish = "PmcSbomPublish",
    PrepareSymbols = "PrepareSymbols",
    PreparePublishSymbols = "PreparePublishSymbols",
    UploadPreparedSymbols = "UploadPreparedSymbols",
    PromotePublicSymbols = "PromotePublicSymbols",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class PmcSbomRecoveryResponse implements IPmcSbomRecoveryResponse {
    selectedComponentCount?: number;
    componentNvrs?: string[];
    remainingBackfillCount?: number;
    workflowJob?: WorkflowJobStatusDto | undefined;

    constructor(data?: IPmcSbomRecoveryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedComponentCount = _data["selectedComponentCount"];
            if (Array.isArray(_data["componentNvrs"])) {
                this.componentNvrs = [] as any;
                for (let item of _data["componentNvrs"])
                    this.componentNvrs!.push(item);
            }
            this.remainingBackfillCount = _data["remainingBackfillCount"];
            this.workflowJob = _data["workflowJob"] ? WorkflowJobStatusDto.fromJS(_data["workflowJob"]) : undefined as any;
        }
    }

    static fromJS(data: any): PmcSbomRecoveryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PmcSbomRecoveryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedComponentCount"] = this.selectedComponentCount;
        if (Array.isArray(this.componentNvrs)) {
            data["componentNvrs"] = [];
            for (let item of this.componentNvrs)
                data["componentNvrs"].push(item);
        }
        data["remainingBackfillCount"] = this.remainingBackfillCount;
        data["workflowJob"] = this.workflowJob ? this.workflowJob.toJSON() : undefined as any;
        return data;
    }
}

export interface IPmcSbomRecoveryResponse {
    selectedComponentCount?: number;
    componentNvrs?: string[];
    remainingBackfillCount?: number;
    workflowJob?: WorkflowJobStatusDto | undefined;
}

export class PmcSbomRecoveryRequest implements IPmcSbomRecoveryRequest {
    componentIds?: string[] | undefined;
    count?: number | undefined;

    constructor(data?: IPmcSbomRecoveryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["componentIds"])) {
                this.componentIds = [] as any;
                for (let item of _data["componentIds"])
                    this.componentIds!.push(item);
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): PmcSbomRecoveryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PmcSbomRecoveryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.componentIds)) {
            data["componentIds"] = [];
            for (let item of this.componentIds)
                data["componentIds"].push(item);
        }
        data["count"] = this.count;
        return data;
    }
}

export interface IPmcSbomRecoveryRequest {
    componentIds?: string[] | undefined;
    count?: number | undefined;
}

export class RecurringJobStatus implements IRecurringJobStatus {
    jobId?: string;
    scheduled?: boolean;
    cron?: string | undefined;
    schedulable?: boolean;
    nextExecution?: Date | undefined;
    lastExecution?: Date | undefined;

    constructor(data?: IRecurringJobStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.scheduled = _data["scheduled"];
            this.cron = _data["cron"];
            this.schedulable = _data["schedulable"];
            this.nextExecution = _data["nextExecution"] ? new Date(_data["nextExecution"].toString()) : undefined as any;
            this.lastExecution = _data["lastExecution"] ? new Date(_data["lastExecution"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RecurringJobStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RecurringJobStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["scheduled"] = this.scheduled;
        data["cron"] = this.cron;
        data["schedulable"] = this.schedulable;
        data["nextExecution"] = this.nextExecution ? this.nextExecution.toISOString() : undefined as any;
        data["lastExecution"] = this.lastExecution ? this.lastExecution.toISOString() : undefined as any;
        return data;
    }
}

export interface IRecurringJobStatus {
    jobId?: string;
    scheduled?: boolean;
    cron?: string | undefined;
    schedulable?: boolean;
    nextExecution?: Date | undefined;
    lastExecution?: Date | undefined;
}

export class RecurringJobScheduleRequest implements IRecurringJobScheduleRequest {
    cron!: string;

    constructor(data?: IRecurringJobScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cron = _data["cron"];
        }
    }

    static fromJS(data: any): RecurringJobScheduleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecurringJobScheduleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cron"] = this.cron;
        return data;
    }
}

export interface IRecurringJobScheduleRequest {
    cron: string;
}

export class BackfillPmcPackageIdsRequest implements IBackfillPmcPackageIdsRequest {
    componentIds!: string[];

    constructor(data?: IBackfillPmcPackageIdsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.componentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["componentIds"])) {
                this.componentIds = [] as any;
                for (let item of _data["componentIds"])
                    this.componentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BackfillPmcPackageIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BackfillPmcPackageIdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.componentIds)) {
            data["componentIds"] = [];
            for (let item of this.componentIds)
                data["componentIds"].push(item);
        }
        return data;
    }
}

export interface IBackfillPmcPackageIdsRequest {
    componentIds: string[];
}

export class PmcPreviewPublishNoSrpmRequest implements IPmcPreviewPublishNoSrpmRequest {
    componentIds!: string[];
    simulatePublish?: boolean;

    constructor(data?: IPmcPreviewPublishNoSrpmRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.componentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["componentIds"])) {
                this.componentIds = [] as any;
                for (let item of _data["componentIds"])
                    this.componentIds!.push(item);
            }
            this.simulatePublish = _data["simulatePublish"];
        }
    }

    static fromJS(data: any): PmcPreviewPublishNoSrpmRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PmcPreviewPublishNoSrpmRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.componentIds)) {
            data["componentIds"] = [];
            for (let item of this.componentIds)
                data["componentIds"].push(item);
        }
        data["simulatePublish"] = this.simulatePublish;
        return data;
    }
}

export interface IPmcPreviewPublishNoSrpmRequest {
    componentIds: string[];
    simulatePublish?: boolean;
}

export class SymbolPreparationRecord implements ISymbolPreparationRecord {
    componentId?: string;
    version?: number;
    workflowJobId?: string;
    workflowJobTaskId?: string;
    outcome?: string;
    updatedUtc?: Date;
    reason?: string | undefined;
    bundlePath?: string | undefined;
    manifestPath?: string | undefined;
    bundleSha256?: string | undefined;
    uploadOutcome?: string | undefined;
    uploadRequestName?: string | undefined;
    uploadReason?: string | undefined;
    publicOutcome?: string | undefined;
    publicReason?: string | undefined;

    constructor(data?: ISymbolPreparationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.version = _data["version"];
            this.workflowJobId = _data["workflowJobId"];
            this.workflowJobTaskId = _data["workflowJobTaskId"];
            this.outcome = _data["outcome"];
            this.updatedUtc = _data["updatedUtc"] ? new Date(_data["updatedUtc"].toString()) : undefined as any;
            this.reason = _data["reason"];
            this.bundlePath = _data["bundlePath"];
            this.manifestPath = _data["manifestPath"];
            this.bundleSha256 = _data["bundleSha256"];
            this.uploadOutcome = _data["uploadOutcome"];
            this.uploadRequestName = _data["uploadRequestName"];
            this.uploadReason = _data["uploadReason"];
            this.publicOutcome = _data["publicOutcome"];
            this.publicReason = _data["publicReason"];
        }
    }

    static fromJS(data: any): SymbolPreparationRecord {
        data = typeof data === 'object' ? data : {};
        let result = new SymbolPreparationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["version"] = this.version;
        data["workflowJobId"] = this.workflowJobId;
        data["workflowJobTaskId"] = this.workflowJobTaskId;
        data["outcome"] = this.outcome;
        data["updatedUtc"] = this.updatedUtc ? this.updatedUtc.toISOString() : undefined as any;
        data["reason"] = this.reason;
        data["bundlePath"] = this.bundlePath;
        data["manifestPath"] = this.manifestPath;
        data["bundleSha256"] = this.bundleSha256;
        data["uploadOutcome"] = this.uploadOutcome;
        data["uploadRequestName"] = this.uploadRequestName;
        data["uploadReason"] = this.uploadReason;
        data["publicOutcome"] = this.publicOutcome;
        data["publicReason"] = this.publicReason;
        return data;
    }
}

export interface ISymbolPreparationRecord {
    componentId?: string;
    version?: number;
    workflowJobId?: string;
    workflowJobTaskId?: string;
    outcome?: string;
    updatedUtc?: Date;
    reason?: string | undefined;
    bundlePath?: string | undefined;
    manifestPath?: string | undefined;
    bundleSha256?: string | undefined;
    uploadOutcome?: string | undefined;
    uploadRequestName?: string | undefined;
    uploadReason?: string | undefined;
    publicOutcome?: string | undefined;
    publicReason?: string | undefined;
}

export class PagedResultOfComponentBuildDto implements IPagedResultOfComponentBuildDto {
    items?: ComponentBuildDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    hasMore?: boolean;

    constructor(data?: IPagedResultOfComponentBuildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ComponentBuildDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PagedResultOfComponentBuildDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfComponentBuildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPagedResultOfComponentBuildDto {
    items?: ComponentBuildDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    hasMore?: boolean;
}

export class ComponentBuildDto implements IComponentBuildDto {
    componentId?: string;
    name?: string;
    epoch?: string | undefined;
    version?: string | undefined;
    release?: string | undefined;
    branch?: string | undefined;
    repo?: string | undefined;
    commit?: string | undefined;
    official?: boolean;
    result?: string | undefined;
    inPreview?: boolean;
    inProd?: boolean;
    createDate?: Date;
    requestedBy?: string | undefined;
    workflowJobId?: string;
    kojiTaskId?: number | undefined;
    artifactCount?: number;
    architectures?: string[];

    constructor(data?: IComponentBuildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.name = _data["name"];
            this.epoch = _data["epoch"];
            this.version = _data["version"];
            this.release = _data["release"];
            this.branch = _data["branch"];
            this.repo = _data["repo"];
            this.commit = _data["commit"];
            this.official = _data["official"];
            this.result = _data["result"];
            this.inPreview = _data["inPreview"];
            this.inProd = _data["inProd"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.requestedBy = _data["requestedBy"];
            this.workflowJobId = _data["workflowJobId"];
            this.kojiTaskId = _data["kojiTaskId"];
            this.artifactCount = _data["artifactCount"];
            if (Array.isArray(_data["architectures"])) {
                this.architectures = [] as any;
                for (let item of _data["architectures"])
                    this.architectures!.push(item);
            }
        }
    }

    static fromJS(data: any): ComponentBuildDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentBuildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["name"] = this.name;
        data["epoch"] = this.epoch;
        data["version"] = this.version;
        data["release"] = this.release;
        data["branch"] = this.branch;
        data["repo"] = this.repo;
        data["commit"] = this.commit;
        data["official"] = this.official;
        data["result"] = this.result;
        data["inPreview"] = this.inPreview;
        data["inProd"] = this.inProd;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["requestedBy"] = this.requestedBy;
        data["workflowJobId"] = this.workflowJobId;
        data["kojiTaskId"] = this.kojiTaskId;
        data["artifactCount"] = this.artifactCount;
        if (Array.isArray(this.architectures)) {
            data["architectures"] = [];
            for (let item of this.architectures)
                data["architectures"].push(item);
        }
        return data;
    }
}

export interface IComponentBuildDto {
    componentId?: string;
    name?: string;
    epoch?: string | undefined;
    version?: string | undefined;
    release?: string | undefined;
    branch?: string | undefined;
    repo?: string | undefined;
    commit?: string | undefined;
    official?: boolean;
    result?: string | undefined;
    inPreview?: boolean;
    inProd?: boolean;
    createDate?: Date;
    requestedBy?: string | undefined;
    workflowJobId?: string;
    kojiTaskId?: number | undefined;
    artifactCount?: number;
    architectures?: string[];
}

export enum ArtifactScope {
    All = "All",
    Official = "Official",
    Unofficial = "Unofficial",
}

export enum ComponentResult {
    BuiltUnsigned = "BuiltUnsigned",
    Signed = "Signed",
    Failed = "Failed",
    Skipped = "Skipped",
    Canceled = "Canceled",
}

export class PagedResultOfComponentSummaryDto implements IPagedResultOfComponentSummaryDto {
    items?: ComponentSummaryDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    hasMore?: boolean;

    constructor(data?: IPagedResultOfComponentSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ComponentSummaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PagedResultOfComponentSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfComponentSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPagedResultOfComponentSummaryDto {
    items?: ComponentSummaryDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    hasMore?: boolean;
}

export class ComponentSummaryDto implements IComponentSummaryDto {
    name?: string;
    latestBuildDate?: Date;
    buildCount?: number;
    latestResult?: string | undefined;
    inPreview?: boolean;
    inProd?: boolean;

    constructor(data?: IComponentSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.latestBuildDate = _data["latestBuildDate"] ? new Date(_data["latestBuildDate"].toString()) : undefined as any;
            this.buildCount = _data["buildCount"];
            this.latestResult = _data["latestResult"];
            this.inPreview = _data["inPreview"];
            this.inProd = _data["inProd"];
        }
    }

    static fromJS(data: any): ComponentSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["latestBuildDate"] = this.latestBuildDate ? this.latestBuildDate.toISOString() : undefined as any;
        data["buildCount"] = this.buildCount;
        data["latestResult"] = this.latestResult;
        data["inPreview"] = this.inPreview;
        data["inProd"] = this.inProd;
        return data;
    }
}

export interface IComponentSummaryDto {
    name?: string;
    latestBuildDate?: Date;
    buildCount?: number;
    latestResult?: string | undefined;
    inPreview?: boolean;
    inProd?: boolean;
}

export class PagedResultOfImageArtifactDto implements IPagedResultOfImageArtifactDto {
    items?: ImageArtifactDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    hasMore?: boolean;

    constructor(data?: IPagedResultOfImageArtifactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ImageArtifactDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PagedResultOfImageArtifactDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfImageArtifactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPagedResultOfImageArtifactDto {
    items?: ImageArtifactDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    hasMore?: boolean;
}

export class ImageArtifactDto implements IImageArtifactDto {
    id?: string;
    azlImageName?: string;
    version?: number;
    calculatedVersion?: string;
    imageFormat?: string;
    container?: boolean;
    official?: boolean;
    branch?: string | undefined;
    repo?: string | undefined;
    commit?: string | undefined;
    environment?: string | undefined;
    createDate?: Date;
    result?: string | undefined;
    architectures?: string[];
    signedArchitectures?: string[];

    constructor(data?: IImageArtifactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.azlImageName = _data["azlImageName"];
            this.version = _data["version"];
            this.calculatedVersion = _data["calculatedVersion"];
            this.imageFormat = _data["imageFormat"];
            this.container = _data["container"];
            this.official = _data["official"];
            this.branch = _data["branch"];
            this.repo = _data["repo"];
            this.commit = _data["commit"];
            this.environment = _data["environment"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.result = _data["result"];
            if (Array.isArray(_data["architectures"])) {
                this.architectures = [] as any;
                for (let item of _data["architectures"])
                    this.architectures!.push(item);
            }
            if (Array.isArray(_data["signedArchitectures"])) {
                this.signedArchitectures = [] as any;
                for (let item of _data["signedArchitectures"])
                    this.signedArchitectures!.push(item);
            }
        }
    }

    static fromJS(data: any): ImageArtifactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageArtifactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["azlImageName"] = this.azlImageName;
        data["version"] = this.version;
        data["calculatedVersion"] = this.calculatedVersion;
        data["imageFormat"] = this.imageFormat;
        data["container"] = this.container;
        data["official"] = this.official;
        data["branch"] = this.branch;
        data["repo"] = this.repo;
        data["commit"] = this.commit;
        data["environment"] = this.environment;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["result"] = this.result;
        if (Array.isArray(this.architectures)) {
            data["architectures"] = [];
            for (let item of this.architectures)
                data["architectures"].push(item);
        }
        if (Array.isArray(this.signedArchitectures)) {
            data["signedArchitectures"] = [];
            for (let item of this.signedArchitectures)
                data["signedArchitectures"].push(item);
        }
        return data;
    }
}

export interface IImageArtifactDto {
    id?: string;
    azlImageName?: string;
    version?: number;
    calculatedVersion?: string;
    imageFormat?: string;
    container?: boolean;
    official?: boolean;
    branch?: string | undefined;
    repo?: string | undefined;
    commit?: string | undefined;
    environment?: string | undefined;
    createDate?: Date;
    result?: string | undefined;
    architectures?: string[];
    signedArchitectures?: string[];
}

export enum Architecture {
    X86_64 = "x86_64",
    Aarch64 = "aarch64",
    Noarch = "noarch",
    Src = "src",
}

export class ValidationRunSummaryDto implements IValidationRunSummaryDto {
    runId!: string;
    imageId?: string | undefined;
    imageName!: string;
    imageVersion?: string | undefined;
    runNumber!: number;
    runStatus?: string | undefined;
    submittedAt!: Date;
    completedAt?: Date | undefined;
    workflowJobId?: string | undefined;
    isLegacy!: boolean;
    failureSummary?: string | undefined;

    constructor(data?: IValidationRunSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runId = _data["runId"];
            this.imageId = _data["imageId"];
            this.imageName = _data["imageName"];
            this.imageVersion = _data["imageVersion"];
            this.runNumber = _data["runNumber"];
            this.runStatus = _data["runStatus"];
            this.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            this.workflowJobId = _data["workflowJobId"];
            this.isLegacy = _data["isLegacy"];
            this.failureSummary = _data["failureSummary"];
        }
    }

    static fromJS(data: any): ValidationRunSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationRunSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runId"] = this.runId;
        data["imageId"] = this.imageId;
        data["imageName"] = this.imageName;
        data["imageVersion"] = this.imageVersion;
        data["runNumber"] = this.runNumber;
        data["runStatus"] = this.runStatus;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["workflowJobId"] = this.workflowJobId;
        data["isLegacy"] = this.isLegacy;
        data["failureSummary"] = this.failureSummary;
        return data;
    }
}

export interface IValidationRunSummaryDto {
    runId: string;
    imageId?: string | undefined;
    imageName: string;
    imageVersion?: string | undefined;
    runNumber: number;
    runStatus?: string | undefined;
    submittedAt: Date;
    completedAt?: Date | undefined;
    workflowJobId?: string | undefined;
    isLegacy: boolean;
    failureSummary?: string | undefined;
}

export class ComponentNvrDto implements IComponentNvrDto {
    componentId?: string;
    name?: string;
    epoch?: string | undefined;
    version?: string | undefined;
    release?: string | undefined;
    nvr?: string;
    official?: boolean;
    result?: string | undefined;
    addedPendingPublish?: boolean;
    createDate?: Date;
    decision?: string | undefined;
    signedOffBy?: string | undefined;
    signedOffAt?: Date | undefined;
    promotedBy?: string | undefined;
    promotedAt?: Date | undefined;
    blockedBy?: string | undefined;
    blockedAt?: Date | undefined;
    blockReason?: string | undefined;
    inPreviewSince?: Date | undefined;
    slaDays?: number | undefined;

    constructor(data?: IComponentNvrDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.name = _data["name"];
            this.epoch = _data["epoch"];
            this.version = _data["version"];
            this.release = _data["release"];
            this.nvr = _data["nvr"];
            this.official = _data["official"];
            this.result = _data["result"];
            this.addedPendingPublish = _data["addedPendingPublish"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.decision = _data["decision"];
            this.signedOffBy = _data["signedOffBy"];
            this.signedOffAt = _data["signedOffAt"] ? new Date(_data["signedOffAt"].toString()) : undefined as any;
            this.promotedBy = _data["promotedBy"];
            this.promotedAt = _data["promotedAt"] ? new Date(_data["promotedAt"].toString()) : undefined as any;
            this.blockedBy = _data["blockedBy"];
            this.blockedAt = _data["blockedAt"] ? new Date(_data["blockedAt"].toString()) : undefined as any;
            this.blockReason = _data["blockReason"];
            this.inPreviewSince = _data["inPreviewSince"] ? new Date(_data["inPreviewSince"].toString()) : undefined as any;
            this.slaDays = _data["slaDays"];
        }
    }

    static fromJS(data: any): ComponentNvrDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentNvrDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["name"] = this.name;
        data["epoch"] = this.epoch;
        data["version"] = this.version;
        data["release"] = this.release;
        data["nvr"] = this.nvr;
        data["official"] = this.official;
        data["result"] = this.result;
        data["addedPendingPublish"] = this.addedPendingPublish;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["decision"] = this.decision;
        data["signedOffBy"] = this.signedOffBy;
        data["signedOffAt"] = this.signedOffAt ? this.signedOffAt.toISOString() : undefined as any;
        data["promotedBy"] = this.promotedBy;
        data["promotedAt"] = this.promotedAt ? this.promotedAt.toISOString() : undefined as any;
        data["blockedBy"] = this.blockedBy;
        data["blockedAt"] = this.blockedAt ? this.blockedAt.toISOString() : undefined as any;
        data["blockReason"] = this.blockReason;
        data["inPreviewSince"] = this.inPreviewSince ? this.inPreviewSince.toISOString() : undefined as any;
        data["slaDays"] = this.slaDays;
        return data;
    }
}

export interface IComponentNvrDto {
    componentId?: string;
    name?: string;
    epoch?: string | undefined;
    version?: string | undefined;
    release?: string | undefined;
    nvr?: string;
    official?: boolean;
    result?: string | undefined;
    addedPendingPublish?: boolean;
    createDate?: Date;
    decision?: string | undefined;
    signedOffBy?: string | undefined;
    signedOffAt?: Date | undefined;
    promotedBy?: string | undefined;
    promotedAt?: Date | undefined;
    blockedBy?: string | undefined;
    blockedAt?: Date | undefined;
    blockReason?: string | undefined;
    inPreviewSince?: Date | undefined;
    slaDays?: number | undefined;
}

export class ComponentBuildStatsDto implements IComponentBuildStatsDto {
    windowDays?: number;
    scope?: ArtifactScope;
    totalBuilds?: number;
    officialBuilds?: number | undefined;
    unofficialBuilds?: number | undefined;
    completedBuilds?: number;
    failedBuilds?: number;
    skippedBuilds?: number | undefined;
    buildsWithTiming?: number;
    averageBuildSeconds?: number | undefined;
    shortestBuildSeconds?: number | undefined;
    longestBuildSeconds?: number | undefined;

    constructor(data?: IComponentBuildStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.windowDays = _data["windowDays"];
            this.scope = _data["scope"];
            this.totalBuilds = _data["totalBuilds"];
            this.officialBuilds = _data["officialBuilds"];
            this.unofficialBuilds = _data["unofficialBuilds"];
            this.completedBuilds = _data["completedBuilds"];
            this.failedBuilds = _data["failedBuilds"];
            this.skippedBuilds = _data["skippedBuilds"];
            this.buildsWithTiming = _data["buildsWithTiming"];
            this.averageBuildSeconds = _data["averageBuildSeconds"];
            this.shortestBuildSeconds = _data["shortestBuildSeconds"];
            this.longestBuildSeconds = _data["longestBuildSeconds"];
        }
    }

    static fromJS(data: any): ComponentBuildStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentBuildStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["windowDays"] = this.windowDays;
        data["scope"] = this.scope;
        data["totalBuilds"] = this.totalBuilds;
        data["officialBuilds"] = this.officialBuilds;
        data["unofficialBuilds"] = this.unofficialBuilds;
        data["completedBuilds"] = this.completedBuilds;
        data["failedBuilds"] = this.failedBuilds;
        data["skippedBuilds"] = this.skippedBuilds;
        data["buildsWithTiming"] = this.buildsWithTiming;
        data["averageBuildSeconds"] = this.averageBuildSeconds;
        data["shortestBuildSeconds"] = this.shortestBuildSeconds;
        data["longestBuildSeconds"] = this.longestBuildSeconds;
        return data;
    }
}

export interface IComponentBuildStatsDto {
    windowDays?: number;
    scope?: ArtifactScope;
    totalBuilds?: number;
    officialBuilds?: number | undefined;
    unofficialBuilds?: number | undefined;
    completedBuilds?: number;
    failedBuilds?: number;
    skippedBuilds?: number | undefined;
    buildsWithTiming?: number;
    averageBuildSeconds?: number | undefined;
    shortestBuildSeconds?: number | undefined;
    longestBuildSeconds?: number | undefined;
}

export class ComponentPmcVersionsDto implements IComponentPmcVersionsDto {
    name?: string;
    preview?: ComponentPmcVersionDto | undefined;
    prod?: ComponentPmcVersionDto | undefined;

    constructor(data?: IComponentPmcVersionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.preview = _data["preview"] ? ComponentPmcVersionDto.fromJS(_data["preview"]) : undefined as any;
            this.prod = _data["prod"] ? ComponentPmcVersionDto.fromJS(_data["prod"]) : undefined as any;
        }
    }

    static fromJS(data: any): ComponentPmcVersionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentPmcVersionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["preview"] = this.preview ? this.preview.toJSON() : undefined as any;
        data["prod"] = this.prod ? this.prod.toJSON() : undefined as any;
        return data;
    }
}

export interface IComponentPmcVersionsDto {
    name?: string;
    preview?: ComponentPmcVersionDto | undefined;
    prod?: ComponentPmcVersionDto | undefined;
}

export class ComponentPmcVersionDto implements IComponentPmcVersionDto {
    componentId?: string;
    evr?: string;
    epoch?: string | undefined;
    version?: string | undefined;
    release?: string | undefined;
    publishedAt?: Date | undefined;

    constructor(data?: IComponentPmcVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.evr = _data["evr"];
            this.epoch = _data["epoch"];
            this.version = _data["version"];
            this.release = _data["release"];
            this.publishedAt = _data["publishedAt"] ? new Date(_data["publishedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ComponentPmcVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentPmcVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["evr"] = this.evr;
        data["epoch"] = this.epoch;
        data["version"] = this.version;
        data["release"] = this.release;
        data["publishedAt"] = this.publishedAt ? this.publishedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IComponentPmcVersionDto {
    componentId?: string;
    evr?: string;
    epoch?: string | undefined;
    version?: string | undefined;
    release?: string | undefined;
    publishedAt?: Date | undefined;
}

export class ComponentBuildDetailDto implements IComponentBuildDetailDto {
    componentId?: string;
    name?: string;
    epoch?: string | undefined;
    version?: string | undefined;
    release?: string | undefined;
    branch?: string | undefined;
    repo?: string | undefined;
    commit?: string | undefined;
    official?: boolean;
    result?: string | undefined;
    inPreview?: boolean;
    inProd?: boolean;
    createDate?: Date;
    requestedBy?: string | undefined;
    workflowJobId?: string;
    kojiTaskId?: number | undefined;
    kojiTarget?: string | undefined;
    isScratchBuild?: boolean;
    kojiTaskCreateTime?: Date | undefined;
    kojiTaskStartTime?: Date | undefined;
    kojiTaskEndTime?: Date | undefined;
    canRebuild?: boolean;
    architectureGroups?: ComponentArtifactGroupDto[];
    subtasks?: KojiSubtaskDto[];

    constructor(data?: IComponentBuildDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.name = _data["name"];
            this.epoch = _data["epoch"];
            this.version = _data["version"];
            this.release = _data["release"];
            this.branch = _data["branch"];
            this.repo = _data["repo"];
            this.commit = _data["commit"];
            this.official = _data["official"];
            this.result = _data["result"];
            this.inPreview = _data["inPreview"];
            this.inProd = _data["inProd"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.requestedBy = _data["requestedBy"];
            this.workflowJobId = _data["workflowJobId"];
            this.kojiTaskId = _data["kojiTaskId"];
            this.kojiTarget = _data["kojiTarget"];
            this.isScratchBuild = _data["isScratchBuild"];
            this.kojiTaskCreateTime = _data["kojiTaskCreateTime"] ? new Date(_data["kojiTaskCreateTime"].toString()) : undefined as any;
            this.kojiTaskStartTime = _data["kojiTaskStartTime"] ? new Date(_data["kojiTaskStartTime"].toString()) : undefined as any;
            this.kojiTaskEndTime = _data["kojiTaskEndTime"] ? new Date(_data["kojiTaskEndTime"].toString()) : undefined as any;
            this.canRebuild = _data["canRebuild"];
            if (Array.isArray(_data["architectureGroups"])) {
                this.architectureGroups = [] as any;
                for (let item of _data["architectureGroups"])
                    this.architectureGroups!.push(ComponentArtifactGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["subtasks"])) {
                this.subtasks = [] as any;
                for (let item of _data["subtasks"])
                    this.subtasks!.push(KojiSubtaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComponentBuildDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentBuildDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["name"] = this.name;
        data["epoch"] = this.epoch;
        data["version"] = this.version;
        data["release"] = this.release;
        data["branch"] = this.branch;
        data["repo"] = this.repo;
        data["commit"] = this.commit;
        data["official"] = this.official;
        data["result"] = this.result;
        data["inPreview"] = this.inPreview;
        data["inProd"] = this.inProd;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["requestedBy"] = this.requestedBy;
        data["workflowJobId"] = this.workflowJobId;
        data["kojiTaskId"] = this.kojiTaskId;
        data["kojiTarget"] = this.kojiTarget;
        data["isScratchBuild"] = this.isScratchBuild;
        data["kojiTaskCreateTime"] = this.kojiTaskCreateTime ? this.kojiTaskCreateTime.toISOString() : undefined as any;
        data["kojiTaskStartTime"] = this.kojiTaskStartTime ? this.kojiTaskStartTime.toISOString() : undefined as any;
        data["kojiTaskEndTime"] = this.kojiTaskEndTime ? this.kojiTaskEndTime.toISOString() : undefined as any;
        data["canRebuild"] = this.canRebuild;
        if (Array.isArray(this.architectureGroups)) {
            data["architectureGroups"] = [];
            for (let item of this.architectureGroups)
                data["architectureGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subtasks)) {
            data["subtasks"] = [];
            for (let item of this.subtasks)
                data["subtasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IComponentBuildDetailDto {
    componentId?: string;
    name?: string;
    epoch?: string | undefined;
    version?: string | undefined;
    release?: string | undefined;
    branch?: string | undefined;
    repo?: string | undefined;
    commit?: string | undefined;
    official?: boolean;
    result?: string | undefined;
    inPreview?: boolean;
    inProd?: boolean;
    createDate?: Date;
    requestedBy?: string | undefined;
    workflowJobId?: string;
    kojiTaskId?: number | undefined;
    kojiTarget?: string | undefined;
    isScratchBuild?: boolean;
    kojiTaskCreateTime?: Date | undefined;
    kojiTaskStartTime?: Date | undefined;
    kojiTaskEndTime?: Date | undefined;
    canRebuild?: boolean;
    architectureGroups?: ComponentArtifactGroupDto[];
    subtasks?: KojiSubtaskDto[];
}

export class ComponentArtifactGroupDto implements IComponentArtifactGroupDto {
    architecture?: string;
    artifacts?: ComponentArtifactDto[];

    constructor(data?: IComponentArtifactGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.architecture = _data["architecture"];
            if (Array.isArray(_data["artifacts"])) {
                this.artifacts = [] as any;
                for (let item of _data["artifacts"])
                    this.artifacts!.push(ComponentArtifactDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComponentArtifactGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentArtifactGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["architecture"] = this.architecture;
        if (Array.isArray(this.artifacts)) {
            data["artifacts"] = [];
            for (let item of this.artifacts)
                data["artifacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IComponentArtifactGroupDto {
    architecture?: string;
    artifacts?: ComponentArtifactDto[];
}

export class ComponentArtifactDto implements IComponentArtifactDto {
    packageName?: string;
    fileType?: string;
    result?: string | undefined;
    workUrl?: string | undefined;
    stableUrl?: string | undefined;
    signedUrl?: string | undefined;
    pmcPreviewUrl?: string | undefined;
    pmcProdUrl?: string | undefined;

    constructor(data?: IComponentArtifactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageName = _data["packageName"];
            this.fileType = _data["fileType"];
            this.result = _data["result"];
            this.workUrl = _data["workUrl"];
            this.stableUrl = _data["stableUrl"];
            this.signedUrl = _data["signedUrl"];
            this.pmcPreviewUrl = _data["pmcPreviewUrl"];
            this.pmcProdUrl = _data["pmcProdUrl"];
        }
    }

    static fromJS(data: any): ComponentArtifactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentArtifactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageName"] = this.packageName;
        data["fileType"] = this.fileType;
        data["result"] = this.result;
        data["workUrl"] = this.workUrl;
        data["stableUrl"] = this.stableUrl;
        data["signedUrl"] = this.signedUrl;
        data["pmcPreviewUrl"] = this.pmcPreviewUrl;
        data["pmcProdUrl"] = this.pmcProdUrl;
        return data;
    }
}

export interface IComponentArtifactDto {
    packageName?: string;
    fileType?: string;
    result?: string | undefined;
    workUrl?: string | undefined;
    stableUrl?: string | undefined;
    signedUrl?: string | undefined;
    pmcPreviewUrl?: string | undefined;
    pmcProdUrl?: string | undefined;
}

export class KojiSubtaskDto implements IKojiSubtaskDto {
    kojiId?: number;
    kojiTaskType?: string | undefined;

    constructor(data?: IKojiSubtaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kojiId = _data["kojiId"];
            this.kojiTaskType = _data["kojiTaskType"];
        }
    }

    static fromJS(data: any): KojiSubtaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new KojiSubtaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kojiId"] = this.kojiId;
        data["kojiTaskType"] = this.kojiTaskType;
        return data;
    }
}

export interface IKojiSubtaskDto {
    kojiId?: number;
    kojiTaskType?: string | undefined;
}

export class TriggerSigningResponse implements ITriggerSigningResponse {
    message!: string;
    componentId!: string;
    workflowJobId!: string;

    constructor(data?: ITriggerSigningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.componentId = _data["componentId"];
            this.workflowJobId = _data["workflowJobId"];
        }
    }

    static fromJS(data: any): TriggerSigningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerSigningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["componentId"] = this.componentId;
        data["workflowJobId"] = this.workflowJobId;
        return data;
    }
}

export interface ITriggerSigningResponse {
    message: string;
    componentId: string;
    workflowJobId: string;
}

export class RefreshSigningStatusResponse implements IRefreshSigningStatusResponse {
    message!: string;
    tag!: string;
    workflowJobId!: string;

    constructor(data?: IRefreshSigningStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.tag = _data["tag"];
            this.workflowJobId = _data["workflowJobId"];
        }
    }

    static fromJS(data: any): RefreshSigningStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshSigningStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["tag"] = this.tag;
        data["workflowJobId"] = this.workflowJobId;
        return data;
    }
}

export interface IRefreshSigningStatusResponse {
    message: string;
    tag: string;
    workflowJobId: string;
}

export class ListUnsignedInTagResponse implements IListUnsignedInTagResponse {
    message!: string;
    tag!: string;
    workflowJobId!: string;

    constructor(data?: IListUnsignedInTagResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.tag = _data["tag"];
            this.workflowJobId = _data["workflowJobId"];
        }
    }

    static fromJS(data: any): ListUnsignedInTagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListUnsignedInTagResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["tag"] = this.tag;
        data["workflowJobId"] = this.workflowJobId;
        return data;
    }
}

export interface IListUnsignedInTagResponse {
    message: string;
    tag: string;
    workflowJobId: string;
}

export class BackfillComponentRecordsResponse implements IBackfillComponentRecordsResponse {
    message!: string;
    workflowJobId?: string | undefined;
    totalMissingComponents?: number | undefined;

    constructor(data?: IBackfillComponentRecordsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.workflowJobId = _data["workflowJobId"];
            this.totalMissingComponents = _data["totalMissingComponents"];
        }
    }

    static fromJS(data: any): BackfillComponentRecordsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BackfillComponentRecordsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["workflowJobId"] = this.workflowJobId;
        data["totalMissingComponents"] = this.totalMissingComponents;
        return data;
    }
}

export interface IBackfillComponentRecordsResponse {
    message: string;
    workflowJobId?: string | undefined;
    totalMissingComponents?: number | undefined;
}

export class PromotableContainerImageDto implements IPromotableContainerImageDto {
    id?: string;
    azlImageName?: string;
    version?: number;
    createDate?: Date;
    tags?: string[];
    tagCount?: number;

    constructor(data?: IPromotableContainerImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.azlImageName = _data["azlImageName"];
            this.version = _data["version"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.tagCount = _data["tagCount"];
        }
    }

    static fromJS(data: any): PromotableContainerImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotableContainerImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["azlImageName"] = this.azlImageName;
        data["version"] = this.version;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["tagCount"] = this.tagCount;
        return data;
    }
}

export interface IPromotableContainerImageDto {
    id?: string;
    azlImageName?: string;
    version?: number;
    createDate?: Date;
    tags?: string[];
    tagCount?: number;
}

export class PagedResultOfImageSummaryDto implements IPagedResultOfImageSummaryDto {
    items?: ImageSummaryDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    hasMore?: boolean;

    constructor(data?: IPagedResultOfImageSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ImageSummaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PagedResultOfImageSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfImageSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPagedResultOfImageSummaryDto {
    items?: ImageSummaryDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    hasMore?: boolean;
}

export class ImageSummaryDto implements IImageSummaryDto {
    name?: string;
    latestBuildDate?: Date;
    buildCount?: number;
    latestResult?: string | undefined;
    latestImageFormat?: string | undefined;
    latestCompletedBuildDate?: Date | undefined;
    latestCompletedVersionNumber?: number | undefined;
    latestCompletedVersion?: string;

    constructor(data?: IImageSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.latestBuildDate = _data["latestBuildDate"] ? new Date(_data["latestBuildDate"].toString()) : undefined as any;
            this.buildCount = _data["buildCount"];
            this.latestResult = _data["latestResult"];
            this.latestImageFormat = _data["latestImageFormat"];
            this.latestCompletedBuildDate = _data["latestCompletedBuildDate"] ? new Date(_data["latestCompletedBuildDate"].toString()) : undefined as any;
            this.latestCompletedVersionNumber = _data["latestCompletedVersionNumber"];
            this.latestCompletedVersion = _data["latestCompletedVersion"];
        }
    }

    static fromJS(data: any): ImageSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["latestBuildDate"] = this.latestBuildDate ? this.latestBuildDate.toISOString() : undefined as any;
        data["buildCount"] = this.buildCount;
        data["latestResult"] = this.latestResult;
        data["latestImageFormat"] = this.latestImageFormat;
        data["latestCompletedBuildDate"] = this.latestCompletedBuildDate ? this.latestCompletedBuildDate.toISOString() : undefined as any;
        data["latestCompletedVersionNumber"] = this.latestCompletedVersionNumber;
        data["latestCompletedVersion"] = this.latestCompletedVersion;
        return data;
    }
}

export interface IImageSummaryDto {
    name?: string;
    latestBuildDate?: Date;
    buildCount?: number;
    latestResult?: string | undefined;
    latestImageFormat?: string | undefined;
    latestCompletedBuildDate?: Date | undefined;
    latestCompletedVersionNumber?: number | undefined;
    latestCompletedVersion?: string;
}

export class PagedResultOfImageBuildDto implements IPagedResultOfImageBuildDto {
    items?: ImageBuildDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    hasMore?: boolean;

    constructor(data?: IPagedResultOfImageBuildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ImageBuildDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PagedResultOfImageBuildDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfImageBuildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPagedResultOfImageBuildDto {
    items?: ImageBuildDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    hasMore?: boolean;
}

export class ImageBuildDto implements IImageBuildDto {
    imageId?: string;
    name?: string;
    imageFormat?: string;
    version?: number;
    calculatedVersion?: string;
    official?: boolean;
    result?: string | undefined;
    createDate?: Date;
    requestedBy?: string | undefined;
    workflowJobId?: string;
    kojiTaskId?: number | undefined;
    architectures?: string[];
    lifecycle?: ImageLifecycleDto | undefined;

    constructor(data?: IImageBuildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.name = _data["name"];
            this.imageFormat = _data["imageFormat"];
            this.version = _data["version"];
            this.calculatedVersion = _data["calculatedVersion"];
            this.official = _data["official"];
            this.result = _data["result"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.requestedBy = _data["requestedBy"];
            this.workflowJobId = _data["workflowJobId"];
            this.kojiTaskId = _data["kojiTaskId"];
            if (Array.isArray(_data["architectures"])) {
                this.architectures = [] as any;
                for (let item of _data["architectures"])
                    this.architectures!.push(item);
            }
            this.lifecycle = _data["lifecycle"] ? ImageLifecycleDto.fromJS(_data["lifecycle"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImageBuildDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageBuildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["name"] = this.name;
        data["imageFormat"] = this.imageFormat;
        data["version"] = this.version;
        data["calculatedVersion"] = this.calculatedVersion;
        data["official"] = this.official;
        data["result"] = this.result;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["requestedBy"] = this.requestedBy;
        data["workflowJobId"] = this.workflowJobId;
        data["kojiTaskId"] = this.kojiTaskId;
        if (Array.isArray(this.architectures)) {
            data["architectures"] = [];
            for (let item of this.architectures)
                data["architectures"].push(item);
        }
        data["lifecycle"] = this.lifecycle ? this.lifecycle.toJSON() : undefined as any;
        return data;
    }
}

export interface IImageBuildDto {
    imageId?: string;
    name?: string;
    imageFormat?: string;
    version?: number;
    calculatedVersion?: string;
    official?: boolean;
    result?: string | undefined;
    createDate?: Date;
    requestedBy?: string | undefined;
    workflowJobId?: string;
    kojiTaskId?: number | undefined;
    architectures?: string[];
    lifecycle?: ImageLifecycleDto | undefined;
}

export class ImagePublishSummaryDto implements IImagePublishSummaryDto {
    previewPublishWorkflowJobId?: string | undefined;
    previewPublishedAt?: Date | undefined;
    previewPublishState?: ImagePublishState;
    previewPublishDestinationsSucceeded?: number | undefined;
    previewPublishDestinationsTotal?: number | undefined;
    previewBlobstoreState?: ImagePublishState;
    previewRegistryState?: ImagePublishState;
    prodPublishWorkflowJobId?: string | undefined;
    prodPublishedAt?: Date | undefined;
    prodPublishState?: ImagePublishState;
    prodPublishDestinationsSucceeded?: number | undefined;
    prodPublishDestinationsTotal?: number | undefined;

    constructor(data?: IImagePublishSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previewPublishWorkflowJobId = _data["previewPublishWorkflowJobId"];
            this.previewPublishedAt = _data["previewPublishedAt"] ? new Date(_data["previewPublishedAt"].toString()) : undefined as any;
            this.previewPublishState = _data["previewPublishState"];
            this.previewPublishDestinationsSucceeded = _data["previewPublishDestinationsSucceeded"];
            this.previewPublishDestinationsTotal = _data["previewPublishDestinationsTotal"];
            this.previewBlobstoreState = _data["previewBlobstoreState"];
            this.previewRegistryState = _data["previewRegistryState"];
            this.prodPublishWorkflowJobId = _data["prodPublishWorkflowJobId"];
            this.prodPublishedAt = _data["prodPublishedAt"] ? new Date(_data["prodPublishedAt"].toString()) : undefined as any;
            this.prodPublishState = _data["prodPublishState"];
            this.prodPublishDestinationsSucceeded = _data["prodPublishDestinationsSucceeded"];
            this.prodPublishDestinationsTotal = _data["prodPublishDestinationsTotal"];
        }
    }

    static fromJS(data: any): ImagePublishSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImagePublishSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previewPublishWorkflowJobId"] = this.previewPublishWorkflowJobId;
        data["previewPublishedAt"] = this.previewPublishedAt ? this.previewPublishedAt.toISOString() : undefined as any;
        data["previewPublishState"] = this.previewPublishState;
        data["previewPublishDestinationsSucceeded"] = this.previewPublishDestinationsSucceeded;
        data["previewPublishDestinationsTotal"] = this.previewPublishDestinationsTotal;
        data["previewBlobstoreState"] = this.previewBlobstoreState;
        data["previewRegistryState"] = this.previewRegistryState;
        data["prodPublishWorkflowJobId"] = this.prodPublishWorkflowJobId;
        data["prodPublishedAt"] = this.prodPublishedAt ? this.prodPublishedAt.toISOString() : undefined as any;
        data["prodPublishState"] = this.prodPublishState;
        data["prodPublishDestinationsSucceeded"] = this.prodPublishDestinationsSucceeded;
        data["prodPublishDestinationsTotal"] = this.prodPublishDestinationsTotal;
        return data;
    }
}

export interface IImagePublishSummaryDto {
    previewPublishWorkflowJobId?: string | undefined;
    previewPublishedAt?: Date | undefined;
    previewPublishState?: ImagePublishState;
    previewPublishDestinationsSucceeded?: number | undefined;
    previewPublishDestinationsTotal?: number | undefined;
    previewBlobstoreState?: ImagePublishState;
    previewRegistryState?: ImagePublishState;
    prodPublishWorkflowJobId?: string | undefined;
    prodPublishedAt?: Date | undefined;
    prodPublishState?: ImagePublishState;
    prodPublishDestinationsSucceeded?: number | undefined;
    prodPublishDestinationsTotal?: number | undefined;
}

export class ImageLifecycleDto extends ImagePublishSummaryDto implements IImageLifecycleDto {
    validationWorkflowJobId?: string | undefined;
    validationWorkflowStatus?: JobStatus | undefined;
    validationRunId?: string | undefined;
    validationRunStatus?: string | undefined;
    validationSubmittedAt?: Date | undefined;
    validationCompletedAt?: Date | undefined;
    canValidate?: boolean;
    validationIneligibleReason?: string | undefined;

    constructor(data?: IImageLifecycleDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validationWorkflowJobId = _data["validationWorkflowJobId"];
            this.validationWorkflowStatus = _data["validationWorkflowStatus"];
            this.validationRunId = _data["validationRunId"];
            this.validationRunStatus = _data["validationRunStatus"];
            this.validationSubmittedAt = _data["validationSubmittedAt"] ? new Date(_data["validationSubmittedAt"].toString()) : undefined as any;
            this.validationCompletedAt = _data["validationCompletedAt"] ? new Date(_data["validationCompletedAt"].toString()) : undefined as any;
            this.canValidate = _data["canValidate"];
            this.validationIneligibleReason = _data["validationIneligibleReason"];
        }
    }

    static override fromJS(data: any): ImageLifecycleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageLifecycleDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationWorkflowJobId"] = this.validationWorkflowJobId;
        data["validationWorkflowStatus"] = this.validationWorkflowStatus;
        data["validationRunId"] = this.validationRunId;
        data["validationRunStatus"] = this.validationRunStatus;
        data["validationSubmittedAt"] = this.validationSubmittedAt ? this.validationSubmittedAt.toISOString() : undefined as any;
        data["validationCompletedAt"] = this.validationCompletedAt ? this.validationCompletedAt.toISOString() : undefined as any;
        data["canValidate"] = this.canValidate;
        data["validationIneligibleReason"] = this.validationIneligibleReason;
        super.toJSON(data);
        return data;
    }
}

export interface IImageLifecycleDto extends IImagePublishSummaryDto {
    validationWorkflowJobId?: string | undefined;
    validationWorkflowStatus?: JobStatus | undefined;
    validationRunId?: string | undefined;
    validationRunStatus?: string | undefined;
    validationSubmittedAt?: Date | undefined;
    validationCompletedAt?: Date | undefined;
    canValidate?: boolean;
    validationIneligibleReason?: string | undefined;
}

export enum JobStatus {
    Queued = "Queued",
    Pending = "Pending",
    Running = "Running",
    Completed = "Completed",
    Failed = "Failed",
    Cancelled = "Cancelled",
    CancelledByAdmin = "CancelledByAdmin",
    Unknown = "Unknown",
    TimedOut = "TimedOut",
}

export enum ImagePublishState {
    NotPublished = "NotPublished",
    InProgress = "InProgress",
    Published = "Published",
    Partial = "Partial",
    Failed = "Failed",
    NotApplicable = "NotApplicable",
}

export class ImageLatestPublishedDto implements IImageLatestPublishedDto {
    preview?: PublishedImageDto | undefined;
    prod?: PublishedImageDto | undefined;

    constructor(data?: IImageLatestPublishedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preview = _data["preview"] ? PublishedImageDto.fromJS(_data["preview"]) : undefined as any;
            this.prod = _data["prod"] ? PublishedImageDto.fromJS(_data["prod"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImageLatestPublishedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageLatestPublishedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preview"] = this.preview ? this.preview.toJSON() : undefined as any;
        data["prod"] = this.prod ? this.prod.toJSON() : undefined as any;
        return data;
    }
}

export interface IImageLatestPublishedDto {
    preview?: PublishedImageDto | undefined;
    prod?: PublishedImageDto | undefined;
}

export class PublishedImageDto implements IPublishedImageDto {
    imageId?: string;
    calculatedVersion?: string;
    publishedAt?: Date;
    workflowJobId?: string | undefined;

    constructor(data?: IPublishedImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.calculatedVersion = _data["calculatedVersion"];
            this.publishedAt = _data["publishedAt"] ? new Date(_data["publishedAt"].toString()) : undefined as any;
            this.workflowJobId = _data["workflowJobId"];
        }
    }

    static fromJS(data: any): PublishedImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublishedImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["calculatedVersion"] = this.calculatedVersion;
        data["publishedAt"] = this.publishedAt ? this.publishedAt.toISOString() : undefined as any;
        data["workflowJobId"] = this.workflowJobId;
        return data;
    }
}

export interface IPublishedImageDto {
    imageId?: string;
    calculatedVersion?: string;
    publishedAt?: Date;
    workflowJobId?: string | undefined;
}

export class ImageBuildStatsDto implements IImageBuildStatsDto {
    windowDays?: number;
    scope?: ArtifactScope;
    totalBuilds?: number;
    officialBuilds?: number | undefined;
    unofficialBuilds?: number | undefined;
    publishedBuilds?: number;
    buildsWithTiming?: number;
    averageBuildSeconds?: number | undefined;
    shortestBuildSeconds?: number | undefined;
    longestBuildSeconds?: number | undefined;

    constructor(data?: IImageBuildStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.windowDays = _data["windowDays"];
            this.scope = _data["scope"];
            this.totalBuilds = _data["totalBuilds"];
            this.officialBuilds = _data["officialBuilds"];
            this.unofficialBuilds = _data["unofficialBuilds"];
            this.publishedBuilds = _data["publishedBuilds"];
            this.buildsWithTiming = _data["buildsWithTiming"];
            this.averageBuildSeconds = _data["averageBuildSeconds"];
            this.shortestBuildSeconds = _data["shortestBuildSeconds"];
            this.longestBuildSeconds = _data["longestBuildSeconds"];
        }
    }

    static fromJS(data: any): ImageBuildStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageBuildStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["windowDays"] = this.windowDays;
        data["scope"] = this.scope;
        data["totalBuilds"] = this.totalBuilds;
        data["officialBuilds"] = this.officialBuilds;
        data["unofficialBuilds"] = this.unofficialBuilds;
        data["publishedBuilds"] = this.publishedBuilds;
        data["buildsWithTiming"] = this.buildsWithTiming;
        data["averageBuildSeconds"] = this.averageBuildSeconds;
        data["shortestBuildSeconds"] = this.shortestBuildSeconds;
        data["longestBuildSeconds"] = this.longestBuildSeconds;
        return data;
    }
}

export interface IImageBuildStatsDto {
    windowDays?: number;
    scope?: ArtifactScope;
    totalBuilds?: number;
    officialBuilds?: number | undefined;
    unofficialBuilds?: number | undefined;
    publishedBuilds?: number;
    buildsWithTiming?: number;
    averageBuildSeconds?: number | undefined;
    shortestBuildSeconds?: number | undefined;
    longestBuildSeconds?: number | undefined;
}

export class ImageBuildDetailDto extends ImagePublishSummaryDto implements IImageBuildDetailDto {
    imageId?: string;
    canValidate?: boolean;
    validationIneligibleReason?: string | undefined;
    registryPulls?: ImageRegistryPullDto[];
    name?: string;
    imageFormat?: string;
    container?: boolean;
    version?: number;
    calculatedVersion?: string;
    branch?: string | undefined;
    repo?: string | undefined;
    commit?: string | undefined;
    official?: boolean;
    result?: string | undefined;
    createDate?: Date;
    requestedBy?: string | undefined;
    workflowJobId?: string;
    kojiTaskId?: number | undefined;
    kojiTarget?: string | undefined;
    isScratchBuild?: boolean;
    kojiTaskCreateTime?: Date | undefined;
    kojiTaskStartTime?: Date | undefined;
    kojiTaskEndTime?: Date | undefined;
    canRebuild?: boolean;
    architectureGroups?: ImageArtifactGroupDto[];
    publishDestinations?: ArtifactUploadDestinationDto[];

    constructor(data?: IImageBuildDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageId = _data["imageId"];
            this.canValidate = _data["canValidate"];
            this.validationIneligibleReason = _data["validationIneligibleReason"];
            if (Array.isArray(_data["registryPulls"])) {
                this.registryPulls = [] as any;
                for (let item of _data["registryPulls"])
                    this.registryPulls!.push(ImageRegistryPullDto.fromJS(item));
            }
            this.name = _data["name"];
            this.imageFormat = _data["imageFormat"];
            this.container = _data["container"];
            this.version = _data["version"];
            this.calculatedVersion = _data["calculatedVersion"];
            this.branch = _data["branch"];
            this.repo = _data["repo"];
            this.commit = _data["commit"];
            this.official = _data["official"];
            this.result = _data["result"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
            this.requestedBy = _data["requestedBy"];
            this.workflowJobId = _data["workflowJobId"];
            this.kojiTaskId = _data["kojiTaskId"];
            this.kojiTarget = _data["kojiTarget"];
            this.isScratchBuild = _data["isScratchBuild"];
            this.kojiTaskCreateTime = _data["kojiTaskCreateTime"] ? new Date(_data["kojiTaskCreateTime"].toString()) : undefined as any;
            this.kojiTaskStartTime = _data["kojiTaskStartTime"] ? new Date(_data["kojiTaskStartTime"].toString()) : undefined as any;
            this.kojiTaskEndTime = _data["kojiTaskEndTime"] ? new Date(_data["kojiTaskEndTime"].toString()) : undefined as any;
            this.canRebuild = _data["canRebuild"];
            if (Array.isArray(_data["architectureGroups"])) {
                this.architectureGroups = [] as any;
                for (let item of _data["architectureGroups"])
                    this.architectureGroups!.push(ImageArtifactGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["publishDestinations"])) {
                this.publishDestinations = [] as any;
                for (let item of _data["publishDestinations"])
                    this.publishDestinations!.push(ArtifactUploadDestinationDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ImageBuildDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageBuildDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["canValidate"] = this.canValidate;
        data["validationIneligibleReason"] = this.validationIneligibleReason;
        if (Array.isArray(this.registryPulls)) {
            data["registryPulls"] = [];
            for (let item of this.registryPulls)
                data["registryPulls"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name;
        data["imageFormat"] = this.imageFormat;
        data["container"] = this.container;
        data["version"] = this.version;
        data["calculatedVersion"] = this.calculatedVersion;
        data["branch"] = this.branch;
        data["repo"] = this.repo;
        data["commit"] = this.commit;
        data["official"] = this.official;
        data["result"] = this.result;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        data["requestedBy"] = this.requestedBy;
        data["workflowJobId"] = this.workflowJobId;
        data["kojiTaskId"] = this.kojiTaskId;
        data["kojiTarget"] = this.kojiTarget;
        data["isScratchBuild"] = this.isScratchBuild;
        data["kojiTaskCreateTime"] = this.kojiTaskCreateTime ? this.kojiTaskCreateTime.toISOString() : undefined as any;
        data["kojiTaskStartTime"] = this.kojiTaskStartTime ? this.kojiTaskStartTime.toISOString() : undefined as any;
        data["kojiTaskEndTime"] = this.kojiTaskEndTime ? this.kojiTaskEndTime.toISOString() : undefined as any;
        data["canRebuild"] = this.canRebuild;
        if (Array.isArray(this.architectureGroups)) {
            data["architectureGroups"] = [];
            for (let item of this.architectureGroups)
                data["architectureGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.publishDestinations)) {
            data["publishDestinations"] = [];
            for (let item of this.publishDestinations)
                data["publishDestinations"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IImageBuildDetailDto extends IImagePublishSummaryDto {
    imageId?: string;
    canValidate?: boolean;
    validationIneligibleReason?: string | undefined;
    registryPulls?: ImageRegistryPullDto[];
    name?: string;
    imageFormat?: string;
    container?: boolean;
    version?: number;
    calculatedVersion?: string;
    branch?: string | undefined;
    repo?: string | undefined;
    commit?: string | undefined;
    official?: boolean;
    result?: string | undefined;
    createDate?: Date;
    requestedBy?: string | undefined;
    workflowJobId?: string;
    kojiTaskId?: number | undefined;
    kojiTarget?: string | undefined;
    isScratchBuild?: boolean;
    kojiTaskCreateTime?: Date | undefined;
    kojiTaskStartTime?: Date | undefined;
    kojiTaskEndTime?: Date | undefined;
    canRebuild?: boolean;
    architectureGroups?: ImageArtifactGroupDto[];
    publishDestinations?: ArtifactUploadDestinationDto[];
}

export class ImageRegistryPullDto implements IImageRegistryPullDto {
    registry?: ContainerRegistryKind;
    registryHost?: string;
    repository?: string;
    tag?: string;
    tagKind?: RegistryTagKind;
    architectures?: string[];
    alsoTagged?: string[];
    digest?: string | undefined;
    pullReference?: string;
    mcrPullReference?: string | undefined;

    constructor(data?: IImageRegistryPullDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registry = _data["registry"];
            this.registryHost = _data["registryHost"];
            this.repository = _data["repository"];
            this.tag = _data["tag"];
            this.tagKind = _data["tagKind"];
            if (Array.isArray(_data["architectures"])) {
                this.architectures = [] as any;
                for (let item of _data["architectures"])
                    this.architectures!.push(item);
            }
            if (Array.isArray(_data["alsoTagged"])) {
                this.alsoTagged = [] as any;
                for (let item of _data["alsoTagged"])
                    this.alsoTagged!.push(item);
            }
            this.digest = _data["digest"];
            this.pullReference = _data["pullReference"];
            this.mcrPullReference = _data["mcrPullReference"];
        }
    }

    static fromJS(data: any): ImageRegistryPullDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageRegistryPullDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registry"] = this.registry;
        data["registryHost"] = this.registryHost;
        data["repository"] = this.repository;
        data["tag"] = this.tag;
        data["tagKind"] = this.tagKind;
        if (Array.isArray(this.architectures)) {
            data["architectures"] = [];
            for (let item of this.architectures)
                data["architectures"].push(item);
        }
        if (Array.isArray(this.alsoTagged)) {
            data["alsoTagged"] = [];
            for (let item of this.alsoTagged)
                data["alsoTagged"].push(item);
        }
        data["digest"] = this.digest;
        data["pullReference"] = this.pullReference;
        data["mcrPullReference"] = this.mcrPullReference;
        return data;
    }
}

export interface IImageRegistryPullDto {
    registry?: ContainerRegistryKind;
    registryHost?: string;
    repository?: string;
    tag?: string;
    tagKind?: RegistryTagKind;
    architectures?: string[];
    alsoTagged?: string[];
    digest?: string | undefined;
    pullReference?: string;
    mcrPullReference?: string | undefined;
}

export enum ContainerRegistryKind {
    Release = "Release",
    Preview = "Preview",
    Other = "Other",
}

export enum RegistryTagKind {
    MultiArchVersioned = "MultiArchVersioned",
    MultiArchRolling = "MultiArchRolling",
    PerArch = "PerArch",
}

export class ImageArtifactGroupDto implements IImageArtifactGroupDto {
    architecture?: string;
    artifacts?: ImageArtifactDetailDto[];

    constructor(data?: IImageArtifactGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.architecture = _data["architecture"];
            if (Array.isArray(_data["artifacts"])) {
                this.artifacts = [] as any;
                for (let item of _data["artifacts"])
                    this.artifacts!.push(ImageArtifactDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImageArtifactGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageArtifactGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["architecture"] = this.architecture;
        if (Array.isArray(this.artifacts)) {
            data["artifacts"] = [];
            for (let item of this.artifacts)
                data["artifacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImageArtifactGroupDto {
    architecture?: string;
    artifacts?: ImageArtifactDetailDto[];
}

export class ImageArtifactDetailDto implements IImageArtifactDetailDto {
    kind?: string;
    workUrl?: string | undefined;
    stableUrl?: string | undefined;
    signedUrl?: string | undefined;
    blobstoreUrls?: string[];
    signingStatus?: ImageSigningStatus | undefined;

    constructor(data?: IImageArtifactDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.workUrl = _data["workUrl"];
            this.stableUrl = _data["stableUrl"];
            this.signedUrl = _data["signedUrl"];
            if (Array.isArray(_data["blobstoreUrls"])) {
                this.blobstoreUrls = [] as any;
                for (let item of _data["blobstoreUrls"])
                    this.blobstoreUrls!.push(item);
            }
            this.signingStatus = _data["signingStatus"];
        }
    }

    static fromJS(data: any): ImageArtifactDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageArtifactDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["workUrl"] = this.workUrl;
        data["stableUrl"] = this.stableUrl;
        data["signedUrl"] = this.signedUrl;
        if (Array.isArray(this.blobstoreUrls)) {
            data["blobstoreUrls"] = [];
            for (let item of this.blobstoreUrls)
                data["blobstoreUrls"].push(item);
        }
        data["signingStatus"] = this.signingStatus;
        return data;
    }
}

export interface IImageArtifactDetailDto {
    kind?: string;
    workUrl?: string | undefined;
    stableUrl?: string | undefined;
    signedUrl?: string | undefined;
    blobstoreUrls?: string[];
    signingStatus?: ImageSigningStatus | undefined;
}

export enum ImageSigningStatus {
    NotApplicable = "NotApplicable",
    Unsigned = "Unsigned",
    PartiallySigned = "PartiallySigned",
    Signed = "Signed",
}

export class ArtifactUploadDestinationDto implements IArtifactUploadDestinationDto {
    kind?: ArtifactDestinationKind;
    imageId?: string | undefined;
    imageName?: string | undefined;
    architecture?: string | undefined;
    destinationUri?: string | undefined;
    blobstore?: string | undefined;
    container?: string | undefined;
    blobPath?: string | undefined;
    acrName?: string | undefined;
    acrRepository?: string | undefined;
    acrTag?: string | undefined;
    offerId?: string | undefined;
    imageLabel?: string | undefined;
    partnerCenterJobId?: string | undefined;
    partnerCenterSubmissionId?: string | undefined;
    azureDevOpsRunId?: number | undefined;
    azureDevOpsRunUrl?: string | undefined;
    marketplaceStatus?: string | undefined;
    marketplaceErrors?: MarketplaceError[];
    updated?: Date | undefined;
    createDate?: Date;

    constructor(data?: IArtifactUploadDestinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.imageId = _data["imageId"];
            this.imageName = _data["imageName"];
            this.architecture = _data["architecture"];
            this.destinationUri = _data["destinationUri"];
            this.blobstore = _data["blobstore"];
            this.container = _data["container"];
            this.blobPath = _data["blobPath"];
            this.acrName = _data["acrName"];
            this.acrRepository = _data["acrRepository"];
            this.acrTag = _data["acrTag"];
            this.offerId = _data["offerId"];
            this.imageLabel = _data["imageLabel"];
            this.partnerCenterJobId = _data["partnerCenterJobId"];
            this.partnerCenterSubmissionId = _data["partnerCenterSubmissionId"];
            this.azureDevOpsRunId = _data["azureDevOpsRunId"];
            this.azureDevOpsRunUrl = _data["azureDevOpsRunUrl"];
            this.marketplaceStatus = _data["marketplaceStatus"];
            if (Array.isArray(_data["marketplaceErrors"])) {
                this.marketplaceErrors = [] as any;
                for (let item of _data["marketplaceErrors"])
                    this.marketplaceErrors!.push(MarketplaceError.fromJS(item));
            }
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : undefined as any;
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ArtifactUploadDestinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArtifactUploadDestinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["imageId"] = this.imageId;
        data["imageName"] = this.imageName;
        data["architecture"] = this.architecture;
        data["destinationUri"] = this.destinationUri;
        data["blobstore"] = this.blobstore;
        data["container"] = this.container;
        data["blobPath"] = this.blobPath;
        data["acrName"] = this.acrName;
        data["acrRepository"] = this.acrRepository;
        data["acrTag"] = this.acrTag;
        data["offerId"] = this.offerId;
        data["imageLabel"] = this.imageLabel;
        data["partnerCenterJobId"] = this.partnerCenterJobId;
        data["partnerCenterSubmissionId"] = this.partnerCenterSubmissionId;
        data["azureDevOpsRunId"] = this.azureDevOpsRunId;
        data["azureDevOpsRunUrl"] = this.azureDevOpsRunUrl;
        data["marketplaceStatus"] = this.marketplaceStatus;
        if (Array.isArray(this.marketplaceErrors)) {
            data["marketplaceErrors"] = [];
            for (let item of this.marketplaceErrors)
                data["marketplaceErrors"].push(item ? item.toJSON() : undefined as any);
        }
        data["updated"] = this.updated ? this.updated.toISOString() : undefined as any;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IArtifactUploadDestinationDto {
    kind?: ArtifactDestinationKind;
    imageId?: string | undefined;
    imageName?: string | undefined;
    architecture?: string | undefined;
    destinationUri?: string | undefined;
    blobstore?: string | undefined;
    container?: string | undefined;
    blobPath?: string | undefined;
    acrName?: string | undefined;
    acrRepository?: string | undefined;
    acrTag?: string | undefined;
    offerId?: string | undefined;
    imageLabel?: string | undefined;
    partnerCenterJobId?: string | undefined;
    partnerCenterSubmissionId?: string | undefined;
    azureDevOpsRunId?: number | undefined;
    azureDevOpsRunUrl?: string | undefined;
    marketplaceStatus?: string | undefined;
    marketplaceErrors?: MarketplaceError[];
    updated?: Date | undefined;
    createDate?: Date;
}

export enum ArtifactDestinationKind {
    Blobstore = "Blobstore",
    Acr = "Acr",
    Acg = "Acg",
    Marketplace = "Marketplace",
    Iso = "Iso",
}

export class MarketplaceError implements IMarketplaceError {
    code?: string;
    message?: string;

    constructor(data?: IMarketplaceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): MarketplaceError {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IMarketplaceError {
    code?: string;
    message?: string;
}

export class StagingImagePublishPreviewDto implements IStagingImagePublishPreviewDto {
    imageId?: string;
    imageName?: string;
    imageVersion?: string;
    official?: boolean;
    container?: string;
    folder?: string;
    previewRegistryTarget?: string | undefined;
    files?: StagingImagePublishFileDto[];

    constructor(data?: IStagingImagePublishPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.imageName = _data["imageName"];
            this.imageVersion = _data["imageVersion"];
            this.official = _data["official"];
            this.container = _data["container"];
            this.folder = _data["folder"];
            this.previewRegistryTarget = _data["previewRegistryTarget"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(StagingImagePublishFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StagingImagePublishPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new StagingImagePublishPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["imageName"] = this.imageName;
        data["imageVersion"] = this.imageVersion;
        data["official"] = this.official;
        data["container"] = this.container;
        data["folder"] = this.folder;
        data["previewRegistryTarget"] = this.previewRegistryTarget;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStagingImagePublishPreviewDto {
    imageId?: string;
    imageName?: string;
    imageVersion?: string;
    official?: boolean;
    container?: string;
    folder?: string;
    previewRegistryTarget?: string | undefined;
    files?: StagingImagePublishFileDto[];
}

export class StagingImagePublishFileDto implements IStagingImagePublishFileDto {
    architecture?: string;
    kind?: string;
    stagedFileName?: string;
    blobPath?: string;
    container?: string;

    constructor(data?: IStagingImagePublishFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.architecture = _data["architecture"];
            this.kind = _data["kind"];
            this.stagedFileName = _data["stagedFileName"];
            this.blobPath = _data["blobPath"];
            this.container = _data["container"];
        }
    }

    static fromJS(data: any): StagingImagePublishFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new StagingImagePublishFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["architecture"] = this.architecture;
        data["kind"] = this.kind;
        data["stagedFileName"] = this.stagedFileName;
        data["blobPath"] = this.blobPath;
        data["container"] = this.container;
        return data;
    }
}

export interface IStagingImagePublishFileDto {
    architecture?: string;
    kind?: string;
    stagedFileName?: string;
    blobPath?: string;
    container?: string;
}

export class OnePGalleryPublishOptionsDto implements IOnePGalleryPublishOptionsDto {
    enabled?: boolean;
    simulatePublish?: boolean;
    imageNames?: string[];

    constructor(data?: IOnePGalleryPublishOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.simulatePublish = _data["simulatePublish"];
            if (Array.isArray(_data["imageNames"])) {
                this.imageNames = [] as any;
                for (let item of _data["imageNames"])
                    this.imageNames!.push(item);
            }
        }
    }

    static fromJS(data: any): OnePGalleryPublishOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnePGalleryPublishOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["simulatePublish"] = this.simulatePublish;
        if (Array.isArray(this.imageNames)) {
            data["imageNames"] = [];
            for (let item of this.imageNames)
                data["imageNames"].push(item);
        }
        return data;
    }
}

export interface IOnePGalleryPublishOptionsDto {
    enabled?: boolean;
    simulatePublish?: boolean;
    imageNames?: string[];
}

export class OnePGalleryImageCheckDto implements IOnePGalleryImageCheckDto {
    imageId!: string;
    problem?: string | undefined;

    constructor(data?: IOnePGalleryImageCheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.problem = _data["problem"];
        }
    }

    static fromJS(data: any): OnePGalleryImageCheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnePGalleryImageCheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["problem"] = this.problem;
        return data;
    }
}

export interface IOnePGalleryImageCheckDto {
    imageId: string;
    problem?: string | undefined;
}

export class WorkflowJobArtifactSummaryDto implements IWorkflowJobArtifactSummaryDto {
    workflowJobId?: string;
    components?: LinkedComponentDto[];
    images?: LinkedImageDto[];
    tasks?: WorkflowTaskArtifactsDto[];

    constructor(data?: IWorkflowJobArtifactSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowJobId = _data["workflowJobId"];
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(LinkedComponentDto.fromJS(item));
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(LinkedImageDto.fromJS(item));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(WorkflowTaskArtifactsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkflowJobArtifactSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowJobArtifactSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowJobId"] = this.workflowJobId;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkflowJobArtifactSummaryDto {
    workflowJobId?: string;
    components?: LinkedComponentDto[];
    images?: LinkedImageDto[];
    tasks?: WorkflowTaskArtifactsDto[];
}

export class LinkedComponentDto implements ILinkedComponentDto {
    componentId?: string;
    name?: string;
    evr?: string;
    result?: string | undefined;
    official?: boolean;
    createDate?: Date;

    constructor(data?: ILinkedComponentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.name = _data["name"];
            this.evr = _data["evr"];
            this.result = _data["result"];
            this.official = _data["official"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LinkedComponentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedComponentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["name"] = this.name;
        data["evr"] = this.evr;
        data["result"] = this.result;
        data["official"] = this.official;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ILinkedComponentDto {
    componentId?: string;
    name?: string;
    evr?: string;
    result?: string | undefined;
    official?: boolean;
    createDate?: Date;
}

export class LinkedImageDto implements ILinkedImageDto {
    imageId?: string;
    name?: string;
    imageFormat?: string;
    version?: number;
    calculatedVersion?: string;
    result?: string | undefined;
    official?: boolean;
    createDate?: Date;

    constructor(data?: ILinkedImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.name = _data["name"];
            this.imageFormat = _data["imageFormat"];
            this.version = _data["version"];
            this.calculatedVersion = _data["calculatedVersion"];
            this.result = _data["result"];
            this.official = _data["official"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LinkedImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["name"] = this.name;
        data["imageFormat"] = this.imageFormat;
        data["version"] = this.version;
        data["calculatedVersion"] = this.calculatedVersion;
        data["result"] = this.result;
        data["official"] = this.official;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ILinkedImageDto {
    imageId?: string;
    name?: string;
    imageFormat?: string;
    version?: number;
    calculatedVersion?: string;
    result?: string | undefined;
    official?: boolean;
    createDate?: Date;
}

export class WorkflowTaskArtifactsDto implements IWorkflowTaskArtifactsDto {
    workflowJobTaskId?: string;
    taskName?: string;
    taskType?: TaskType | undefined;
    componentsBuilt?: LinkedComponentDto[];
    componentsUploaded?: LinkedComponentDto[];
    imagesBuilt?: LinkedImageDto[];
    imageUploadDestinations?: ArtifactUploadDestinationDto[];

    constructor(data?: IWorkflowTaskArtifactsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowJobTaskId = _data["workflowJobTaskId"];
            this.taskName = _data["taskName"];
            this.taskType = _data["taskType"];
            if (Array.isArray(_data["componentsBuilt"])) {
                this.componentsBuilt = [] as any;
                for (let item of _data["componentsBuilt"])
                    this.componentsBuilt!.push(LinkedComponentDto.fromJS(item));
            }
            if (Array.isArray(_data["componentsUploaded"])) {
                this.componentsUploaded = [] as any;
                for (let item of _data["componentsUploaded"])
                    this.componentsUploaded!.push(LinkedComponentDto.fromJS(item));
            }
            if (Array.isArray(_data["imagesBuilt"])) {
                this.imagesBuilt = [] as any;
                for (let item of _data["imagesBuilt"])
                    this.imagesBuilt!.push(LinkedImageDto.fromJS(item));
            }
            if (Array.isArray(_data["imageUploadDestinations"])) {
                this.imageUploadDestinations = [] as any;
                for (let item of _data["imageUploadDestinations"])
                    this.imageUploadDestinations!.push(ArtifactUploadDestinationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkflowTaskArtifactsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowTaskArtifactsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowJobTaskId"] = this.workflowJobTaskId;
        data["taskName"] = this.taskName;
        data["taskType"] = this.taskType;
        if (Array.isArray(this.componentsBuilt)) {
            data["componentsBuilt"] = [];
            for (let item of this.componentsBuilt)
                data["componentsBuilt"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.componentsUploaded)) {
            data["componentsUploaded"] = [];
            for (let item of this.componentsUploaded)
                data["componentsUploaded"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imagesBuilt)) {
            data["imagesBuilt"] = [];
            for (let item of this.imagesBuilt)
                data["imagesBuilt"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageUploadDestinations)) {
            data["imageUploadDestinations"] = [];
            for (let item of this.imageUploadDestinations)
                data["imageUploadDestinations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkflowTaskArtifactsDto {
    workflowJobTaskId?: string;
    taskName?: string;
    taskType?: TaskType | undefined;
    componentsBuilt?: LinkedComponentDto[];
    componentsUploaded?: LinkedComponentDto[];
    imagesBuilt?: LinkedImageDto[];
    imageUploadDestinations?: ArtifactUploadDestinationDto[];
}

export class BuildDashboardMetricsDto implements IBuildDashboardMetricsDto {
    startDate?: Date;
    endDate?: Date;
    packageOutcomes?: BuildOutcomeMetricsDto;
    imageOutcomes?: BuildOutcomeMetricsDto;
    packages?: PackageMetricsDto;
    images?: ImageMetricsDto;
    packagePipeline?: PipelineStageMetricDto[];
    imagePipeline?: PipelineStageMetricDto[];

    constructor(data?: IBuildDashboardMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.packageOutcomes = _data["packageOutcomes"] ? BuildOutcomeMetricsDto.fromJS(_data["packageOutcomes"]) : undefined as any;
            this.imageOutcomes = _data["imageOutcomes"] ? BuildOutcomeMetricsDto.fromJS(_data["imageOutcomes"]) : undefined as any;
            this.packages = _data["packages"] ? PackageMetricsDto.fromJS(_data["packages"]) : undefined as any;
            this.images = _data["images"] ? ImageMetricsDto.fromJS(_data["images"]) : undefined as any;
            if (Array.isArray(_data["packagePipeline"])) {
                this.packagePipeline = [] as any;
                for (let item of _data["packagePipeline"])
                    this.packagePipeline!.push(PipelineStageMetricDto.fromJS(item));
            }
            if (Array.isArray(_data["imagePipeline"])) {
                this.imagePipeline = [] as any;
                for (let item of _data["imagePipeline"])
                    this.imagePipeline!.push(PipelineStageMetricDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuildDashboardMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildDashboardMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["packageOutcomes"] = this.packageOutcomes ? this.packageOutcomes.toJSON() : undefined as any;
        data["imageOutcomes"] = this.imageOutcomes ? this.imageOutcomes.toJSON() : undefined as any;
        data["packages"] = this.packages ? this.packages.toJSON() : undefined as any;
        data["images"] = this.images ? this.images.toJSON() : undefined as any;
        if (Array.isArray(this.packagePipeline)) {
            data["packagePipeline"] = [];
            for (let item of this.packagePipeline)
                data["packagePipeline"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imagePipeline)) {
            data["imagePipeline"] = [];
            for (let item of this.imagePipeline)
                data["imagePipeline"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBuildDashboardMetricsDto {
    startDate?: Date;
    endDate?: Date;
    packageOutcomes?: BuildOutcomeMetricsDto;
    imageOutcomes?: BuildOutcomeMetricsDto;
    packages?: PackageMetricsDto;
    images?: ImageMetricsDto;
    packagePipeline?: PipelineStageMetricDto[];
    imagePipeline?: PipelineStageMetricDto[];
}

export class BuildOutcomeMetricsDto implements IBuildOutcomeMetricsDto {
    succeeded?: number;
    failed?: number;

    constructor(data?: IBuildOutcomeMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.failed = _data["failed"];
        }
    }

    static fromJS(data: any): BuildOutcomeMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildOutcomeMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["failed"] = this.failed;
        return data;
    }
}

export interface IBuildOutcomeMetricsDto {
    succeeded?: number;
    failed?: number;
}

export class PackageMetricsDto implements IPackageMetricsDto {
    averageBuildSeconds?: number | undefined;
    averagePreviewPublishSeconds?: number | undefined;
    averageProdPublishSeconds?: number | undefined;
    longestBuilds?: NamedDurationMetricDto[];
    selectedPackage?: PackageTrendMetricDto | undefined;

    constructor(data?: IPackageMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageBuildSeconds = _data["averageBuildSeconds"];
            this.averagePreviewPublishSeconds = _data["averagePreviewPublishSeconds"];
            this.averageProdPublishSeconds = _data["averageProdPublishSeconds"];
            if (Array.isArray(_data["longestBuilds"])) {
                this.longestBuilds = [] as any;
                for (let item of _data["longestBuilds"])
                    this.longestBuilds!.push(NamedDurationMetricDto.fromJS(item));
            }
            this.selectedPackage = _data["selectedPackage"] ? PackageTrendMetricDto.fromJS(_data["selectedPackage"]) : undefined as any;
        }
    }

    static fromJS(data: any): PackageMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageBuildSeconds"] = this.averageBuildSeconds;
        data["averagePreviewPublishSeconds"] = this.averagePreviewPublishSeconds;
        data["averageProdPublishSeconds"] = this.averageProdPublishSeconds;
        if (Array.isArray(this.longestBuilds)) {
            data["longestBuilds"] = [];
            for (let item of this.longestBuilds)
                data["longestBuilds"].push(item ? item.toJSON() : undefined as any);
        }
        data["selectedPackage"] = this.selectedPackage ? this.selectedPackage.toJSON() : undefined as any;
        return data;
    }
}

export interface IPackageMetricsDto {
    averageBuildSeconds?: number | undefined;
    averagePreviewPublishSeconds?: number | undefined;
    averageProdPublishSeconds?: number | undefined;
    longestBuilds?: NamedDurationMetricDto[];
    selectedPackage?: PackageTrendMetricDto | undefined;
}

export class NamedDurationMetricDto implements INamedDurationMetricDto {
    name?: string;
    averageSeconds?: number;
    sampleCount?: number;

    constructor(data?: INamedDurationMetricDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.averageSeconds = _data["averageSeconds"];
            this.sampleCount = _data["sampleCount"];
        }
    }

    static fromJS(data: any): NamedDurationMetricDto {
        data = typeof data === 'object' ? data : {};
        let result = new NamedDurationMetricDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["averageSeconds"] = this.averageSeconds;
        data["sampleCount"] = this.sampleCount;
        return data;
    }
}

export interface INamedDurationMetricDto {
    name?: string;
    averageSeconds?: number;
    sampleCount?: number;
}

export class PackageTrendMetricDto implements IPackageTrendMetricDto {
    packageName?: string;
    averageBuildSeconds?: number | undefined;
    trend?: DurationTrendPointDto[];

    constructor(data?: IPackageTrendMetricDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageName = _data["packageName"];
            this.averageBuildSeconds = _data["averageBuildSeconds"];
            if (Array.isArray(_data["trend"])) {
                this.trend = [] as any;
                for (let item of _data["trend"])
                    this.trend!.push(DurationTrendPointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageTrendMetricDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTrendMetricDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageName"] = this.packageName;
        data["averageBuildSeconds"] = this.averageBuildSeconds;
        if (Array.isArray(this.trend)) {
            data["trend"] = [];
            for (let item of this.trend)
                data["trend"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPackageTrendMetricDto {
    packageName?: string;
    averageBuildSeconds?: number | undefined;
    trend?: DurationTrendPointDto[];
}

export class DurationTrendPointDto implements IDurationTrendPointDto {
    date?: Date;
    averageSeconds?: number;
    sampleCount?: number;

    constructor(data?: IDurationTrendPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.averageSeconds = _data["averageSeconds"];
            this.sampleCount = _data["sampleCount"];
        }
    }

    static fromJS(data: any): DurationTrendPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new DurationTrendPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["averageSeconds"] = this.averageSeconds;
        data["sampleCount"] = this.sampleCount;
        return data;
    }
}

export interface IDurationTrendPointDto {
    date?: Date;
    averageSeconds?: number;
    sampleCount?: number;
}

export class ImageMetricsDto implements IImageMetricsDto {
    buildByType?: NamedDurationMetricDto[];
    validationByType?: NamedDurationMetricDto[];
    previewPublishByType?: NamedDurationMetricDto[];
    prodPublishByType?: NamedDurationMetricDto[];

    constructor(data?: IImageMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["buildByType"])) {
                this.buildByType = [] as any;
                for (let item of _data["buildByType"])
                    this.buildByType!.push(NamedDurationMetricDto.fromJS(item));
            }
            if (Array.isArray(_data["validationByType"])) {
                this.validationByType = [] as any;
                for (let item of _data["validationByType"])
                    this.validationByType!.push(NamedDurationMetricDto.fromJS(item));
            }
            if (Array.isArray(_data["previewPublishByType"])) {
                this.previewPublishByType = [] as any;
                for (let item of _data["previewPublishByType"])
                    this.previewPublishByType!.push(NamedDurationMetricDto.fromJS(item));
            }
            if (Array.isArray(_data["prodPublishByType"])) {
                this.prodPublishByType = [] as any;
                for (let item of _data["prodPublishByType"])
                    this.prodPublishByType!.push(NamedDurationMetricDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImageMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildByType)) {
            data["buildByType"] = [];
            for (let item of this.buildByType)
                data["buildByType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.validationByType)) {
            data["validationByType"] = [];
            for (let item of this.validationByType)
                data["validationByType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.previewPublishByType)) {
            data["previewPublishByType"] = [];
            for (let item of this.previewPublishByType)
                data["previewPublishByType"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.prodPublishByType)) {
            data["prodPublishByType"] = [];
            for (let item of this.prodPublishByType)
                data["prodPublishByType"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImageMetricsDto {
    buildByType?: NamedDurationMetricDto[];
    validationByType?: NamedDurationMetricDto[];
    previewPublishByType?: NamedDurationMetricDto[];
    prodPublishByType?: NamedDurationMetricDto[];
}

export class PipelineStageMetricDto implements IPipelineStageMetricDto {
    name?: string;
    averageSeconds?: number | undefined;
    available?: boolean;
    note?: string | undefined;

    constructor(data?: IPipelineStageMetricDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.averageSeconds = _data["averageSeconds"];
            this.available = _data["available"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PipelineStageMetricDto {
        data = typeof data === 'object' ? data : {};
        let result = new PipelineStageMetricDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["averageSeconds"] = this.averageSeconds;
        data["available"] = this.available;
        data["note"] = this.note;
        return data;
    }
}

export interface IPipelineStageMetricDto {
    name?: string;
    averageSeconds?: number | undefined;
    available?: boolean;
    note?: string | undefined;
}

export class BuildInfoDto implements IBuildInfoDto {
    controlTowerVersion!: string;
    controlTowerDeployedByPipeline?: string | undefined;
    controlTowerCommitSha?: string | undefined;
    controlTowerBuildTime?: string | undefined;
    environment!: string;
    runtime!: string;
    os!: string;
    machineName!: string;
    metadataAzldevVersion?: string | undefined;
    hangfireVersion?: string | undefined;
    efCoreVersion?: string | undefined;
    sqlServerVersion?: string | undefined;
    redisVersion?: string | undefined;
    uptime?: string | undefined;
    workingSetMemoryMb?: number | undefined;

    constructor(data?: IBuildInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controlTowerVersion = _data["controlTowerVersion"];
            this.controlTowerDeployedByPipeline = _data["controlTowerDeployedByPipeline"];
            this.controlTowerCommitSha = _data["controlTowerCommitSha"];
            this.controlTowerBuildTime = _data["controlTowerBuildTime"];
            this.environment = _data["environment"];
            this.runtime = _data["runtime"];
            this.os = _data["os"];
            this.machineName = _data["machineName"];
            this.metadataAzldevVersion = _data["metadataAzldevVersion"];
            this.hangfireVersion = _data["hangfireVersion"];
            this.efCoreVersion = _data["efCoreVersion"];
            this.sqlServerVersion = _data["sqlServerVersion"];
            this.redisVersion = _data["redisVersion"];
            this.uptime = _data["uptime"];
            this.workingSetMemoryMb = _data["workingSetMemoryMb"];
        }
    }

    static fromJS(data: any): BuildInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlTowerVersion"] = this.controlTowerVersion;
        data["controlTowerDeployedByPipeline"] = this.controlTowerDeployedByPipeline;
        data["controlTowerCommitSha"] = this.controlTowerCommitSha;
        data["controlTowerBuildTime"] = this.controlTowerBuildTime;
        data["environment"] = this.environment;
        data["runtime"] = this.runtime;
        data["os"] = this.os;
        data["machineName"] = this.machineName;
        data["metadataAzldevVersion"] = this.metadataAzldevVersion;
        data["hangfireVersion"] = this.hangfireVersion;
        data["efCoreVersion"] = this.efCoreVersion;
        data["sqlServerVersion"] = this.sqlServerVersion;
        data["redisVersion"] = this.redisVersion;
        data["uptime"] = this.uptime;
        data["workingSetMemoryMb"] = this.workingSetMemoryMb;
        return data;
    }
}

export interface IBuildInfoDto {
    controlTowerVersion: string;
    controlTowerDeployedByPipeline?: string | undefined;
    controlTowerCommitSha?: string | undefined;
    controlTowerBuildTime?: string | undefined;
    environment: string;
    runtime: string;
    os: string;
    machineName: string;
    metadataAzldevVersion?: string | undefined;
    hangfireVersion?: string | undefined;
    efCoreVersion?: string | undefined;
    sqlServerVersion?: string | undefined;
    redisVersion?: string | undefined;
    uptime?: string | undefined;
    workingSetMemoryMb?: number | undefined;
}

export class PublishSymbolsRequest implements IPublishSymbolsRequest {
    componentIds!: string[];

    constructor(data?: IPublishSymbolsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.componentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["componentIds"])) {
                this.componentIds = [] as any;
                for (let item of _data["componentIds"])
                    this.componentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PublishSymbolsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PublishSymbolsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.componentIds)) {
            data["componentIds"] = [];
            for (let item of this.componentIds)
                data["componentIds"].push(item);
        }
        return data;
    }
}

export interface IPublishSymbolsRequest {
    componentIds: string[];
}

export class OfficialPackageBuildRequest implements IOfficialPackageBuildRequest {
    environment!: string;
    packages!: string[];

    constructor(data?: IOfficialPackageBuildRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.packages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.environment = _data["environment"];
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(item);
            }
        }
    }

    static fromJS(data: any): OfficialPackageBuildRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialPackageBuildRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item);
        }
        return data;
    }
}

export interface IOfficialPackageBuildRequest {
    environment: string;
    packages: string[];
}

export class OfficialBuildImageRequest implements IOfficialBuildImageRequest {
    environment!: string;
    imageName!: string;
    architecture?: Architectures | undefined;

    constructor(data?: IOfficialBuildImageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.environment = _data["environment"];
            this.imageName = _data["imageName"];
            this.architecture = _data["architecture"];
        }
    }

    static fromJS(data: any): OfficialBuildImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialBuildImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment;
        data["imageName"] = this.imageName;
        data["architecture"] = this.architecture;
        return data;
    }
}

export interface IOfficialBuildImageRequest {
    environment: string;
    imageName: string;
    architecture?: Architectures | undefined;
}

export enum Architectures {
    Noarch = "noarch",
    X86_64 = "amd64",
    Aarch64 = "arm64",
}

export class OfficialPackagePmcPublishRequest implements IOfficialPackagePmcPublishRequest {
    componentIds!: string[];
    simulatePublish?: boolean;

    constructor(data?: IOfficialPackagePmcPublishRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.componentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["componentIds"])) {
                this.componentIds = [] as any;
                for (let item of _data["componentIds"])
                    this.componentIds!.push(item);
            }
            this.simulatePublish = _data["simulatePublish"];
        }
    }

    static fromJS(data: any): OfficialPackagePmcPublishRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialPackagePmcPublishRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.componentIds)) {
            data["componentIds"] = [];
            for (let item of this.componentIds)
                data["componentIds"].push(item);
        }
        data["simulatePublish"] = this.simulatePublish;
        return data;
    }
}

export interface IOfficialPackagePmcPublishRequest {
    componentIds: string[];
    simulatePublish?: boolean;
}

export class PreviewUploadAndPublishRequest implements IPreviewUploadAndPublishRequest {
    componentIds!: string[];

    constructor(data?: IPreviewUploadAndPublishRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.componentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["componentIds"])) {
                this.componentIds = [] as any;
                for (let item of _data["componentIds"])
                    this.componentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PreviewUploadAndPublishRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewUploadAndPublishRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.componentIds)) {
            data["componentIds"] = [];
            for (let item of this.componentIds)
                data["componentIds"].push(item);
        }
        return data;
    }
}

export interface IPreviewUploadAndPublishRequest {
    componentIds: string[];
}

export class PreviewToProdPmcTransferRequest implements IPreviewToProdPmcTransferRequest {
    componentIds!: string[];
    simulate?: boolean;
    reason?: string | undefined;

    constructor(data?: IPreviewToProdPmcTransferRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.componentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["componentIds"])) {
                this.componentIds = [] as any;
                for (let item of _data["componentIds"])
                    this.componentIds!.push(item);
            }
            this.simulate = _data["simulate"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): PreviewToProdPmcTransferRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewToProdPmcTransferRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.componentIds)) {
            data["componentIds"] = [];
            for (let item of this.componentIds)
                data["componentIds"].push(item);
        }
        data["simulate"] = this.simulate;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IPreviewToProdPmcTransferRequest {
    componentIds: string[];
    simulate?: boolean;
    reason?: string | undefined;
}

export class PreviewToProdPmcTransferByAgeResponse implements IPreviewToProdPmcTransferByAgeResponse {
    message!: string;
    minDaysInPreview!: number;
    componentCount!: number;
    workflowJobId?: string | undefined;

    constructor(data?: IPreviewToProdPmcTransferByAgeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.minDaysInPreview = _data["minDaysInPreview"];
            this.componentCount = _data["componentCount"];
            this.workflowJobId = _data["workflowJobId"];
        }
    }

    static fromJS(data: any): PreviewToProdPmcTransferByAgeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewToProdPmcTransferByAgeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["minDaysInPreview"] = this.minDaysInPreview;
        data["componentCount"] = this.componentCount;
        data["workflowJobId"] = this.workflowJobId;
        return data;
    }
}

export interface IPreviewToProdPmcTransferByAgeResponse {
    message: string;
    minDaysInPreview: number;
    componentCount: number;
    workflowJobId?: string | undefined;
}

export class PreviewToProdPmcTransferByAgeRequest implements IPreviewToProdPmcTransferByAgeRequest {
    minDaysInPreview!: number;
    simulate?: boolean;

    constructor(data?: IPreviewToProdPmcTransferByAgeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minDaysInPreview = _data["minDaysInPreview"];
            this.simulate = _data["simulate"];
        }
    }

    static fromJS(data: any): PreviewToProdPmcTransferByAgeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewToProdPmcTransferByAgeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minDaysInPreview"] = this.minDaysInPreview;
        data["simulate"] = this.simulate;
        return data;
    }
}

export interface IPreviewToProdPmcTransferByAgeRequest {
    minDaysInPreview: number;
    simulate?: boolean;
}

export class BuildImagesRequest implements IBuildImagesRequest {
    images?: BuildImageSelection[] | undefined;

    constructor(data?: IBuildImagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(BuildImageSelection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuildImagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BuildImagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBuildImagesRequest {
    images?: BuildImageSelection[] | undefined;
}

export class BuildImageSelection implements IBuildImageSelection {
    environment!: string;
    imageNames?: string[] | undefined;
    architecture?: Architectures | undefined;

    constructor(data?: IBuildImageSelection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.environment = _data["environment"];
            if (Array.isArray(_data["imageNames"])) {
                this.imageNames = [] as any;
                for (let item of _data["imageNames"])
                    this.imageNames!.push(item);
            }
            this.architecture = _data["architecture"];
        }
    }

    static fromJS(data: any): BuildImageSelection {
        data = typeof data === 'object' ? data : {};
        let result = new BuildImageSelection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment;
        if (Array.isArray(this.imageNames)) {
            data["imageNames"] = [];
            for (let item of this.imageNames)
                data["imageNames"].push(item);
        }
        data["architecture"] = this.architecture;
        return data;
    }
}

export interface IBuildImageSelection {
    environment: string;
    imageNames?: string[] | undefined;
    architecture?: Architectures | undefined;
}

export class PreviewPublishRequest implements IPreviewPublishRequest {
    imageIds!: string[];

    constructor(data?: IPreviewPublishRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.imageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imageIds"])) {
                this.imageIds = [] as any;
                for (let item of _data["imageIds"])
                    this.imageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PreviewPublishRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewPublishRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageIds)) {
            data["imageIds"] = [];
            for (let item of this.imageIds)
                data["imageIds"].push(item);
        }
        return data;
    }
}

export interface IPreviewPublishRequest {
    imageIds: string[];
}

export class PublishImagesToProdRequest implements IPublishImagesToProdRequest {
    imageIds!: string[];

    constructor(data?: IPublishImagesToProdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.imageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imageIds"])) {
                this.imageIds = [] as any;
                for (let item of _data["imageIds"])
                    this.imageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PublishImagesToProdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PublishImagesToProdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageIds)) {
            data["imageIds"] = [];
            for (let item of this.imageIds)
                data["imageIds"].push(item);
        }
        return data;
    }
}

export interface IPublishImagesToProdRequest {
    imageIds: string[];
}

export class PromotionActionResult implements IPromotionActionResult {
    componentId?: string;
    outcome?: string;
    decision?: string;
    message?: string | undefined;

    constructor(data?: IPromotionActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.outcome = _data["outcome"];
            this.decision = _data["decision"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PromotionActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["outcome"] = this.outcome;
        data["decision"] = this.decision;
        data["message"] = this.message;
        return data;
    }
}

export interface IPromotionActionResult {
    componentId?: string;
    outcome?: string;
    decision?: string;
    message?: string | undefined;
}

export class PromotionActionRequest implements IPromotionActionRequest {
    componentIds!: string[];
    reason?: string | undefined;

    constructor(data?: IPromotionActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.componentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["componentIds"])) {
                this.componentIds = [] as any;
                for (let item of _data["componentIds"])
                    this.componentIds!.push(item);
            }
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): PromotionActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.componentIds)) {
            data["componentIds"] = [];
            for (let item of this.componentIds)
                data["componentIds"].push(item);
        }
        data["reason"] = this.reason;
        return data;
    }
}

export interface IPromotionActionRequest {
    componentIds: string[];
    reason?: string | undefined;
}

export class PromotionEventDto implements IPromotionEventDto {
    sequence?: number;
    type?: string;
    requestedBy?: string;
    reason?: string | undefined;
    createDate?: Date;

    constructor(data?: IPromotionEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sequence = _data["sequence"];
            this.type = _data["type"];
            this.requestedBy = _data["requestedBy"];
            this.reason = _data["reason"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PromotionEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequence"] = this.sequence;
        data["type"] = this.type;
        data["requestedBy"] = this.requestedBy;
        data["reason"] = this.reason;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IPromotionEventDto {
    sequence?: number;
    type?: string;
    requestedBy?: string;
    reason?: string | undefined;
    createDate?: Date;
}

export class PublishScheduleDto implements IPublishScheduleDto {
    id?: string;
    label?: string;
    description?: string;
    cron?: string;
    enabled?: boolean;
    nextRunAt?: Date | undefined;

    constructor(data?: IPublishScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.description = _data["description"];
            this.cron = _data["cron"];
            this.enabled = _data["enabled"];
            this.nextRunAt = _data["nextRunAt"] ? new Date(_data["nextRunAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PublishScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublishScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["description"] = this.description;
        data["cron"] = this.cron;
        data["enabled"] = this.enabled;
        data["nextRunAt"] = this.nextRunAt ? this.nextRunAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IPublishScheduleDto {
    id?: string;
    label?: string;
    description?: string;
    cron?: string;
    enabled?: boolean;
    nextRunAt?: Date | undefined;
}

export class PagedResultOfReleaseDto implements IPagedResultOfReleaseDto {
    items?: ReleaseDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    hasMore?: boolean;

    constructor(data?: IPagedResultOfReleaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReleaseDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PagedResultOfReleaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfReleaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPagedResultOfReleaseDto {
    items?: ReleaseDto[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    hasMore?: boolean;
}

export class ReleaseDto implements IReleaseDto {
    id!: string;
    name!: string;
    environment?: string | undefined;
    sourceWorkflowJobId?: string | undefined;
    createdAt!: Date;
    requestedBy?: string | undefined;
    images!: ReleaseImageDto[];
    imageIds!: string[];
    imageTypes!: string[];
    validationWorkflowJobId?: string | undefined;
    validationWorkflowStatus?: JobStatus | undefined;

    constructor(data?: IReleaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.images = [];
            this.imageIds = [];
            this.imageTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.environment = _data["environment"];
            this.sourceWorkflowJobId = _data["sourceWorkflowJobId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.requestedBy = _data["requestedBy"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ReleaseImageDto.fromJS(item));
            }
            if (Array.isArray(_data["imageIds"])) {
                this.imageIds = [] as any;
                for (let item of _data["imageIds"])
                    this.imageIds!.push(item);
            }
            if (Array.isArray(_data["imageTypes"])) {
                this.imageTypes = [] as any;
                for (let item of _data["imageTypes"])
                    this.imageTypes!.push(item);
            }
            this.validationWorkflowJobId = _data["validationWorkflowJobId"];
            this.validationWorkflowStatus = _data["validationWorkflowStatus"];
        }
    }

    static fromJS(data: any): ReleaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["environment"] = this.environment;
        data["sourceWorkflowJobId"] = this.sourceWorkflowJobId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["requestedBy"] = this.requestedBy;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageIds)) {
            data["imageIds"] = [];
            for (let item of this.imageIds)
                data["imageIds"].push(item);
        }
        if (Array.isArray(this.imageTypes)) {
            data["imageTypes"] = [];
            for (let item of this.imageTypes)
                data["imageTypes"].push(item);
        }
        data["validationWorkflowJobId"] = this.validationWorkflowJobId;
        data["validationWorkflowStatus"] = this.validationWorkflowStatus;
        return data;
    }
}

export interface IReleaseDto {
    id: string;
    name: string;
    environment?: string | undefined;
    sourceWorkflowJobId?: string | undefined;
    createdAt: Date;
    requestedBy?: string | undefined;
    images: ReleaseImageDto[];
    imageIds: string[];
    imageTypes: string[];
    validationWorkflowJobId?: string | undefined;
    validationWorkflowStatus?: JobStatus | undefined;
}

export class ReleaseImageDto implements IReleaseImageDto {
    id!: string;
    name!: string;
    type!: string;
    container?: boolean;
    architectures?: string[];
    version?: string | undefined;
    buildResult?: string | undefined;
    buildWorkflowJobId?: string | undefined;
    builtAt?: Date | undefined;
    previewPublishWorkflowJobId?: string | undefined;
    previewPublishWorkflowStatus?: JobStatus | undefined;
    previewPublishedAt?: Date | undefined;
    prodPublishWorkflowJobId?: string | undefined;
    prodPublishWorkflowStatus?: JobStatus | undefined;
    prodPublishedAt?: Date | undefined;
    previewPublishState?: ImagePublishState;
    previewPublishDestinationsSucceeded?: number | undefined;
    previewPublishDestinationsTotal?: number | undefined;
    previewBlobstoreState?: ImagePublishState;
    previewRegistryState?: ImagePublishState;
    prodPublishState?: ImagePublishState;
    prodPublishDestinationsSucceeded?: number | undefined;
    prodPublishDestinationsTotal?: number | undefined;
    validationWorkflowJobId?: string | undefined;
    validationWorkflowStatus?: JobStatus | undefined;
    validationRunStatus?: string | undefined;
    validationRunId?: string | undefined;
    validationSubmittedAt?: Date | undefined;
    validationCompletedAt?: Date | undefined;
    canValidate?: boolean | undefined;
    validationIneligibleReason?: string | undefined;

    constructor(data?: IReleaseImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.container = _data["container"];
            if (Array.isArray(_data["architectures"])) {
                this.architectures = [] as any;
                for (let item of _data["architectures"])
                    this.architectures!.push(item);
            }
            this.version = _data["version"];
            this.buildResult = _data["buildResult"];
            this.buildWorkflowJobId = _data["buildWorkflowJobId"];
            this.builtAt = _data["builtAt"] ? new Date(_data["builtAt"].toString()) : undefined as any;
            this.previewPublishWorkflowJobId = _data["previewPublishWorkflowJobId"];
            this.previewPublishWorkflowStatus = _data["previewPublishWorkflowStatus"];
            this.previewPublishedAt = _data["previewPublishedAt"] ? new Date(_data["previewPublishedAt"].toString()) : undefined as any;
            this.prodPublishWorkflowJobId = _data["prodPublishWorkflowJobId"];
            this.prodPublishWorkflowStatus = _data["prodPublishWorkflowStatus"];
            this.prodPublishedAt = _data["prodPublishedAt"] ? new Date(_data["prodPublishedAt"].toString()) : undefined as any;
            this.previewPublishState = _data["previewPublishState"];
            this.previewPublishDestinationsSucceeded = _data["previewPublishDestinationsSucceeded"];
            this.previewPublishDestinationsTotal = _data["previewPublishDestinationsTotal"];
            this.previewBlobstoreState = _data["previewBlobstoreState"];
            this.previewRegistryState = _data["previewRegistryState"];
            this.prodPublishState = _data["prodPublishState"];
            this.prodPublishDestinationsSucceeded = _data["prodPublishDestinationsSucceeded"];
            this.prodPublishDestinationsTotal = _data["prodPublishDestinationsTotal"];
            this.validationWorkflowJobId = _data["validationWorkflowJobId"];
            this.validationWorkflowStatus = _data["validationWorkflowStatus"];
            this.validationRunStatus = _data["validationRunStatus"];
            this.validationRunId = _data["validationRunId"];
            this.validationSubmittedAt = _data["validationSubmittedAt"] ? new Date(_data["validationSubmittedAt"].toString()) : undefined as any;
            this.validationCompletedAt = _data["validationCompletedAt"] ? new Date(_data["validationCompletedAt"].toString()) : undefined as any;
            this.canValidate = _data["canValidate"];
            this.validationIneligibleReason = _data["validationIneligibleReason"];
        }
    }

    static fromJS(data: any): ReleaseImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["container"] = this.container;
        if (Array.isArray(this.architectures)) {
            data["architectures"] = [];
            for (let item of this.architectures)
                data["architectures"].push(item);
        }
        data["version"] = this.version;
        data["buildResult"] = this.buildResult;
        data["buildWorkflowJobId"] = this.buildWorkflowJobId;
        data["builtAt"] = this.builtAt ? this.builtAt.toISOString() : undefined as any;
        data["previewPublishWorkflowJobId"] = this.previewPublishWorkflowJobId;
        data["previewPublishWorkflowStatus"] = this.previewPublishWorkflowStatus;
        data["previewPublishedAt"] = this.previewPublishedAt ? this.previewPublishedAt.toISOString() : undefined as any;
        data["prodPublishWorkflowJobId"] = this.prodPublishWorkflowJobId;
        data["prodPublishWorkflowStatus"] = this.prodPublishWorkflowStatus;
        data["prodPublishedAt"] = this.prodPublishedAt ? this.prodPublishedAt.toISOString() : undefined as any;
        data["previewPublishState"] = this.previewPublishState;
        data["previewPublishDestinationsSucceeded"] = this.previewPublishDestinationsSucceeded;
        data["previewPublishDestinationsTotal"] = this.previewPublishDestinationsTotal;
        data["previewBlobstoreState"] = this.previewBlobstoreState;
        data["previewRegistryState"] = this.previewRegistryState;
        data["prodPublishState"] = this.prodPublishState;
        data["prodPublishDestinationsSucceeded"] = this.prodPublishDestinationsSucceeded;
        data["prodPublishDestinationsTotal"] = this.prodPublishDestinationsTotal;
        data["validationWorkflowJobId"] = this.validationWorkflowJobId;
        data["validationWorkflowStatus"] = this.validationWorkflowStatus;
        data["validationRunStatus"] = this.validationRunStatus;
        data["validationRunId"] = this.validationRunId;
        data["validationSubmittedAt"] = this.validationSubmittedAt ? this.validationSubmittedAt.toISOString() : undefined as any;
        data["validationCompletedAt"] = this.validationCompletedAt ? this.validationCompletedAt.toISOString() : undefined as any;
        data["canValidate"] = this.canValidate;
        data["validationIneligibleReason"] = this.validationIneligibleReason;
        return data;
    }
}

export interface IReleaseImageDto {
    id: string;
    name: string;
    type: string;
    container?: boolean;
    architectures?: string[];
    version?: string | undefined;
    buildResult?: string | undefined;
    buildWorkflowJobId?: string | undefined;
    builtAt?: Date | undefined;
    previewPublishWorkflowJobId?: string | undefined;
    previewPublishWorkflowStatus?: JobStatus | undefined;
    previewPublishedAt?: Date | undefined;
    prodPublishWorkflowJobId?: string | undefined;
    prodPublishWorkflowStatus?: JobStatus | undefined;
    prodPublishedAt?: Date | undefined;
    previewPublishState?: ImagePublishState;
    previewPublishDestinationsSucceeded?: number | undefined;
    previewPublishDestinationsTotal?: number | undefined;
    previewBlobstoreState?: ImagePublishState;
    previewRegistryState?: ImagePublishState;
    prodPublishState?: ImagePublishState;
    prodPublishDestinationsSucceeded?: number | undefined;
    prodPublishDestinationsTotal?: number | undefined;
    validationWorkflowJobId?: string | undefined;
    validationWorkflowStatus?: JobStatus | undefined;
    validationRunStatus?: string | undefined;
    validationRunId?: string | undefined;
    validationSubmittedAt?: Date | undefined;
    validationCompletedAt?: Date | undefined;
    canValidate?: boolean | undefined;
    validationIneligibleReason?: string | undefined;
}

export abstract class WorkflowJobKojiResultsBaseDto implements IWorkflowJobKojiResultsBaseDto {
    workflowJobId?: string;
    numKojiJobs?: number;
    numKojiJobsClosed?: number;
    numKojiJobsFailed?: number;
    numKojiJobsOpen?: number;
    numKojiJobsFree?: number;
    numKojiJobsAssigned?: number;

    constructor(data?: IWorkflowJobKojiResultsBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowJobId = _data["workflowJobId"];
            this.numKojiJobs = _data["numKojiJobs"];
            this.numKojiJobsClosed = _data["numKojiJobsClosed"];
            this.numKojiJobsFailed = _data["numKojiJobsFailed"];
            this.numKojiJobsOpen = _data["numKojiJobsOpen"];
            this.numKojiJobsFree = _data["numKojiJobsFree"];
            this.numKojiJobsAssigned = _data["numKojiJobsAssigned"];
        }
    }

    static fromJS(data: any): WorkflowJobKojiResultsBaseDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'WorkflowJobKojiResultsBaseDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowJobId"] = this.workflowJobId;
        data["numKojiJobs"] = this.numKojiJobs;
        data["numKojiJobsClosed"] = this.numKojiJobsClosed;
        data["numKojiJobsFailed"] = this.numKojiJobsFailed;
        data["numKojiJobsOpen"] = this.numKojiJobsOpen;
        data["numKojiJobsFree"] = this.numKojiJobsFree;
        data["numKojiJobsAssigned"] = this.numKojiJobsAssigned;
        return data;
    }
}

export interface IWorkflowJobKojiResultsBaseDto {
    workflowJobId?: string;
    numKojiJobs?: number;
    numKojiJobsClosed?: number;
    numKojiJobsFailed?: number;
    numKojiJobsOpen?: number;
    numKojiJobsFree?: number;
    numKojiJobsAssigned?: number;
}

export class WorkflowJobKojiResultsDto extends WorkflowJobKojiResultsBaseDto implements IWorkflowJobKojiResultsDto {
    buildTasks?: WorkflowBuildTaskKojiInfoDto[];
    imageTasks?: WorkflowImageTaskKojiInfoDto[];
    distRepoTasks?: WorkflowDistRepoTaskKojiInfoDto[];

    constructor(data?: IWorkflowJobKojiResultsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["buildTasks"])) {
                this.buildTasks = [] as any;
                for (let item of _data["buildTasks"])
                    this.buildTasks!.push(WorkflowBuildTaskKojiInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["imageTasks"])) {
                this.imageTasks = [] as any;
                for (let item of _data["imageTasks"])
                    this.imageTasks!.push(WorkflowImageTaskKojiInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["distRepoTasks"])) {
                this.distRepoTasks = [] as any;
                for (let item of _data["distRepoTasks"])
                    this.distRepoTasks!.push(WorkflowDistRepoTaskKojiInfoDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): WorkflowJobKojiResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowJobKojiResultsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildTasks)) {
            data["buildTasks"] = [];
            for (let item of this.buildTasks)
                data["buildTasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.imageTasks)) {
            data["imageTasks"] = [];
            for (let item of this.imageTasks)
                data["imageTasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.distRepoTasks)) {
            data["distRepoTasks"] = [];
            for (let item of this.distRepoTasks)
                data["distRepoTasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWorkflowJobKojiResultsDto extends IWorkflowJobKojiResultsBaseDto {
    buildTasks?: WorkflowBuildTaskKojiInfoDto[];
    imageTasks?: WorkflowImageTaskKojiInfoDto[];
    distRepoTasks?: WorkflowDistRepoTaskKojiInfoDto[];
}

export class WorkflowBuildTaskKojiInfoDto implements IWorkflowBuildTaskKojiInfoDto {
    workflowJobTaskId?: string;
    taskStatus?: string;
    kojiInfo?: KojiPackageTaskInfoDto | undefined;

    constructor(data?: IWorkflowBuildTaskKojiInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowJobTaskId = _data["workflowJobTaskId"];
            this.taskStatus = _data["taskStatus"];
            this.kojiInfo = _data["kojiInfo"] ? KojiPackageTaskInfoDto.fromJS(_data["kojiInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkflowBuildTaskKojiInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowBuildTaskKojiInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowJobTaskId"] = this.workflowJobTaskId;
        data["taskStatus"] = this.taskStatus;
        data["kojiInfo"] = this.kojiInfo ? this.kojiInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkflowBuildTaskKojiInfoDto {
    workflowJobTaskId?: string;
    taskStatus?: string;
    kojiInfo?: KojiPackageTaskInfoDto | undefined;
}

export class KojiPackageTaskInfoDto implements IKojiPackageTaskInfoDto {
    id?: string;
    workflowJobTaskId?: string;
    kojiTaskNumber?: number;
    componentName?: string;
    kojiTarget?: string;
    kojiTaskStatus?: string;
    requestedAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;

    constructor(data?: IKojiPackageTaskInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workflowJobTaskId = _data["workflowJobTaskId"];
            this.kojiTaskNumber = _data["kojiTaskNumber"];
            this.componentName = _data["componentName"];
            this.kojiTarget = _data["kojiTarget"];
            this.kojiTaskStatus = _data["kojiTaskStatus"];
            this.requestedAt = _data["requestedAt"] ? new Date(_data["requestedAt"].toString()) : undefined as any;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): KojiPackageTaskInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new KojiPackageTaskInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workflowJobTaskId"] = this.workflowJobTaskId;
        data["kojiTaskNumber"] = this.kojiTaskNumber;
        data["componentName"] = this.componentName;
        data["kojiTarget"] = this.kojiTarget;
        data["kojiTaskStatus"] = this.kojiTaskStatus;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toISOString() : undefined as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IKojiPackageTaskInfoDto {
    id?: string;
    workflowJobTaskId?: string;
    kojiTaskNumber?: number;
    componentName?: string;
    kojiTarget?: string;
    kojiTaskStatus?: string;
    requestedAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
}

export class WorkflowImageTaskKojiInfoDto implements IWorkflowImageTaskKojiInfoDto {
    workflowJobTaskId?: string;
    taskStatus?: string;
    kojiInfo?: KojiImageTaskInfoDto | undefined;

    constructor(data?: IWorkflowImageTaskKojiInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowJobTaskId = _data["workflowJobTaskId"];
            this.taskStatus = _data["taskStatus"];
            this.kojiInfo = _data["kojiInfo"] ? KojiImageTaskInfoDto.fromJS(_data["kojiInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkflowImageTaskKojiInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowImageTaskKojiInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowJobTaskId"] = this.workflowJobTaskId;
        data["taskStatus"] = this.taskStatus;
        data["kojiInfo"] = this.kojiInfo ? this.kojiInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkflowImageTaskKojiInfoDto {
    workflowJobTaskId?: string;
    taskStatus?: string;
    kojiInfo?: KojiImageTaskInfoDto | undefined;
}

export class KojiImageTaskInfoDto implements IKojiImageTaskInfoDto {
    id?: string;
    workflowJobTaskId?: string;
    kojiTaskNumber?: number;
    imageName?: string;
    kojiTarget?: string;
    kojiTaskStatus?: string;
    imageProfile?: string;
    requestedAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;

    constructor(data?: IKojiImageTaskInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workflowJobTaskId = _data["workflowJobTaskId"];
            this.kojiTaskNumber = _data["kojiTaskNumber"];
            this.imageName = _data["imageName"];
            this.kojiTarget = _data["kojiTarget"];
            this.kojiTaskStatus = _data["kojiTaskStatus"];
            this.imageProfile = _data["imageProfile"];
            this.requestedAt = _data["requestedAt"] ? new Date(_data["requestedAt"].toString()) : undefined as any;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): KojiImageTaskInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new KojiImageTaskInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workflowJobTaskId"] = this.workflowJobTaskId;
        data["kojiTaskNumber"] = this.kojiTaskNumber;
        data["imageName"] = this.imageName;
        data["kojiTarget"] = this.kojiTarget;
        data["kojiTaskStatus"] = this.kojiTaskStatus;
        data["imageProfile"] = this.imageProfile;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toISOString() : undefined as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IKojiImageTaskInfoDto {
    id?: string;
    workflowJobTaskId?: string;
    kojiTaskNumber?: number;
    imageName?: string;
    kojiTarget?: string;
    kojiTaskStatus?: string;
    imageProfile?: string;
    requestedAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
}

export class WorkflowDistRepoTaskKojiInfoDto implements IWorkflowDistRepoTaskKojiInfoDto {
    workflowJobTaskId?: string;
    taskStatus?: string;
    kojiInfo?: KojiDistRepoInfoDto | undefined;

    constructor(data?: IWorkflowDistRepoTaskKojiInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowJobTaskId = _data["workflowJobTaskId"];
            this.taskStatus = _data["taskStatus"];
            this.kojiInfo = _data["kojiInfo"] ? KojiDistRepoInfoDto.fromJS(_data["kojiInfo"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkflowDistRepoTaskKojiInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowDistRepoTaskKojiInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowJobTaskId"] = this.workflowJobTaskId;
        data["taskStatus"] = this.taskStatus;
        data["kojiInfo"] = this.kojiInfo ? this.kojiInfo.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkflowDistRepoTaskKojiInfoDto {
    workflowJobTaskId?: string;
    taskStatus?: string;
    kojiInfo?: KojiDistRepoInfoDto | undefined;
}

export class KojiDistRepoInfoDto implements IKojiDistRepoInfoDto {
    id?: string;
    workflowJobTaskId?: string;
    kojiTaskNumber?: number;
    tag?: string;
    repoId?: number | undefined;
    kojiTaskStatus?: string;
    requestedAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;

    constructor(data?: IKojiDistRepoInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workflowJobTaskId = _data["workflowJobTaskId"];
            this.kojiTaskNumber = _data["kojiTaskNumber"];
            this.tag = _data["tag"];
            this.repoId = _data["repoId"];
            this.kojiTaskStatus = _data["kojiTaskStatus"];
            this.requestedAt = _data["requestedAt"] ? new Date(_data["requestedAt"].toString()) : undefined as any;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): KojiDistRepoInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new KojiDistRepoInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workflowJobTaskId"] = this.workflowJobTaskId;
        data["kojiTaskNumber"] = this.kojiTaskNumber;
        data["tag"] = this.tag;
        data["repoId"] = this.repoId;
        data["kojiTaskStatus"] = this.kojiTaskStatus;
        data["requestedAt"] = this.requestedAt ? this.requestedAt.toISOString() : undefined as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IKojiDistRepoInfoDto {
    id?: string;
    workflowJobTaskId?: string;
    kojiTaskNumber?: number;
    tag?: string;
    repoId?: number | undefined;
    kojiTaskStatus?: string;
    requestedAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
}

export class WorkflowJobKojiPackageResultsDto extends WorkflowJobKojiResultsBaseDto implements IWorkflowJobKojiPackageResultsDto {
    buildTasks?: WorkflowBuildTaskKojiInfoDto[];

    constructor(data?: IWorkflowJobKojiPackageResultsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["buildTasks"])) {
                this.buildTasks = [] as any;
                for (let item of _data["buildTasks"])
                    this.buildTasks!.push(WorkflowBuildTaskKojiInfoDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): WorkflowJobKojiPackageResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowJobKojiPackageResultsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.buildTasks)) {
            data["buildTasks"] = [];
            for (let item of this.buildTasks)
                data["buildTasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWorkflowJobKojiPackageResultsDto extends IWorkflowJobKojiResultsBaseDto {
    buildTasks?: WorkflowBuildTaskKojiInfoDto[];
}

export class WorkflowJobKojiImageResultsDto extends WorkflowJobKojiResultsBaseDto implements IWorkflowJobKojiImageResultsDto {
    imageTasks?: WorkflowImageTaskKojiInfoDto[];

    constructor(data?: IWorkflowJobKojiImageResultsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["imageTasks"])) {
                this.imageTasks = [] as any;
                for (let item of _data["imageTasks"])
                    this.imageTasks!.push(WorkflowImageTaskKojiInfoDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): WorkflowJobKojiImageResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowJobKojiImageResultsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageTasks)) {
            data["imageTasks"] = [];
            for (let item of this.imageTasks)
                data["imageTasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWorkflowJobKojiImageResultsDto extends IWorkflowJobKojiResultsBaseDto {
    imageTasks?: WorkflowImageTaskKojiInfoDto[];
}

export class WorkflowJobKojiDistRepoResultsDto extends WorkflowJobKojiResultsBaseDto implements IWorkflowJobKojiDistRepoResultsDto {
    distRepoTasks?: WorkflowDistRepoTaskKojiInfoDto[];

    constructor(data?: IWorkflowJobKojiDistRepoResultsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["distRepoTasks"])) {
                this.distRepoTasks = [] as any;
                for (let item of _data["distRepoTasks"])
                    this.distRepoTasks!.push(WorkflowDistRepoTaskKojiInfoDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): WorkflowJobKojiDistRepoResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowJobKojiDistRepoResultsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.distRepoTasks)) {
            data["distRepoTasks"] = [];
            for (let item of this.distRepoTasks)
                data["distRepoTasks"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IWorkflowJobKojiDistRepoResultsDto extends IWorkflowJobKojiResultsBaseDto {
    distRepoTasks?: WorkflowDistRepoTaskKojiInfoDto[];
}

export class KojiJobStatisticsDto implements IKojiJobStatisticsDto {
    passFailRate?: PassFailRateDto;
    buildTimeMetrics?: BuildTimeMetricsDto;
    longestTask?: TaskExecutionTimeDto | undefined;

    constructor(data?: IKojiJobStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.passFailRate = _data["passFailRate"] ? PassFailRateDto.fromJS(_data["passFailRate"]) : undefined as any;
            this.buildTimeMetrics = _data["buildTimeMetrics"] ? BuildTimeMetricsDto.fromJS(_data["buildTimeMetrics"]) : undefined as any;
            this.longestTask = _data["longestTask"] ? TaskExecutionTimeDto.fromJS(_data["longestTask"]) : undefined as any;
        }
    }

    static fromJS(data: any): KojiJobStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new KojiJobStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passFailRate"] = this.passFailRate ? this.passFailRate.toJSON() : undefined as any;
        data["buildTimeMetrics"] = this.buildTimeMetrics ? this.buildTimeMetrics.toJSON() : undefined as any;
        data["longestTask"] = this.longestTask ? this.longestTask.toJSON() : undefined as any;
        return data;
    }
}

export interface IKojiJobStatisticsDto {
    passFailRate?: PassFailRateDto;
    buildTimeMetrics?: BuildTimeMetricsDto;
    longestTask?: TaskExecutionTimeDto | undefined;
}

export class PassFailRateDto implements IPassFailRateDto {
    totalTasks?: number;
    passedCount?: number;
    failedCount?: number;
    pendingCount?: number;
    passPercentage?: number | undefined;

    constructor(data?: IPassFailRateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTasks = _data["totalTasks"];
            this.passedCount = _data["passedCount"];
            this.failedCount = _data["failedCount"];
            this.pendingCount = _data["pendingCount"];
            this.passPercentage = _data["passPercentage"];
        }
    }

    static fromJS(data: any): PassFailRateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassFailRateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTasks"] = this.totalTasks;
        data["passedCount"] = this.passedCount;
        data["failedCount"] = this.failedCount;
        data["pendingCount"] = this.pendingCount;
        data["passPercentage"] = this.passPercentage;
        return data;
    }
}

export interface IPassFailRateDto {
    totalTasks?: number;
    passedCount?: number;
    failedCount?: number;
    pendingCount?: number;
    passPercentage?: number | undefined;
}

export class BuildTimeMetricsDto implements IBuildTimeMetricsDto {
    wallClockTimeSeconds?: number | undefined;
    totalExecutionSeconds?: number | undefined;
    taskExecutionTimes?: TaskExecutionTimeDto[];

    constructor(data?: IBuildTimeMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wallClockTimeSeconds = _data["wallClockTimeSeconds"];
            this.totalExecutionSeconds = _data["totalExecutionSeconds"];
            if (Array.isArray(_data["taskExecutionTimes"])) {
                this.taskExecutionTimes = [] as any;
                for (let item of _data["taskExecutionTimes"])
                    this.taskExecutionTimes!.push(TaskExecutionTimeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuildTimeMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildTimeMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wallClockTimeSeconds"] = this.wallClockTimeSeconds;
        data["totalExecutionSeconds"] = this.totalExecutionSeconds;
        if (Array.isArray(this.taskExecutionTimes)) {
            data["taskExecutionTimes"] = [];
            for (let item of this.taskExecutionTimes)
                data["taskExecutionTimes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBuildTimeMetricsDto {
    wallClockTimeSeconds?: number | undefined;
    totalExecutionSeconds?: number | undefined;
    taskExecutionTimes?: TaskExecutionTimeDto[];
}

export class TaskExecutionTimeDto implements ITaskExecutionTimeDto {
    kojiTaskNumber?: number;
    name?: string;
    taskType?: string;
    durationSeconds?: number | undefined;
    kojiTaskStatus?: string;

    constructor(data?: ITaskExecutionTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kojiTaskNumber = _data["kojiTaskNumber"];
            this.name = _data["name"];
            this.taskType = _data["taskType"];
            this.durationSeconds = _data["durationSeconds"];
            this.kojiTaskStatus = _data["kojiTaskStatus"];
        }
    }

    static fromJS(data: any): TaskExecutionTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskExecutionTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kojiTaskNumber"] = this.kojiTaskNumber;
        data["name"] = this.name;
        data["taskType"] = this.taskType;
        data["durationSeconds"] = this.durationSeconds;
        data["kojiTaskStatus"] = this.kojiTaskStatus;
        return data;
    }
}

export interface ITaskExecutionTimeDto {
    kojiTaskNumber?: number;
    name?: string;
    taskType?: string;
    durationSeconds?: number | undefined;
    kojiTaskStatus?: string;
}

export class KojiWorkflowCancellationResultDto implements IKojiWorkflowCancellationResultDto {
    workflowId?: string;
    totalTasksFound?: number;
    tasksCancelled?: number;
    tasksFailed?: number;
    tasksSkipped?: number;
    jobResults?: KojiJobCancellationSummary[];

    constructor(data?: IKojiWorkflowCancellationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowId = _data["workflowId"];
            this.totalTasksFound = _data["totalTasksFound"];
            this.tasksCancelled = _data["tasksCancelled"];
            this.tasksFailed = _data["tasksFailed"];
            this.tasksSkipped = _data["tasksSkipped"];
            if (Array.isArray(_data["jobResults"])) {
                this.jobResults = [] as any;
                for (let item of _data["jobResults"])
                    this.jobResults!.push(KojiJobCancellationSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KojiWorkflowCancellationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new KojiWorkflowCancellationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowId"] = this.workflowId;
        data["totalTasksFound"] = this.totalTasksFound;
        data["tasksCancelled"] = this.tasksCancelled;
        data["tasksFailed"] = this.tasksFailed;
        data["tasksSkipped"] = this.tasksSkipped;
        if (Array.isArray(this.jobResults)) {
            data["jobResults"] = [];
            for (let item of this.jobResults)
                data["jobResults"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IKojiWorkflowCancellationResultDto {
    workflowId?: string;
    totalTasksFound?: number;
    tasksCancelled?: number;
    tasksFailed?: number;
    tasksSkipped?: number;
    jobResults?: KojiJobCancellationSummary[];
}

export class KojiJobCancellationSummary implements IKojiJobCancellationSummary {
    workflowJobId?: string;
    tasksCancelled?: number;
    tasksFailed?: number;
    tasksSkipped?: number;

    constructor(data?: IKojiJobCancellationSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowJobId = _data["workflowJobId"];
            this.tasksCancelled = _data["tasksCancelled"];
            this.tasksFailed = _data["tasksFailed"];
            this.tasksSkipped = _data["tasksSkipped"];
        }
    }

    static fromJS(data: any): KojiJobCancellationSummary {
        data = typeof data === 'object' ? data : {};
        let result = new KojiJobCancellationSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowJobId"] = this.workflowJobId;
        data["tasksCancelled"] = this.tasksCancelled;
        data["tasksFailed"] = this.tasksFailed;
        data["tasksSkipped"] = this.tasksSkipped;
        return data;
    }
}

export interface IKojiJobCancellationSummary {
    workflowJobId?: string;
    tasksCancelled?: number;
    tasksFailed?: number;
    tasksSkipped?: number;
}

export class PrCheckRequest implements IPrCheckRequest {
    repoUri!: string;
    sourceBranch?: string | undefined;
    sourceCommitSha?: string | undefined;
    targetBranch?: string | undefined;
    targetCommitSha?: string | undefined;
    components?: string[] | undefined;

    constructor(data?: IPrCheckRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repoUri = _data["repoUri"];
            this.sourceBranch = _data["sourceBranch"];
            this.sourceCommitSha = _data["sourceCommitSha"];
            this.targetBranch = _data["targetBranch"];
            this.targetCommitSha = _data["targetCommitSha"];
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(item);
            }
        }
    }

    static fromJS(data: any): PrCheckRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrCheckRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repoUri"] = this.repoUri;
        data["sourceBranch"] = this.sourceBranch;
        data["sourceCommitSha"] = this.sourceCommitSha;
        data["targetBranch"] = this.targetBranch;
        data["targetCommitSha"] = this.targetCommitSha;
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item);
        }
        return data;
    }
}

export interface IPrCheckRequest {
    repoUri: string;
    sourceBranch?: string | undefined;
    sourceCommitSha?: string | undefined;
    targetBranch?: string | undefined;
    targetCommitSha?: string | undefined;
    components?: string[] | undefined;
}

export class BuildBranchRequest implements IBuildBranchRequest {
    repoUri!: string;
    branch!: string;
    commitSha?: string;
    productPath?: string;
    projectPath?: string;
    rpmsTarget?: string;
    imagesTarget?: string;
    containersTarget?: string;
    buildPackages?: boolean;
    buildImages?: boolean;
    buildContainers?: boolean;
    isScratchBuild?: boolean;

    constructor(data?: IBuildBranchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repoUri = _data["repoUri"];
            this.branch = _data["branch"];
            this.commitSha = _data["commitSha"];
            this.productPath = _data["productPath"];
            this.projectPath = _data["projectPath"];
            this.rpmsTarget = _data["rpmsTarget"];
            this.imagesTarget = _data["imagesTarget"];
            this.containersTarget = _data["containersTarget"];
            this.buildPackages = _data["buildPackages"];
            this.buildImages = _data["buildImages"];
            this.buildContainers = _data["buildContainers"];
            this.isScratchBuild = _data["isScratchBuild"];
        }
    }

    static fromJS(data: any): BuildBranchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BuildBranchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repoUri"] = this.repoUri;
        data["branch"] = this.branch;
        data["commitSha"] = this.commitSha;
        data["productPath"] = this.productPath;
        data["projectPath"] = this.projectPath;
        data["rpmsTarget"] = this.rpmsTarget;
        data["imagesTarget"] = this.imagesTarget;
        data["containersTarget"] = this.containersTarget;
        data["buildPackages"] = this.buildPackages;
        data["buildImages"] = this.buildImages;
        data["buildContainers"] = this.buildContainers;
        data["isScratchBuild"] = this.isScratchBuild;
        return data;
    }
}

export interface IBuildBranchRequest {
    repoUri: string;
    branch: string;
    commitSha?: string;
    productPath?: string;
    projectPath?: string;
    rpmsTarget?: string;
    imagesTarget?: string;
    containersTarget?: string;
    buildPackages?: boolean;
    buildImages?: boolean;
    buildContainers?: boolean;
    isScratchBuild?: boolean;
}

export class BuildImageRequest implements IBuildImageRequest {
    repoUri!: string;
    branch?: string | undefined;
    commitSha?: string | undefined;
    imageName!: string;
    imagePath!: string;
    kiwiProfile?: string | undefined;
    architecture?: Architectures | undefined;
    imageTarget!: string;
    imageRepoUri?: string | undefined;
    isContainer?: boolean | undefined;

    constructor(data?: IBuildImageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repoUri = _data["repoUri"];
            this.branch = _data["branch"];
            this.commitSha = _data["commitSha"];
            this.imageName = _data["imageName"];
            this.imagePath = _data["imagePath"];
            this.kiwiProfile = _data["kiwiProfile"];
            this.architecture = _data["architecture"];
            this.imageTarget = _data["imageTarget"];
            this.imageRepoUri = _data["imageRepoUri"];
            this.isContainer = _data["isContainer"];
        }
    }

    static fromJS(data: any): BuildImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BuildImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repoUri"] = this.repoUri;
        data["branch"] = this.branch;
        data["commitSha"] = this.commitSha;
        data["imageName"] = this.imageName;
        data["imagePath"] = this.imagePath;
        data["kiwiProfile"] = this.kiwiProfile;
        data["architecture"] = this.architecture;
        data["imageTarget"] = this.imageTarget;
        data["imageRepoUri"] = this.imageRepoUri;
        data["isContainer"] = this.isContainer;
        return data;
    }
}

export interface IBuildImageRequest {
    repoUri: string;
    branch?: string | undefined;
    commitSha?: string | undefined;
    imageName: string;
    imagePath: string;
    kiwiProfile?: string | undefined;
    architecture?: Architectures | undefined;
    imageTarget: string;
    imageRepoUri?: string | undefined;
    isContainer?: boolean | undefined;
}

export class CustomImageBuildRequest implements ICustomImageBuildRequest {
    repoUri!: string;
    branch?: string | undefined;
    commitSha?: string | undefined;
    imageName!: string;
    imagePath!: string;
    kiwiProfile?: string | undefined;
    architecture?: Architectures | undefined;
    imageTarget!: string;
    imageRepoUri?: string | undefined;
    isScratchBuild?: boolean;
    isContainer?: boolean | undefined;
    environmentName?: string | undefined;

    constructor(data?: ICustomImageBuildRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repoUri = _data["repoUri"];
            this.branch = _data["branch"];
            this.commitSha = _data["commitSha"];
            this.imageName = _data["imageName"];
            this.imagePath = _data["imagePath"];
            this.kiwiProfile = _data["kiwiProfile"];
            this.architecture = _data["architecture"];
            this.imageTarget = _data["imageTarget"];
            this.imageRepoUri = _data["imageRepoUri"];
            this.isScratchBuild = _data["isScratchBuild"];
            this.isContainer = _data["isContainer"];
            this.environmentName = _data["environmentName"];
        }
    }

    static fromJS(data: any): CustomImageBuildRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomImageBuildRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repoUri"] = this.repoUri;
        data["branch"] = this.branch;
        data["commitSha"] = this.commitSha;
        data["imageName"] = this.imageName;
        data["imagePath"] = this.imagePath;
        data["kiwiProfile"] = this.kiwiProfile;
        data["architecture"] = this.architecture;
        data["imageTarget"] = this.imageTarget;
        data["imageRepoUri"] = this.imageRepoUri;
        data["isScratchBuild"] = this.isScratchBuild;
        data["isContainer"] = this.isContainer;
        data["environmentName"] = this.environmentName;
        return data;
    }
}

export interface ICustomImageBuildRequest {
    repoUri: string;
    branch?: string | undefined;
    commitSha?: string | undefined;
    imageName: string;
    imagePath: string;
    kiwiProfile?: string | undefined;
    architecture?: Architectures | undefined;
    imageTarget: string;
    imageRepoUri?: string | undefined;
    isScratchBuild?: boolean;
    isContainer?: boolean | undefined;
    environmentName?: string | undefined;
}

export class PackageBuildRequest implements IPackageBuildRequest {
    environment!: string;
    branch?: string | undefined;
    commitSha?: string | undefined;
    packages!: string[];

    constructor(data?: IPackageBuildRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.packages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.environment = _data["environment"];
            this.branch = _data["branch"];
            this.commitSha = _data["commitSha"];
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(item);
            }
        }
    }

    static fromJS(data: any): PackageBuildRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PackageBuildRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment;
        data["branch"] = this.branch;
        data["commitSha"] = this.commitSha;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item);
        }
        return data;
    }
}

export interface IPackageBuildRequest {
    environment: string;
    branch?: string | undefined;
    commitSha?: string | undefined;
    packages: string[];
}

export class PublishComponentsRequest implements IPublishComponentsRequest {
    componentIds!: string[];

    constructor(data?: IPublishComponentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.componentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["componentIds"])) {
                this.componentIds = [] as any;
                for (let item of _data["componentIds"])
                    this.componentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PublishComponentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PublishComponentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.componentIds)) {
            data["componentIds"] = [];
            for (let item of this.componentIds)
                data["componentIds"].push(item);
        }
        return data;
    }
}

export interface IPublishComponentsRequest {
    componentIds: string[];
}

export class AllowlistPackagesRequest implements IAllowlistPackagesRequest {
    tag!: string;
    packages!: string[];

    constructor(data?: IAllowlistPackagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.packages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"];
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(item);
            }
        }
    }

    static fromJS(data: any): AllowlistPackagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AllowlistPackagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item);
        }
        return data;
    }
}

export interface IAllowlistPackagesRequest {
    tag: string;
    packages: string[];
}

export class RegenerateRepoRequest implements IRegenerateRepoRequest {
    tag!: string;

    constructor(data?: IRegenerateRepoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"];
        }
    }

    static fromJS(data: any): RegenerateRepoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegenerateRepoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        return data;
    }
}

export interface IRegenerateRepoRequest {
    tag: string;
}

export class PublishMarketplaceImageJobRequest implements IPublishMarketplaceImageJobRequest {
    imageId!: string;
    destination?: string | undefined;
    imageLabel?: string | undefined;
    plans?: MarketplacePlanPublishRequest[] | undefined;
    overrideExistingImages?: boolean;

    constructor(data?: IPublishMarketplaceImageJobRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.destination = _data["destination"];
            this.imageLabel = _data["imageLabel"];
            if (Array.isArray(_data["plans"])) {
                this.plans = [] as any;
                for (let item of _data["plans"])
                    this.plans!.push(MarketplacePlanPublishRequest.fromJS(item));
            }
            this.overrideExistingImages = _data["overrideExistingImages"];
        }
    }

    static fromJS(data: any): PublishMarketplaceImageJobRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PublishMarketplaceImageJobRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["destination"] = this.destination;
        data["imageLabel"] = this.imageLabel;
        if (Array.isArray(this.plans)) {
            data["plans"] = [];
            for (let item of this.plans)
                data["plans"].push(item ? item.toJSON() : undefined as any);
        }
        data["overrideExistingImages"] = this.overrideExistingImages;
        return data;
    }
}

export interface IPublishMarketplaceImageJobRequest {
    imageId: string;
    destination?: string | undefined;
    imageLabel?: string | undefined;
    plans?: MarketplacePlanPublishRequest[] | undefined;
    overrideExistingImages?: boolean;
}

export class MarketplacePlanPublishRequest implements IMarketplacePlanPublishRequest {
    planType!: MarketplacePlanType;
    imageTypes?: VmType[] | undefined;

    constructor(data?: IMarketplacePlanPublishRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planType = _data["planType"];
            if (Array.isArray(_data["imageTypes"])) {
                this.imageTypes = [] as any;
                for (let item of _data["imageTypes"])
                    this.imageTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): MarketplacePlanPublishRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplacePlanPublishRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planType"] = this.planType;
        if (Array.isArray(this.imageTypes)) {
            data["imageTypes"] = [];
            for (let item of this.imageTypes)
                data["imageTypes"].push(item);
        }
        return data;
    }
}

export interface IMarketplacePlanPublishRequest {
    planType: MarketplacePlanType;
    imageTypes?: VmType[] | undefined;
}

export enum MarketplacePlanType {
    Regular = "regular",
    Fips = "fips",
    Cvm = "cvm",
    KernelHwe = "kernel-hwe",
}

export enum VmType {
    X64Gen2 = "x64Gen2",
    Arm64Gen2 = "arm64Gen2",
}

export class RunImageFundamentalsRequest implements IRunImageFundamentalsRequest {
    imageWorkflowJobTaskId?: string | undefined;
    imageReference?: string | undefined;

    constructor(data?: IRunImageFundamentalsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageWorkflowJobTaskId = _data["imageWorkflowJobTaskId"];
            this.imageReference = _data["imageReference"];
        }
    }

    static fromJS(data: any): RunImageFundamentalsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RunImageFundamentalsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageWorkflowJobTaskId"] = this.imageWorkflowJobTaskId;
        data["imageReference"] = this.imageReference;
        return data;
    }
}

export interface IRunImageFundamentalsRequest {
    imageWorkflowJobTaskId?: string | undefined;
    imageReference?: string | undefined;
}

export class UploadStagingImageRequest implements IUploadStagingImageRequest {
    imageIds!: string[];

    constructor(data?: IUploadStagingImageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.imageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imageIds"])) {
                this.imageIds = [] as any;
                for (let item of _data["imageIds"])
                    this.imageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UploadStagingImageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UploadStagingImageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageIds)) {
            data["imageIds"] = [];
            for (let item of this.imageIds)
                data["imageIds"].push(item);
        }
        return data;
    }
}

export interface IUploadStagingImageRequest {
    imageIds: string[];
}

export class EsrpReleaseResumeRequest implements IEsrpReleaseResumeRequest {
    imageId!: string;
    architecture?: string | undefined;
    operationId?: string | undefined;

    constructor(data?: IEsrpReleaseResumeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"];
            this.architecture = _data["architecture"];
            this.operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): EsrpReleaseResumeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EsrpReleaseResumeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["architecture"] = this.architecture;
        data["operationId"] = this.operationId;
        return data;
    }
}

export interface IEsrpReleaseResumeRequest {
    imageId: string;
    architecture?: string | undefined;
    operationId?: string | undefined;
}

export class ContainerPublishRequest implements IContainerPublishRequest {
    imageIds!: string[];

    constructor(data?: IContainerPublishRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.imageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["imageIds"])) {
                this.imageIds = [] as any;
                for (let item of _data["imageIds"])
                    this.imageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ContainerPublishRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerPublishRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageIds)) {
            data["imageIds"] = [];
            for (let item of this.imageIds)
                data["imageIds"].push(item);
        }
        return data;
    }
}

export interface IContainerPublishRequest {
    imageIds: string[];
}

export abstract class WorkflowPlanRequest implements IWorkflowPlanRequest {
    noSave?: boolean;

    constructor(data?: IWorkflowPlanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noSave = _data["noSave"];
        }
    }

    static fromJS(data: any): WorkflowPlanRequest {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'WorkflowPlanRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noSave"] = this.noSave;
        return data;
    }
}

export interface IWorkflowPlanRequest {
    noSave?: boolean;
}

export class CustomImageValidationPlanRequest extends WorkflowPlanRequest implements ICustomImageValidationPlanRequest {
    imageIds!: string[];
    architectures?: string[];
    testSuiteDetails?: WorkflowTestSuiteInfo[];

    constructor(data?: ICustomImageValidationPlanRequest) {
        super(data);
        if (!data) {
            this.imageIds = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["imageIds"])) {
                this.imageIds = [] as any;
                for (let item of _data["imageIds"])
                    this.imageIds!.push(item);
            }
            if (Array.isArray(_data["architectures"])) {
                this.architectures = [] as any;
                for (let item of _data["architectures"])
                    this.architectures!.push(item);
            }
            if (Array.isArray(_data["testSuiteDetails"])) {
                this.testSuiteDetails = [] as any;
                for (let item of _data["testSuiteDetails"])
                    this.testSuiteDetails!.push(WorkflowTestSuiteInfo.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CustomImageValidationPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomImageValidationPlanRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageIds)) {
            data["imageIds"] = [];
            for (let item of this.imageIds)
                data["imageIds"].push(item);
        }
        if (Array.isArray(this.architectures)) {
            data["architectures"] = [];
            for (let item of this.architectures)
                data["architectures"].push(item);
        }
        if (Array.isArray(this.testSuiteDetails)) {
            data["testSuiteDetails"] = [];
            for (let item of this.testSuiteDetails)
                data["testSuiteDetails"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICustomImageValidationPlanRequest extends IWorkflowPlanRequest {
    imageIds: string[];
    architectures?: string[];
    testSuiteDetails?: WorkflowTestSuiteInfo[];
}

export class WorkflowTestSuiteInfo implements IWorkflowTestSuiteInfo {
    name!: string;
    type?: string | undefined;
    suiteDefinition?: any | undefined;

    constructor(data?: IWorkflowTestSuiteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.suiteDefinition = _data["suiteDefinition"];
        }
    }

    static fromJS(data: any): WorkflowTestSuiteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowTestSuiteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["suiteDefinition"] = this.suiteDefinition;
        return data;
    }
}

export interface IWorkflowTestSuiteInfo {
    name: string;
    type?: string | undefined;
    suiteDefinition?: any | undefined;
}

export class StressTestResult implements IStressTestResult {
    queueName?: string;
    jobsCreated?: number;
    jobIds?: string[];
    processingTimeSeconds?: number;

    constructor(data?: IStressTestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queueName = _data["queueName"];
            this.jobsCreated = _data["jobsCreated"];
            if (Array.isArray(_data["jobIds"])) {
                this.jobIds = [] as any;
                for (let item of _data["jobIds"])
                    this.jobIds!.push(item);
            }
            this.processingTimeSeconds = _data["processingTimeSeconds"];
        }
    }

    static fromJS(data: any): StressTestResult {
        data = typeof data === 'object' ? data : {};
        let result = new StressTestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queueName"] = this.queueName;
        data["jobsCreated"] = this.jobsCreated;
        if (Array.isArray(this.jobIds)) {
            data["jobIds"] = [];
            for (let item of this.jobIds)
                data["jobIds"].push(item);
        }
        data["processingTimeSeconds"] = this.processingTimeSeconds;
        return data;
    }
}

export interface IStressTestResult {
    queueName?: string;
    jobsCreated?: number;
    jobIds?: string[];
    processingTimeSeconds?: number;
}

export class QueueStats implements IQueueStats {
    queueName?: string;
    enqueuedCount?: number;
    processingCount?: number;
    succeededCount?: number;

    constructor(data?: IQueueStats) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queueName = _data["queueName"];
            this.enqueuedCount = _data["enqueuedCount"];
            this.processingCount = _data["processingCount"];
            this.succeededCount = _data["succeededCount"];
        }
    }

    static fromJS(data: any): QueueStats {
        data = typeof data === 'object' ? data : {};
        let result = new QueueStats();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queueName"] = this.queueName;
        data["enqueuedCount"] = this.enqueuedCount;
        data["processingCount"] = this.processingCount;
        data["succeededCount"] = this.succeededCount;
        return data;
    }
}

export interface IQueueStats {
    queueName?: string;
    enqueuedCount?: number;
    processingCount?: number;
    succeededCount?: number;
}

export class WorkflowPlanDto implements IWorkflowPlanDto {
    id?: string | undefined;
    planType?: PlanType;
    isProd?: boolean;
    isScratchBuild?: boolean;
    requestedBy?: string | undefined;
    tasks?: WorkflowTaskDto[];

    constructor(data?: IWorkflowPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.planType = _data["planType"];
            this.isProd = _data["isProd"];
            this.isScratchBuild = _data["isScratchBuild"];
            this.requestedBy = _data["requestedBy"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(WorkflowTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkflowPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planType"] = this.planType;
        data["isProd"] = this.isProd;
        data["isScratchBuild"] = this.isScratchBuild;
        data["requestedBy"] = this.requestedBy;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkflowPlanDto {
    id?: string | undefined;
    planType?: PlanType;
    isProd?: boolean;
    isScratchBuild?: boolean;
    requestedBy?: string | undefined;
    tasks?: WorkflowTaskDto[];
}

export enum PlanType {
    SpecificArtifact = "SpecificArtifact",
    IncrementalRepository = "IncrementalRepository",
    FullRepository = "FullRepository",
    Upload = "Upload",
    ImageBuild = "ImageBuild",
    Publish = "Publish",
    PackageOnly = "PackageOnly",
    ImageFundamentals = "ImageFundamentals",
    Target = "Target",
    Custom = "Custom",
    KojiStatusUpdate = "KojiStatusUpdate",
    Mirror = "Mirror",
    DistRepo = "DistRepo",
    NightlyImageBuild = "NightlyImageBuild",
    ContainerUpload = "ContainerUpload",
    PrCheck = "PrCheck",
    RemoveFromRepo = "RemoveFromRepo",
    StagingImageUpload = "StagingImageUpload",
    ContainerPublish = "ContainerPublish",
    NightlyPackageBuild = "NightlyPackageBuild",
    OfficialPackageBuild = "OfficialPackageBuild",
    OfficialImageBuild = "OfficialImageBuild",
    PreviewPublish = "PreviewPublish",
    PublishProdImages = "PublishProdImages",
    SignTrigger = "SignTrigger",
    ListUnsignedInTag = "ListUnsignedInTag",
    RefreshSigningStatus = "RefreshSigningStatus",
    BackfillComponentRecords = "BackfillComponentRecords",
    AllowlistPackages = "AllowlistPackages",
    RepoRegeneration = "RepoRegeneration",
    CustomValidation = "CustomValidation",
    ComponentSignedPmcPublish = "ComponentSignedPmcPublish",
    PreviewRepoPublish = "PreviewRepoPublish",
    PublishComponent = "PublishComponent",
    PreviewUploadAndPublish = "PreviewUploadAndPublish",
    SymbolPreparation = "SymbolPreparation",
    SymbolPublish = "SymbolPublish",
}

export class WorkflowTaskDto implements IWorkflowTaskDto {
    taskType?: TaskType;
    taskName?: string;
    taskNumber?: number;
    dependsOn?: number[];
    properties?: { [key: string]: any; };

    constructor(data?: IWorkflowTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskType = _data["taskType"];
            this.taskName = _data["taskName"];
            this.taskNumber = _data["taskNumber"];
            if (Array.isArray(_data["dependsOn"])) {
                this.dependsOn = [] as any;
                for (let item of _data["dependsOn"])
                    this.dependsOn!.push(item);
            }
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (this.properties as any)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): WorkflowTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskType"] = this.taskType;
        data["taskName"] = this.taskName;
        data["taskNumber"] = this.taskNumber;
        if (Array.isArray(this.dependsOn)) {
            data["dependsOn"] = [];
            for (let item of this.dependsOn)
                data["dependsOn"].push(item);
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (data["properties"] as any)[key] = (this.properties as any)[key];
            }
        }
        return data;
    }
}

export interface IWorkflowTaskDto {
    taskType?: TaskType;
    taskName?: string;
    taskNumber?: number;
    dependsOn?: number[];
    properties?: { [key: string]: any; };
}

export class FullBuildPlanRequest extends WorkflowPlanRequest implements IFullBuildPlanRequest {
    isScratchBuild?: boolean;
    isProd?: boolean;
    productRepoUri!: string;
    productBranch?: string;
    productCommit?: string;
    productPath?: string;
    projectRepoUri!: string;
    projectBranch?: string;
    projectCommit?: string;
    projectPath?: string;
    buildPackages?: boolean;
    buildImages?: boolean;
    buildContainers?: boolean;
    rpmsTarget?: string;
    imagesTarget?: string;
    containersTarget?: string;

    constructor(data?: IFullBuildPlanRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isScratchBuild = _data["isScratchBuild"];
            this.isProd = _data["isProd"];
            this.productRepoUri = _data["productRepoUri"];
            this.productBranch = _data["productBranch"];
            this.productCommit = _data["productCommit"];
            this.productPath = _data["productPath"];
            this.projectRepoUri = _data["projectRepoUri"];
            this.projectBranch = _data["projectBranch"];
            this.projectCommit = _data["projectCommit"];
            this.projectPath = _data["projectPath"];
            this.buildPackages = _data["buildPackages"];
            this.buildImages = _data["buildImages"];
            this.buildContainers = _data["buildContainers"];
            this.rpmsTarget = _data["rpmsTarget"];
            this.imagesTarget = _data["imagesTarget"];
            this.containersTarget = _data["containersTarget"];
        }
    }

    static override fromJS(data: any): FullBuildPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FullBuildPlanRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isScratchBuild"] = this.isScratchBuild;
        data["isProd"] = this.isProd;
        data["productRepoUri"] = this.productRepoUri;
        data["productBranch"] = this.productBranch;
        data["productCommit"] = this.productCommit;
        data["productPath"] = this.productPath;
        data["projectRepoUri"] = this.projectRepoUri;
        data["projectBranch"] = this.projectBranch;
        data["projectCommit"] = this.projectCommit;
        data["projectPath"] = this.projectPath;
        data["buildPackages"] = this.buildPackages;
        data["buildImages"] = this.buildImages;
        data["buildContainers"] = this.buildContainers;
        data["rpmsTarget"] = this.rpmsTarget;
        data["imagesTarget"] = this.imagesTarget;
        data["containersTarget"] = this.containersTarget;
        super.toJSON(data);
        return data;
    }
}

export interface IFullBuildPlanRequest extends IWorkflowPlanRequest {
    isScratchBuild?: boolean;
    isProd?: boolean;
    productRepoUri: string;
    productBranch?: string;
    productCommit?: string;
    productPath?: string;
    projectRepoUri: string;
    projectBranch?: string;
    projectCommit?: string;
    projectPath?: string;
    buildPackages?: boolean;
    buildImages?: boolean;
    buildContainers?: boolean;
    rpmsTarget?: string;
    imagesTarget?: string;
    containersTarget?: string;
}

export class ImageFundamentalsPlanRequest extends WorkflowPlanRequest implements IImageFundamentalsPlanRequest {
    imageWorkflowJobTaskId?: string | undefined;
    imageReference?: string | undefined;

    constructor(data?: IImageFundamentalsPlanRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageWorkflowJobTaskId = _data["imageWorkflowJobTaskId"];
            this.imageReference = _data["imageReference"];
        }
    }

    static override fromJS(data: any): ImageFundamentalsPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImageFundamentalsPlanRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageWorkflowJobTaskId"] = this.imageWorkflowJobTaskId;
        data["imageReference"] = this.imageReference;
        super.toJSON(data);
        return data;
    }
}

export interface IImageFundamentalsPlanRequest extends IWorkflowPlanRequest {
    imageWorkflowJobTaskId?: string | undefined;
    imageReference?: string | undefined;
}

export class TargetPlanRequest extends WorkflowPlanRequest implements ITargetPlanRequest {
    resolvedTargets!: ResolvedKojiTargetDto[];

    constructor(data?: ITargetPlanRequest) {
        super(data);
        if (!data) {
            this.resolvedTargets = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["resolvedTargets"])) {
                this.resolvedTargets = [] as any;
                for (let item of _data["resolvedTargets"])
                    this.resolvedTargets!.push(ResolvedKojiTargetDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TargetPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TargetPlanRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resolvedTargets)) {
            data["resolvedTargets"] = [];
            for (let item of this.resolvedTargets)
                data["resolvedTargets"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITargetPlanRequest extends IWorkflowPlanRequest {
    resolvedTargets: ResolvedKojiTargetDto[];
}

export class ResolvedKojiTargetDto implements IResolvedKojiTargetDto {
    name?: string;
    outputTag?: string | undefined;
    buildTag?: string | undefined;
    buildTagParent?: string | undefined;
    parentTag?: string | undefined;
    buildRoots?: BuildRootDto[] | undefined;
    mockOptions?: string[] | undefined;
    externalRepos?: ExternalRepoDto[] | undefined;
    suffix?: string | undefined;
    bootstrap?: boolean;
    kind?: string | undefined;

    constructor(data?: IResolvedKojiTargetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.outputTag = _data["outputTag"];
            this.buildTag = _data["buildTag"];
            this.buildTagParent = _data["buildTagParent"];
            this.parentTag = _data["parentTag"];
            if (Array.isArray(_data["buildRoots"])) {
                this.buildRoots = [] as any;
                for (let item of _data["buildRoots"])
                    this.buildRoots!.push(BuildRootDto.fromJS(item));
            }
            if (Array.isArray(_data["mockOptions"])) {
                this.mockOptions = [] as any;
                for (let item of _data["mockOptions"])
                    this.mockOptions!.push(item);
            }
            if (Array.isArray(_data["externalRepos"])) {
                this.externalRepos = [] as any;
                for (let item of _data["externalRepos"])
                    this.externalRepos!.push(ExternalRepoDto.fromJS(item));
            }
            this.suffix = _data["suffix"];
            this.bootstrap = _data["bootstrap"];
            this.kind = _data["kind"];
        }
    }

    static fromJS(data: any): ResolvedKojiTargetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResolvedKojiTargetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["outputTag"] = this.outputTag;
        data["buildTag"] = this.buildTag;
        data["buildTagParent"] = this.buildTagParent;
        data["parentTag"] = this.parentTag;
        if (Array.isArray(this.buildRoots)) {
            data["buildRoots"] = [];
            for (let item of this.buildRoots)
                data["buildRoots"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mockOptions)) {
            data["mockOptions"] = [];
            for (let item of this.mockOptions)
                data["mockOptions"].push(item);
        }
        if (Array.isArray(this.externalRepos)) {
            data["externalRepos"] = [];
            for (let item of this.externalRepos)
                data["externalRepos"].push(item ? item.toJSON() : undefined as any);
        }
        data["suffix"] = this.suffix;
        data["bootstrap"] = this.bootstrap;
        data["kind"] = this.kind;
        return data;
    }
}

export interface IResolvedKojiTargetDto {
    name?: string;
    outputTag?: string | undefined;
    buildTag?: string | undefined;
    buildTagParent?: string | undefined;
    parentTag?: string | undefined;
    buildRoots?: BuildRootDto[] | undefined;
    mockOptions?: string[] | undefined;
    externalRepos?: ExternalRepoDto[] | undefined;
    suffix?: string | undefined;
    bootstrap?: boolean;
    kind?: string | undefined;
}

export class BuildRootDto implements IBuildRootDto {
    type?: string;
    packages?: string[];

    constructor(data?: IBuildRootDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(item);
            }
        }
    }

    static fromJS(data: any): BuildRootDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildRootDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item);
        }
        return data;
    }
}

export interface IBuildRootDto {
    type?: string;
    packages?: string[];
}

export class ExternalRepoDto implements IExternalRepoDto {
    name?: string;
    url?: string;
    mergeMode?: string;

    constructor(data?: IExternalRepoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.mergeMode = _data["mergeMode"];
        }
    }

    static fromJS(data: any): ExternalRepoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalRepoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["mergeMode"] = this.mergeMode;
        return data;
    }
}

export interface IExternalRepoDto {
    name?: string;
    url?: string;
    mergeMode?: string;
}

export class AllTargetsPlanRequest extends WorkflowPlanRequest implements IAllTargetsPlanRequest {

    constructor(data?: IAllTargetsPlanRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AllTargetsPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AllTargetsPlanRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAllTargetsPlanRequest extends IWorkflowPlanRequest {
}

export class DistRepoPlanRequest extends WorkflowPlanRequest implements IDistRepoPlanRequest {
    tag!: string;
    latest?: boolean;
    withSrc?: boolean;
    allowMissingSignatures?: boolean;
    skipMissingSignatures?: boolean;
    splitDebuginfo?: boolean;
    signed?: boolean;

    constructor(data?: IDistRepoPlanRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tag = _data["tag"];
            this.latest = _data["latest"];
            this.withSrc = _data["withSrc"];
            this.allowMissingSignatures = _data["allowMissingSignatures"];
            this.skipMissingSignatures = _data["skipMissingSignatures"];
            this.splitDebuginfo = _data["splitDebuginfo"];
            this.signed = _data["signed"];
        }
    }

    static override fromJS(data: any): DistRepoPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DistRepoPlanRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["latest"] = this.latest;
        data["withSrc"] = this.withSrc;
        data["allowMissingSignatures"] = this.allowMissingSignatures;
        data["skipMissingSignatures"] = this.skipMissingSignatures;
        data["splitDebuginfo"] = this.splitDebuginfo;
        data["signed"] = this.signed;
        super.toJSON(data);
        return data;
    }
}

export interface IDistRepoPlanRequest extends IWorkflowPlanRequest {
    tag: string;
    latest?: boolean;
    withSrc?: boolean;
    allowMissingSignatures?: boolean;
    skipMissingSignatures?: boolean;
    splitDebuginfo?: boolean;
    signed?: boolean;
}

export class ContainerUploadPlanRequest extends WorkflowPlanRequest implements IContainerUploadPlanRequest {
    workflowJobId!: string;
    publishType?: ContainerPublishType;

    constructor(data?: IContainerUploadPlanRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.workflowJobId = _data["workflowJobId"];
            this.publishType = _data["publishType"];
        }
    }

    static override fromJS(data: any): ContainerUploadPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerUploadPlanRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowJobId"] = this.workflowJobId;
        data["publishType"] = this.publishType;
        super.toJSON(data);
        return data;
    }
}

export interface IContainerUploadPlanRequest extends IWorkflowPlanRequest {
    workflowJobId: string;
    publishType?: ContainerPublishType;
}

export enum ContainerPublishType {
    Official = "Official",
    Daily = "Daily",
    Test = "Test",
}

export class PublishImagesToProdPlanRequest extends WorkflowPlanRequest implements IPublishImagesToProdPlanRequest {
    imageIds!: string[];

    constructor(data?: IPublishImagesToProdPlanRequest) {
        super(data);
        if (!data) {
            this.imageIds = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["imageIds"])) {
                this.imageIds = [] as any;
                for (let item of _data["imageIds"])
                    this.imageIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): PublishImagesToProdPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PublishImagesToProdPlanRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.imageIds)) {
            data["imageIds"] = [];
            for (let item of this.imageIds)
                data["imageIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPublishImagesToProdPlanRequest extends IWorkflowPlanRequest {
    imageIds: string[];
}

export class ExecuteWorkflowResponse implements IExecuteWorkflowResponse {
    jobId?: string;

    constructor(data?: IExecuteWorkflowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
        }
    }

    static fromJS(data: any): ExecuteWorkflowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteWorkflowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        return data;
    }
}

export interface IExecuteWorkflowResponse {
    jobId?: string;
}

export class WorkflowJobDto implements IWorkflowJobDto {
    id?: string;
    workflowPlanId?: string;
    workflowPlan?: WorkflowPlanSummaryDto | undefined;
    status?: string;
    createdAt?: Date;
    updatedAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    requestedBy?: string | undefined;
    errorMessage?: string | undefined;
    buildTarget?: string | undefined;
    tasks?: WorkflowJobTaskStatusDto[];

    constructor(data?: IWorkflowJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workflowPlanId = _data["workflowPlanId"];
            this.workflowPlan = _data["workflowPlan"] ? WorkflowPlanSummaryDto.fromJS(_data["workflowPlan"]) : undefined as any;
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            this.requestedBy = _data["requestedBy"];
            this.errorMessage = _data["errorMessage"];
            this.buildTarget = _data["buildTarget"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(WorkflowJobTaskStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkflowJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workflowPlanId"] = this.workflowPlanId;
        data["workflowPlan"] = this.workflowPlan ? this.workflowPlan.toJSON() : undefined as any;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["requestedBy"] = this.requestedBy;
        data["errorMessage"] = this.errorMessage;
        data["buildTarget"] = this.buildTarget;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkflowJobDto {
    id?: string;
    workflowPlanId?: string;
    workflowPlan?: WorkflowPlanSummaryDto | undefined;
    status?: string;
    createdAt?: Date;
    updatedAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
    requestedBy?: string | undefined;
    errorMessage?: string | undefined;
    buildTarget?: string | undefined;
    tasks?: WorkflowJobTaskStatusDto[];
}

export class WorkflowPlanSummaryDto implements IWorkflowPlanSummaryDto {
    id?: string;
    planType?: PlanType;
    isProd?: boolean;
    isScratchBuild?: boolean;
    requestedBy?: string | undefined;
    createdAt?: Date;
    estimatedTotalExecutionTime?: string;
    numReposRequested?: number;
    batchSize?: number;
    tasks?: WorkflowTaskDto[] | undefined;

    constructor(data?: IWorkflowPlanSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.planType = _data["planType"];
            this.isProd = _data["isProd"];
            this.isScratchBuild = _data["isScratchBuild"];
            this.requestedBy = _data["requestedBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.estimatedTotalExecutionTime = _data["estimatedTotalExecutionTime"];
            this.numReposRequested = _data["numReposRequested"];
            this.batchSize = _data["batchSize"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(WorkflowTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkflowPlanSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowPlanSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planType"] = this.planType;
        data["isProd"] = this.isProd;
        data["isScratchBuild"] = this.isScratchBuild;
        data["requestedBy"] = this.requestedBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["estimatedTotalExecutionTime"] = this.estimatedTotalExecutionTime;
        data["numReposRequested"] = this.numReposRequested;
        data["batchSize"] = this.batchSize;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkflowPlanSummaryDto {
    id?: string;
    planType?: PlanType;
    isProd?: boolean;
    isScratchBuild?: boolean;
    requestedBy?: string | undefined;
    createdAt?: Date;
    estimatedTotalExecutionTime?: string;
    numReposRequested?: number;
    batchSize?: number;
    tasks?: WorkflowTaskDto[] | undefined;
}

export class WorkflowValidationRunsDto implements IWorkflowValidationRunsDto {
    workflowJobId?: string;
    runs?: WorkflowValidationRunDto[];

    constructor(data?: IWorkflowValidationRunsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowJobId = _data["workflowJobId"];
            if (Array.isArray(_data["runs"])) {
                this.runs = [] as any;
                for (let item of _data["runs"])
                    this.runs!.push(WorkflowValidationRunDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkflowValidationRunsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowValidationRunsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowJobId"] = this.workflowJobId;
        if (Array.isArray(this.runs)) {
            data["runs"] = [];
            for (let item of this.runs)
                data["runs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkflowValidationRunsDto {
    workflowJobId?: string;
    runs?: WorkflowValidationRunDto[];
}

export class WorkflowValidationRunDto implements IWorkflowValidationRunDto {
    runId?: string;
    imageName?: string;
    imageId?: string | undefined;
    imageVersion?: string | undefined;
    runStatus?: string | undefined;
    submittedAt?: Date;
    completedAt?: Date | undefined;
    failureSummary?: string | undefined;

    constructor(data?: IWorkflowValidationRunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runId = _data["runId"];
            this.imageName = _data["imageName"];
            this.imageId = _data["imageId"];
            this.imageVersion = _data["imageVersion"];
            this.runStatus = _data["runStatus"];
            this.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            this.failureSummary = _data["failureSummary"];
        }
    }

    static fromJS(data: any): WorkflowValidationRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowValidationRunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runId"] = this.runId;
        data["imageName"] = this.imageName;
        data["imageId"] = this.imageId;
        data["imageVersion"] = this.imageVersion;
        data["runStatus"] = this.runStatus;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["failureSummary"] = this.failureSummary;
        return data;
    }
}

export interface IWorkflowValidationRunDto {
    runId?: string;
    imageName?: string;
    imageId?: string | undefined;
    imageVersion?: string | undefined;
    runStatus?: string | undefined;
    submittedAt?: Date;
    completedAt?: Date | undefined;
    failureSummary?: string | undefined;
}

export class PaginatedLogsResponse implements IPaginatedLogsResponse {
    logs?: LogEntryDto[];
    totalCount?: number;
    skip?: number;
    take?: number;
    hasMore?: boolean;

    constructor(data?: IPaginatedLogsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(LogEntryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.skip = _data["skip"];
            this.take = _data["take"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): PaginatedLogsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedLogsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["skip"] = this.skip;
        data["take"] = this.take;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IPaginatedLogsResponse {
    logs?: LogEntryDto[];
    totalCount?: number;
    skip?: number;
    take?: number;
    hasMore?: boolean;
}

export class LogEntryDto implements ILogEntryDto {
    id?: string;
    businessJobId?: string;
    subJobId?: string | undefined;
    level?: JobLogLevel;
    message?: string;
    timestamp?: Date;
    source?: string;
    exception?: string | undefined;
    metadata?: string | undefined;

    constructor(data?: ILogEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessJobId = _data["businessJobId"];
            this.subJobId = _data["subJobId"];
            this.level = _data["level"];
            this.message = _data["message"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            this.source = _data["source"];
            this.exception = _data["exception"];
            this.metadata = _data["metadata"];
        }
    }

    static fromJS(data: any): LogEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessJobId"] = this.businessJobId;
        data["subJobId"] = this.subJobId;
        data["level"] = this.level;
        data["message"] = this.message;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        data["source"] = this.source;
        data["exception"] = this.exception;
        data["metadata"] = this.metadata;
        return data;
    }
}

export interface ILogEntryDto {
    id?: string;
    businessJobId?: string;
    subJobId?: string | undefined;
    level?: JobLogLevel;
    message?: string;
    timestamp?: Date;
    source?: string;
    exception?: string | undefined;
    metadata?: string | undefined;
}

export enum JobLogLevel {
    Debug = "Debug",
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
    Critical = "Critical",
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}